<template>
  <div>
    <div class="model" v-if="upload_loader">
      <span class="loader"></span>
      <span>Loading...........</span>
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
    <div class="main-container" v-if="ifAuditor">
      <p style="font-size: larger"><span style="font-weight: 500">{{ this.employeeName}}</span> ({{ this.e_code}})</p>
      <div style="display: flex">
        <tl-header type="h1">Income Tax Audit Approval</tl-header>
        <div class="margintop">
          <btn-grp class="form-button">
            <btn
              text="Download Documents"
              type="secondary"
              @click="downloadAllDocumentsUrl(DownloadAllDocuments)"
            />
          </btn-grp>
        </div>
      </div>
      <pop-up-window-lg
        v-if="form12BB_pop_up"
        @back="form12BB_pop_up = !form12BB_pop_up;toast=false"
        header="Upload Form 12BB"
      >
        <template v-slot:content>
         <pop-up-message
      v-if="showDeleteConfirmation"
      message="Please review the entire document carefully before submission. This will be final and cannot be altered after submission."
      :popupType="'Warning'"
      :popupHeaderMessage="'Confirm Submit'"
      @back="backFromPopup"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="showDeleteConfirmation = !showDeleteConfirmation">cancel</button>
          <button class="btn-popup" type="button" @click="it_proof_submission('final_submit')">Final Submit</button>
        </div>
      </template>
    </pop-up-message>
          <div class="BBmain">
            <div class="BBtop">
              <div style="padding-top:5px">
                  <div style="font-size:small;font-weight:400;padding:0px">
                    <p>I hereby declare that the information provided is true in all respects and
                       to the best of my knowledge and belief.  I am aware that the company is 
                       considering the above self attested copies of proofs/documents provided by 
                       me in utmost good faith and trust for the purpose of calculating my TDS.</p>
                       <p>Therefore, it would be binding on me to keep the said documents under 
                        my safe custody and produce a part or all the original documents to the Company 
                        or Income tax Authorities whenever the same is requisitioned for.  
                        I am also aware that I alone would be liable for any consequences/action as 
                        per the rules of the company if the above mentioned is found to be devoid of
                       the truth and/or in case of my failure 
                        to produce the requisitioned documents within the time/ period given to me. 
                    </p>
                  </div>
                
                   <div style="display: flex; gap: 30px; margin: 40px">
                  <input style="transform: scale(2.5)" type="checkbox" @click="(val)=>{
                  checkBoxFlag = !checkBoxFlag
                  }" />
                  <p style="font-size: medium">
                    I agree and confirm the above declaration
                  </p>
                   </div>
                </div>
              <div style="display:flex; gap:64rem">
                <p style="font-weight: 600; padding-top: 10px">
                  Digitally sign your form 12BB below
                </p>
                <btn :disabled="checkBoxFlag" style="font-size:medium" text="Download 12BB" type="secondary" @click="download12BBUrl(BB_12_url)" />
              </div>
              <div style="display: flex; flex-direction: column">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin: 40px;
                  "
                >
                  <div>
                    <p style="font-weight: 600; font-size: large">{{ promiseIP?promiseIP:"103.139.159.242"}}</p>
                    <p style="font-weight: 500; font-size: large">Ip Address</p>
                  </div>
                  <div>
                    <p style="font-weight: 600; font-size: large">
                      {{ form12BBDate }}
                    </p>
                    <p style="font-weight: 500; font-size: large">
                      Date & Time
                    </p>
                  </div>
                  <div>
                    <p style="font-weight: 600; font-size: large">{{ employeeName }}</p>
                    <p style="font-weight: 500; font-size: large">Name</p>
                  </div>
                  <div>
                    <btn
                      :disabled="checkBoxFlag"
                      style="font-size:medium"
                      text="Sign Digitally"
                      type="primary"
                      @click="()=>digitalySign()"
                    />
                  </div>
                </div>
              </div>
              <div></div>
            </div>
            <div class="BBcenter">OR</div>
            <div class="BBbottom">
              <p style="font-weight: 600; padding-top: 10px">
                Download your form 12BB sign it and upload the scanned copy
                below
              </p>
              <div class="upload">
                <p>Upload files here</p>
                <div class="upload-button">
                  <!-- <img src="@/assets/logout-copy-2_2@2x.png" alt /> -->
                  <label :disabled="checkBoxFlag" for="upload-photo">Browse</label>
                  <input type="file" name="photo" id="upload-photo" @change="upload12BBmanual(
                    $event.target.files,
                  )" />
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:bottom>
          <footer>
            <popup-bottom-container>
              <template slot="end">
                <btn-grp class="form-button">
                  <btn
                  v-show="incomeTaxProofSubmittedFlag"
                  :disabled="finalSubmitFlag"
                    text="Submit"
                    type="primary"
                    @click="showConfirmMessageFunction()"
                  />
                </btn-grp>
              </template>
            </popup-bottom-container>
          </footer>
        </template>
      </pop-up-window-lg>
      <div :disabled="incomeTaxProofSubmittedFlag" class="section-container">
        <!-- <div
          class="pl-0 cursor-point"
          @click="showPopupFamilyDetaila = !showPopupFamilyDetaila;toast=false"
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/home_rent_declartion.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">
                <Section>Family Details</Section>
              </div>
              <div class="sub-heading-details-sm">
                Please enter your family details
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div> -->
        <pop-up-window-lg
          v-if="showPopupFamilyDetaila"
          @back="showPopupFamilyDetaila = !showPopupFamilyDetaila;toast=false;getItSubmissionData();"
          header="Family Details"
        >
          <template v-slot:content>
            <toast-message
              :message="errmsg"
              type="error"
              :isToastEnable="toast"
              @close="(val) => (toast = val)"
            />
            <!-- <div style="display: flex; flex-direction: column">
              <p style="font-size: large; font-weight: 600">
                Number of children, Self and Family Details.
              </p>

              <div style="display: flex; gap: 10rem; padding: 30px">
                <div style="width: 50rem">
                  <label style="font-weight: 500" for="no_of_school_Childrens"
                    >No of Children*</label
                  >
                  <txt
                    type="number"
                    name="No_Children"
                    placeholder="enter no of children"
                    v-validate="'required'"
                    :classname="errors.has('No_Children')"
                    :errormsg="errors.first('No_Children')"
                    @change="
                      (val) => {
                        
                            employeeFamilyDetails[0].no_of_children = val;
                        childValidation()
                        
                        
                      }
                    "
                    v-model="employeeFamilyDetails[0].no_of_children"
                  />
                </div>
                <div style="width: 50rem">
                  <label style="font-weight: 500" for="no_of_school_Childrens"
                    >No of School Going Children*</label
                  >
                  <txt
                    type="number"
                    :disable="employeeFamilyDetails[0].no_of_children<=0"
                    placeholder="enter no of school childrens"
                    @change="
                      (val) => {
                        
                           employeeFamilyDetails[0].no_of_school_children =
                          val ||0
                          childValidation()
                        
                       
                      }
                    "
                    v-model="employeeFamilyDetails[0].no_of_school_children "
                  />
                </div>
                <div style="width: 50rem">
                  <label style="font-weight: 500" for="no_of_hostel_Childrens"
                    >No of Hostel Going Children*</label
                  >
                  <txt
                    type="number"
                   :disable="employeeFamilyDetails[0].no_of_children<=0"
                    placeholder="enter no of hostel childrens"
                    @change="
                      (val) => {
                        
                          employeeFamilyDetails[0].no_of_hostel_children =
                          val ||0;
                          childValidation()
                        
                        
                      }
                    "
                    v-model="employeeFamilyDetails[0].no_of_hostel_children"
                  />
                </div>
              </div>
            </div> -->
            <itProof-submit-dataTable
              
              :tableColumsHeader="auditTableColumns"
              :tableColumnsData="sectionData"
            >
              <template v-slot="slotprops">
               <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'particulars'"
                >
                  <span style="width: 12rem">{{
                    slotprops.value.record.name
                  }}</span>
                  <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  />
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.planned }}
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  
                >
                  {{ slotprops.value.record.actual }}
                </span>
                 <txt
                  v-if="slotprops.value.column.key == 'verfiedAmount'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 14rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                      slotprops.value.record.approved = value;
                      slotprops.value.record.actual=value;
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                  <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops,
                        slotprops.value.index,
                        'section_ten_exemption'
                      )
                    "
                  />
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved'"
                    src="@/assets/pending.svg"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 14rem;"
                 
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <span
                  style="display: flex; gap: 5px; width: 6rem"
                  v-if="slotprops.value.column.key == 'action'"
                >
                  <img
                    style="width: 2rem; height: 2rem;"

                    src="@/assets/rejected.svg"
                  />
                  <img
                    style="width: 2rem; height: 2rem"
                    
                    src="@/assets/success.svg"
                  />
                  
                  
                </span>
              </template>
            </itProof-submit-dataTable>
            <!-- <div class="row margin-t-m margin-b-l">
              <div class="col-12">
                <div
                  class="row-container"
                  style="display: flex; justify-content: right"
                >
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button
                    class="text-green"
                    @click="addMoreRow('family_details')"
                  >
                    Add More Family Details
                  </button>
                </div>
              </div>
            </div> -->
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      For Updated Attachements  please download the existing document and zip it with new document and upload
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="showPopupFamilyDetaila = !showPopupFamilyDetaila;toast=false;getItSubmissionData()"
                    />
                    <btn
                    
                    
                  
                      text="Save as Draft"
                      type="primary"
                      @click="saveDataForFinalArray('employee_family_details')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div 
          
          class="pr-0 cursor-point"
          @click="
            showPopupExemptionUnderSectionDeduction =
              !showPopupExemptionUnderSectionDeduction;toast=false
          "
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/home_rent_declartion.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">
                <Section>Sec 10 Exemption <span v-if="isSec10Emp=='Approved'" style="color:green">(Validated)</span><span v-if="isSec10Emp=='Pending'" style="color:orange">(Pending)</span></Section>
              </div>
              <div class="sub-heading-details-sm">
                provides exemption only in respect of tax on non- monetary
                perquisites
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupExemptionUnderSectionDeduction"
          @back="
            showPopupExemptionUnderSectionDeduction =
              !showPopupExemptionUnderSectionDeduction;toast=false;getItSubmissionData();
          "
          header="Sec 10 Exemption"
        >
        
          <template v-slot:content>
            <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
           <itProof-submit-dataTable
              
              :tableColumsHeader="auditTableColumns"
               :tableColumnsData="sec_ten_exemption_table_columns_data"
            >
              <template v-slot="slotprops">
               <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'particulars'"
                >
                  <span style="width: 12rem">{{
                    slotprops.value.record.name || slotprops.value.record["InvestmentComponentType.name"]
                  }}</span>
                  <!-- <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.planned }}
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending'||slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='partially_approved' )"
                  
                >
                  {{ slotprops.value.record.actual }}
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status!='rejected' && slotprops.value.record.status!='audit_approved' && slotprops.value.record.status!='partially_approved' && slotprops.value.record.status!='Pending'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <!-- ----------- -->
                <!-- <txt
                 v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                      slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                {{ slotprops.value.record.actual }}
              </span>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p>

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                {{ slotprops.value.record.actual }}
              </span> -->
                <txt
                  v-if="slotprops.value.column.key == 'verfiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.approved = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verfiedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' || slotprops.value.record.status=='audit_approved'|| slotprops.value.record.status=='approved'  )"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <!-- <p v-if="slotprops.value.column.key == 'verfiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p> -->

                 <!-- <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verfiedAmount' && (slotprops.value.record.status=='audit_approved'||slotprops.value.record.status=='approved')"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span> -->
                 <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'section_ten_exemption',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                
                <button
                  style="width:10rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.status=='rejected'
                  "
                   
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                   
                  >
                    <img src="@/assets/upload1.svg" />
                   
                  </label>
                 
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops,
                        slotprops.value.index,
                        'section_ten_exemption'
                      )
                    "
                  />
                </button>
                 <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                  <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
                  <!-- <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops,
                        slotprops.value.index,
                        'section_ten_exemption'
                      )
                    "
                  /> -->
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected' "
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 14rem;"
                 
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>

                 <div  v-if="slotprops.value.column.key == 'action'" class="d-flex justify-space-around">
                
                <v-toolbar-items class="hidden-sm-and-down">

                <v-menu offset-y>
                
                  <v-btn
                      class="act-btn"
                      slot="activator"
                      
                    >
                      Act
                    </v-btn>

                    <v-list>
                      <v-list-tile
                        v-for="(i, index) in menuItems" 
                        :key="index"
                      >
                      <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'section_ten_exemption')">{{ i.title}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                </v-menu>

                </v-toolbar-items>
               </div>
                <!-- <span
                  style="display: flex; gap: 5px; width: 6rem"
                  v-if="slotprops.value.column.key == 'action'"
                >
                  <img
                    style="width: 2rem; height: 2rem;"

                    src="@/assets/rejected.svg"
                  />
                  <img
                    style="width: 2rem; height: 2rem"
                    
                    src="@/assets/success.svg"
                  />
                  
                  
                </span> -->
              </template>
            </itProof-submit-dataTable>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      For Updated Attachements  please download the existing document and zip it with new document and upload
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="
                        showPopupExemptionUnderSectionDeduction =
                          !showPopupExemptionUnderSectionDeduction;toast=false;getItSubmissionData()
                      "
                    />
                    <btn
                      text="Validate"
                      type="primary"
                      @click="saveDataForFinalArray('section_ten_exemption')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <pop-up-window-lg
          v-if="
            section_ten_attachments_pop_up ||
            house_rent_attachments_pop_up ||
            deduction_under_6A_attachments_pop_up ||
            income_from_previous_employee_pop_up ||
            income_loss_from_house_attachments_pop_up ||
            other_income_attachments_pop_up ||
            other_tcs_attachment_pop_up
          "
          @back="goBackFunction(attachments_pop_up_header)"
          :header="attachments_pop_up_header"
        >
          <template v-slot:content>
            
            <itProof-submit-dataTable
               :disabled="incomeTaxProofSubmittedFlag"
              :tableColumsHeader="attachment_pop_up_column_header"
              :tableColumnsData="attachment_pop_up_table_columns_data"
            >
              <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'attachment'"
                >
                  <span style="width: 12rem">{{
                    slotprops.value.record.attachment
                  }}</span>
                </span>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'fileName'"
                >
                  {{ slotprops.value.record.fileName }}
                </span>
               

               
                <span
                  style="width: 15rem"
                  v-if="slotprops.value.column.key == 'viewFile'"
                >
               
                  <button @click="downloadUrl()" class="export-button">
                    View Attachment
                  </button>
                 
                </span>
                
                <!-- <span
                  style="width: 15rem"
                  v-if="slotprops.value.column.key == 'removeFile'"
                >
                  <button @click="deleteUrl(slotprops.value.record,slotprops.value.index,attachments_pop_up_header)" class="export-button">
                    Delete Attachment
                  </button>
                </span> -->
              </template>
            </itProof-submit-dataTable>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="goBackFunction(attachments_pop_up_header);"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div
        
          class="pl-0 cursor-point"
          @click="
            showPopupHouseRentDeclaration = !showPopupHouseRentDeclaration;toast=false
          "
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/home_rent_declartion.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">House Rent Declaration <span v-show="isHraEmp=='Approved'" style="color:green">(Validated)</span><span v-show="isHraEmp=='Pending'" style="color:orange">(Pending)</span></div>
              <div class="sub-heading-details-sm">
                To claim House rent allowance(HRA), it is necessary to provide
                evidence of the payment of the rent to the employee.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupHouseRentDeclaration"
          @back="showPopupHouseRentDeclaration = !showPopupHouseRentDeclaration;toast=false;getItSubmissionData();"
          header="House Rent Allowance"
        >
          <template v-slot:content>
             <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
            <div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                "
              >
                <div class="heading-text">
                  Rent Paid Details for HRA Exemption
                </div>
                <div 
                  class="align-center"
                  style="display: flex; align-items: center; gap: 5px"
                >
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button
                    class="text-green"
                    @click="addMoreRow('house_rent_declaration')"
                  >
                    Add Row
                  </button>
                </div>
              </div>
              <div
                class="row form-group my-3 hraMain"
                v-for="(item, index) in house_rent_declaration_array.details"
                :key="index"
              >
              <hr style="width:100%; border: 1px dashed #34c0be; margin: 2px 0px 14px 0px;"> 
                <div :disabled="item.status=='audit_approved'" class="col-4 pl-0">
                  <div class="label">
                    <span class="input-label1">From Date</span>
                    <date-picker
                      name="fromDate"
                      data-vv-as="from date"
                      @datevalue="
                        (val) => {
                          item.from=val
                          let date=new Date(val)
                          item.to=date.setDate(date.getDate()+1)
                        }
                      "

                      :dates-disabled="{
                        from:  new Date(
                          
                            fiscalYearEnd
                        ),
                        to: new Date(
                         
                            fiscalYearStart
                        ),
                      }"
                      v-validate="{ required: true }"
                      :classname="errors.has('fromDate')"
                      :errormsg="errors.first('fromDate')"
                      v-model="item.from"
                    />
                  </div>
                </div>
                
                <div :disabled="item.status=='audit_approved'" class="col-4 pl-0">
                  <div class="label">
                    <span class="input-label1">To Date</span>
                    <date-picker
                      name="toDate"
                      data-vv-as="to date"
                      @datevalue="
                        (val) => {
                          item.to = val;
                        }
                      "
                      :dates-disabled="{
                        from: new Date(

                         fiscalYearEndPlus 
                        ),
                        to: new Date(
                         
                         house_rent_declaration_array.details[index].from   
                        ),
                      }"
                      v-validate="{ required: true }"
                      :classname="errors.has('toDate')"
                      :errormsg="errors.first('toDate')"
                      v-model="item.to"
                    />
                  </div>
                </div>
                 
                <div :disabled="item.status=='audit_approved'" class="col-4 pl-0">
                  <txt
                    label="Rent per Month *"
                    type="number"
                    :name="`${index}Amount`"
                    v-validate="{ required: true }"
                    :classname="errors.has(`${index}Amount`)"
                    errormsg="Amount field is mandatory"
                    v-model="item.value"
                    @change="
                      (val) => {
                        if(val>=0){
                          item.value = val;
                        }else{
                          item.value=0
                        }
                      }
                    "
                  />
                </div>
                <div :disabled="item.status=='audit_approved'" class="col-4 pl-0 metroBtn">
                  <tl-select
                    label="City *"
                    :options="metro_city_options"
                    @change="
                      (val) => {
                        sendMetroValue(val, index);
                      }
                    "
                    value="Other"
                    v-model="item.ownerDetails.state"
                  ></tl-select>
                </div>
                <!-- <div :disabled="item.status=='audit_approved'" class="col-4 pl-0 metroBtn">
                  <tl-select
                    label="City"
                    :options="metro_city_options"
                    @change="
                      (val) => {
                        sendMetroValue(val, index);
                      }
                    "
                    value="Other"
                  ></tl-select>
                </div> -->
                <!-- <div 
                :disabled="item.status=='audit_approved'"
                  class="col-4 pl-0 metroBtn"
                  v-if="
                    (item.ownerDetails.metro == 'Other' ||
                      item.ownerDetails.metro == 'non_metro') &&
                    !item.isDelete && item.value>0
                  "
                >
                  <txt
                    label="City Name *"
                    type="text"
                    :name="`${index}City name`"
                    v-validate="{ required: true }"
                    :classname="errors.has(`${index}City name`)"
                    errormsg="City name is mandatory for non-metro"
                    v-model="item.ownerDetails.state"
                    @change="
                      (val) => {
                        item.ownerDetails.state = val;
                      }
                    "
                  />
                </div> -->
                <div
                  class="col-4 pl-0 metroBtn"
                  :disabled="item.status=='audit_approved'"
                  v-if="
                    (item.ownerDetails.metro == 'Other' ||
                      item.ownerDetails.metro == 'non_metro') &&
                    !item.isDelete && item.value>0
                  "
                >
                  <txt
                    label="City Name *"
                    type="text"
                    :name="`${index}City name`"
                    v-validate="{ required: true }"
                    :classname="errors.has(`${index}City name`)"
                    errormsg="City name is mandatory for non-metro"
                    v-model="item.ownerDetails.state"
                    @change="
                      (val) => {
                        item.ownerDetails.state = val;
                      }
                    "
                  />
                </div>
                <div
                  :disabled="item.status=='audit_approved'"
                  class="col-4 pl-0"
                >
                  <txt
                    label="Owner PAN Number *"
                    type="text"
                    :name="`${index}owner PAN Number`"
                    v-validate="item.value>8333?{ required: true, regex: pancardRegex }:{required: false,regex: pancardRegex }"
                    :classname="errors.has(`${index}owner PAN Number`)"
                    errormsg="Owner PAN number is required & should be in valid format"
                    v-model="item.ownerDetails.panNumber"
                    @change="
                      (val) => {
                        
                        item.ownerDetails.panNumber = val.toUpperCase();
                        checkOwnerPan(val.toUpperCase(),index)
                      }
                    "
                  />
                </div>
                <div
                 :disabled="item.status=='audit_approved'"
                  class="col-4 pl-0"
                >
                  <txt
                    label="Owner Name *"
                    type="text"
                    :name="`${index}Owner name`"
                    v-validate="{ required: true }"
                    :classname="errors.has(`${index}Owner name`)"
                    errormsg="Owner name is mandatory for non-metro"
                    v-model="item.ownerDetails.name"
                    @change="
                      (val) => {
                        item.ownerDetails.name = val.toUpperCase();
                      }
                    "
                  />
                </div>
                <div
                  :disabled="item.status=='audit_approved'"
                  class="col-4 pl-0"
                >
                  <txt
                    label="Owner Address *"
                    type="text"
                    :name="`${index}owner address`"
                    v-validate="{ required: true }"
                    :classname="errors.has(`${index}owner address`)"
                    errormsg="Owner Name is required "
                    v-model="item.ownerDetails.address"
                    @change="
                      (val) => {
                        item.ownerDetails.address = val;
                      }
                    "
                  />
                </div>
              <div>
                <txt style="margin-top: 2%;" v-if="item.status!='audit_approved'" type="text" v-model="item.remarks" label="Remarks"/>
                <p v-if="item.status!='audit_approved' && !item.remarks" style="font-size:small;color:red;">Remark is Mandatory</p>
            <div class="uploadMethoRadio">
              <tl-radio
                :name="`actionType${index}`"
                label="Approved"
                :id="`approve${index}`"
                value='audit_approved'
                @change="getValues('Approve',index,'house_rent_declaration')"
                v-model="item.status"
               
              />
               
              <tl-radio
                :name="`actionType${index}`"
                label="Reject"
                :id="`reject${index}`"
                value="rejected"
               @change="getValues('Reject',index,'house_rent_declaration')"
               v-model="item.status"
              />
                <tl-radio
                :name="`actionType${index}`"
                label="Partially Approved"
                :id="`partial${index}`"
                value="partially_approved"
               @change="getValues('Partially Approve',index,'house_rent_declaration')"
               v-model="item.status"
              />
            

            </div>

          </div>
              </div>
            

            </div>
            <div class="hraButton">
              <button
                style="width: 12rem; background-color: #e3c449"
                class="export-button"
                v-if="file_location_hra || house_rent_declaration_array.file_location"
                @click="
                  show_pop_up(
                    house_rent_declaration_array,
                    'house_rent_declaration',
                  )
                "
              >
                <img src="@/assets/clip.svg" />
                <label style="cursor: pointer">View Attachment</label>
              </button>
               <button
                  style="width:10rem; cursor: default"
                  
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-inputHRA1`"
                   
                  >
                    <img title="Upload Document in case the submitted document is not valid" src="@/assets/upload1.svg" />
                   
                  </label>
                  
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-inputHRA1`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                      $event.target.files,
                      0,
                      0,
                      'house_rent_declaration'
                    )
                    "
                  />
                </button>
              <button
                style="width: 12rem; cursor: default"
                class="export-button"
                v-if="!house_rent_declaration_array.file_location"
              >
                <label :for="`file-inputHRA`" class="input-label">
                  <img src="@/assets/clip.svg" />
                  <p>No Attachment</p>
                </label>
                <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
               
              </button>
            </div>
            <!-- <div style="display: flex; gap: 5px; margin:20px 0px; justify-content:center;align-items: center;">
             <textarea
                
                class="form-control"
                name="remarks"
                
              />
              
               
                  <img
                    style="width: 2rem; height: 2rem;"

                    src="@/assets/rejected.svg"
                  />
                  <img
                    style="width: 2rem; height: 2rem"
                    
                    src="@/assets/success.svg"
                  />
                  
                  
             
            </div>
            -->
          </template>

          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      For Updated Attachements  please download the existing document and zip it with new document and upload
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="
                        showPopupHouseRentDeclaration =
                          !showPopupHouseRentDeclaration;toast=false;getItSubmissionData()
                      "
                    />
                    <btn
                      text="Validate"
                      type="primary"
                      @click="saveDataForFinalArray('hraSection')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div
        
          class="pr-0 cursor-point"
          @click="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu;toast=false"
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/deduction_under_80CD.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">Deduction under VI A <span v-if="isDeduction6AEmp=='Approved'" style="color:green">(Validated)</span><span v-if="isDeduction6AEmp=='Pending'" style="color:orange">(Pending)</span></div>
              <div class="sub-heading-details-sm">
                Section 80C offers tax deductions on different types of
                tax-saving investments, such as ULIP,PPF, premium, etc.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupDeductionUnderCdeu"
          @back="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu;toast=false;getItSubmissionData();"
          header="Deduction Under Chapter VI A"
        >
          <template v-slot:content>
             <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
    <pop-up-message popupHeaderMessage="Section 80D - Medical Insurance for Self, Spouse and Dependent Children"
      v-if="show80DFamilyPopup" :message="'Qualified Amount : 25000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>HEALTH INSURANCE PREMIUM - 80D</h3>

              <h4>Eligibility</h4>
              <p>You can claim a tax deduction under this section for the payment of medical insurance premiums for self, your spouse, or any child. In addition, any amount paid for health check-ups can also be claimed for a tax deduction which shall not exceed Rs. 5,000. 
              </p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80DFamilyPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message>    
    <pop-up-message popupHeaderMessage="Section 80D - Medical Insurance for Parents"
      v-if="show80DParentsPopup" :message="'Qualified Amount : 25000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>HEALTH INSURANCE PREMIUM - 80D</h3>
              <p>You can claim a tax deduction under this section for the payment of medical insurance premiums for your parents. Additionally, any amount spent on health check-ups can also be claimed as a tax deduction, subject to a maximum limit of Rs. 5,000.</p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80DParentsPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message>   
    <pop-up-message popupHeaderMessage="Section 80D - Medical Insurance/ Medical Expenditure for Parent(s) if Senior Citizen(s)"
      v-if="show80DSeniorParentsPopup" :message="'Qualified Amount : 50000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>HEALTH INSURANCE PREMIUM - 80D</h3>
              <p>You can claim a tax deduction under this section for the payment of medical insurance premiums for your parents if they are senior citizens. Additionally, any amount spent on health check-ups can also be claimed as a tax deduction, with a maximum limit of Rs. 5,000.</p>
              <h3>MEDICAL EXPENDITURE</h3>
              <p>If there is no health insurance in effect, medical expenses for senior citizen parents can be claimed up to a maximum of Rs. 50,000.</p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80DSeniorParentsPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message popupHeaderMessage="Section 80D - Health Insurance for Self, Spouse and Children if Senior Citizen"
      v-if="show80DFamilySeniorParentsPopup" :message="'Qualified Amount : 50000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>HEALTH INSURANCE PREMIUM - 80D</h3>
              <p>You can claim a tax deduction under this section for the payment of medical insurance premium for self, spouse or any child. In addition, any amount paid for health check-up can also be claimed for tax deduction which shall not exceed to Rs. 5,000.</p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80DFamilySeniorParentsPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message popupHeaderMessage="80 E- Interest paid on loan for Higher Education"
      v-if="showInterestonEducationPopup" :message="'Qualified Amount : No Limit'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>Section 80E: Income tax deduction for interest on Education Loan</h3>
              <p>You can claim a tax deduction under section 80E for interest paid on repayment of an Education loan. The deduction can only be claimed on the interest paid on the repayment of the loan and not on the principal amount. </p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showInterestonEducationPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message popupHeaderMessage="80 EE - Additional Home Loan Interest Deduction"
      v-if="showInterestonHomeonePopup" :message="'Qualified Amount : 50000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3 style="margin-bottom: 10px; color: #333;">Condition for Claiming this Section</h3>
                <ul style="margin: 0; padding: 0 0 0 20px; color: #555;">
                  <li style="margin-bottom: 8px;">The value of the house should be <strong>Rs 50 lakh or less</strong>.</li>
                  <li style="margin-bottom: 8px;">The loan taken for the house must be <strong>Rs 35 lakh or less</strong>.</li>
                  <li style="margin-bottom: 8px;">The loan must be sanctioned by a <strong>financial institution or a housing finance company</strong>.</li>
                  <li style="margin-bottom: 8px;">The loan must be sanctioned between <strong>01.04.2016 to 31.03.2017</strong>.</li>
                  <li style="margin-bottom: 8px;">As of the date of the sanction of the loan, <strong>no other house property must be owned by you</strong>.</li>
                </ul>
                <p style="margin-top: 15px; color: #444;">
                  <strong>Eligibility Amount:</strong> Rs 50,000 per year until the loan is repaid.
                </p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showInterestonHomeonePopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message popupHeaderMessage="80 EEA - Additional Home Loan Interest Deduction"
      v-if="showInterestonHometwoPopup" :message="'Qualified Amount : 150000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3 style="margin-bottom: 10px; color: #333;">Condition for Claiming this Section</h3>
                  <ul style="margin: 0; padding: 0 0 0 20px; color: #555;">
                    <li style="margin-bottom: 8px;">
                      A housing loan must be taken from a <strong>financial institution or a housing finance company</strong> for buying a residential house property.
                    </li>
                    <li style="margin-bottom: 8px;">
                      The loan should be sanctioned during the period <strong>1st April 2019 and 31st March 2022</strong>.
                    </li>
                    <li style="margin-bottom: 8px;">
                      The stamp duty value of the house property should be <strong>Rs 45 lakhs or less</strong>.
                    </li>
                    <li style="margin-bottom: 8px;">
                      The individual taxpayer should not be eligible to claim a deduction under the existing <strong>Section 80EE</strong>.
                    </li>
                    <li style="margin-bottom: 8px;">
                      The taxpayer should be a first-time home buyer. The taxpayer should not own any residential house property as of the date of sanction of the loan.
                    </li>
                  </ul>
                  <p style="margin-top: 15px; color: #444;">
                    <strong>Eligibility Amount:</strong> Rs 1,50,000 per year until the loan is repaid.
                  </p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showInterestonHometwoPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message popupHeaderMessage="80 EEB - Deduction in Respect of Purchase of Electric Vehicle"
      v-if="showInterestonEVPopup" :message="'Qualified Amount : 150000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3 style="margin-bottom: 10px; color: #333;">Condition for Claiming this Section</h3>
                  <ul style="margin: 0; padding: 0 0 0 20px; color: #555;">
                    <li style="margin-bottom: 8px;">
                      The loan must be sanctioned anytime during the period starting from 1 April 2019 till 31 March 2023
                    </li>
                  </ul>
                  
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showInterestonEVPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message :dynamicWidth="'50%'" popupHeaderMessage="INTEREST ON DEPOSIT IN SAVING ACCOUNT - 80TTA"
      v-if="showInterestFromSavingAccount" :message="'Qualified Amount : 10000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
               <p>As per the existing provisions of Section 80TTA of the Income Tax Act, an assessee is allowed a deduction of up to Rs. 10,000 on interest income from a savings account. It's important to note that this deduction applies only to interest earned from savings accounts and not from Fixed Deposits or Recurring Deposits.</p>
               <p>Under Section 80TTA, there is no distinction for senior citizens; the deduction of Rs. 10,000 applies to all eligible taxpayers, regardless of age</p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showInterestFromSavingAccount = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message :dynamicWidth="'50%'" popupHeaderMessage="INTEREST ON DEPOSIT IN SAVING ACCOUNT FOR SENIOR CITIZEN - 80TTB"
      v-if="showInterestFromSavingAccountforseniorcitizen" :message="'Qualified Amount : 50000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <p>As per the Budget 2018, a new section 80TTB was introduced in the Income Tax Act to provide a deduction of Rs. 50,000 for senior citizens on interest income from deposits, including savings accounts, fixed deposits, and recurring deposits. This provision is effective from 1st April 2018 (i.e., for Assessment Year 2019-20 and Financial Year 2018-19).</p>
              <p>It is important to note that if a senior citizen claims a deduction under Section 80TTB, they cannot claim a deduction under Section 80TTA for interest income. Both deductions are mutually exclusive, meaning the taxpayer can choose only one of them.</p>
              <p>This provision benefits senior citizens by allowing a higher deduction of Rs. 50,000 compared to the Rs. 10,000 available under Section 80TTA for other taxpayers.</p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showInterestFromSavingAccountforseniorcitizen = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message :dynamicWidth="'50%'" popupHeaderMessage="Additional Exemption Under National Pension Scheme (NPS) u/s 80CCD (1B)"
      v-if="showNPSEmployeeContributionPopup" :message="'Qualified Amount : 50000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3 style="margin-bottom: 10px; color: #333;">Tax deductions under Section 80CCC and 80CCD for contributions to pension funds</h3>
              <p>You can claim a tax deduction under Section 80CCC and 80CCD for the contribution made to Pension Funds. If you have contributed any amount in any insurance scheme to receive a pension, then you can claim a tax deduction under 80CCC. However, if you have contributed to any pension scheme initiated by the central government, up to 10% of your salary such as the National Pension Scheme then you can claim a tax deduction under section 80CCD. </p>    
              <p><strong>Note:</strong> As per the Income Tax Act, the maximum limit of Rs. 1.5 lakh is an aggregate of deduction that may be claimed under sections 80C, 80CCC, and 80CCD. However, an exclusive tax benefit is available for NPS subscribers under section 80CCD. As per the Income Tax Act, Tier 1 account holder gets an additional deduction for investments up to Rs. 50, 000 in NPS. This deduction is over and above the deduction of Rs. 1.5 lakh available under section 80C of the IT Act, 1961. </p>    
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showNPSEmployeeContributionPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message popupHeaderMessage="Additional Exemption Under National Pension Scheme (NPS) u/s 80CCD (2)"
      v-if="showNPSEmployerContributionPopup" :message="'Qualified Amount : No Limit'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3 style="margin-bottom: 10px; color: #333;">The exemption is based on the least of the following options:</h3>
              <ol>
                <li>1) Amount contributed by an employer,</li>
                <li>2) 10% of Basic+Dearness Allowance for the Old Tax regime, and 14% of Basic+Dearness Allowance for the New Tax Regime.</li>
                <li>3) Gross Total Income</li>
              </ol>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showNPSEmployerContributionPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
           <itProof-submit-dataTable
              
              :tableColumsHeader="deduction_under_80C_table_colums_header"
              :tableColumnsData="deduction_under_80C_table_columns_data"
            >
              <template v-slot="slotprops">
               <span
                  style="display: flex; gap: 20px"
                   v-if="slotprops.value.column.key == '80Cparticulars'"
                >
                  <span v-if="slotprops.value.record.InvestmentComponentType.name == 'NPS Employee Contribution'" style="width: 12rem">
                    80CCD1(B)-Additional NPS Employee Contribution
                  </span>
                  <span v-else style="width: 12rem">{{
                   slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                  }}</span>
                   <img
                  v-if="slotprops.value.record.InvestmentComponentType.name=='NPS Employee Contribution'"
                    style="cursor: pointer"
                    src="@/assets/info-black.svg"
                    @click="show6APopup(slotprops.value.record.InvestmentComponentType.name)"
                  />
                  <img
                  v-if="slotprops.value.record.InvestmentComponentType.name=='NPS Employer Contribution'"
                    style="cursor: pointer"
                    src="@/assets/info-black.svg"
                    @click="show6APopup(slotprops.value.record.InvestmentComponentType.name)"
                  />
                  <!-- <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.planned }}
                </span>
                  <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending'||slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='partially_approved' )"                  
                >
                  {{ slotprops.value.record.actual }}
                </span>
                <txt
                v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status!='rejected' && slotprops.value.record.status!='audit_approved' && slotprops.value.record.status!='partially_approved' && slotprops.value.record.status!='Pending'"
                @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <!-- <txt
                 v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                      slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                {{ slotprops.value.record.actual }}
              </span>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p>

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                {{ slotprops.value.record.actual }}
              </span> -->
                 <txt
                 v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.approved = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <!-- <p v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p> -->

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                 <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80C',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                
                <button
                  style="width:10rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.status=='rejected'
                  "
                   
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-input80C${slotprops.value.index}`"
                   
                  >
                    <img src="@/assets/upload1.svg" />
                   
                  </label>
                 
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80C${slotprops.value.index}`"
                    name="attachment"
                    @change="
                       uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_80C'
                      )
                    "
                  />
                </button>
                 <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input80C${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                  <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
                  <!-- <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops,
                        slotprops.value.index,
                        'section_ten_exemption'
                      )
                    "
                  /> -->
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected' "
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                   @blur="uploadValidation('deduction_under_chapter_four_80C')"
                  style="width: 14rem;"
                 
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>

                 <div  v-if="slotprops.value.column.key == 'action'" class="d-flex justify-space-around">
                  
                <v-toolbar-items >

                <v-menu offset-y>
                
                    <v-btn
                      class="act-btn"
                      slot="activator"
                      
                    >
                      Act
                    </v-btn>

                    <v-list>
                      <v-list-tile
                        v-for="(i, index) in menuItems" 
                        :key="index"
                      >
                      <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'deduction_under_chapter_four_80C')">{{ i.title}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                </v-menu>

                </v-toolbar-items>
                <!-- <v-toolbar-items class="hidden-sm-and-down">
                  <v-btn @click="handleActClick">
                    Act
                  </v-btn>
                </v-toolbar-items> -->

              </div>
              </template>
            </itProof-submit-dataTable>
            <itProof-submit-dataTable
              
              :tableColumsHeader="deduction_under_80D_table_colums_header"
              :tableColumnsData="deduction_under_80D_table_columns_data"
            >
              <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == '80Dparticulars'"
                >
                <span v-if="slotprops.value.record.InvestmentComponentType.name == 'Medical Insurance Premium Parents Sr. Citizen'"
                    class="hover-on-text"
                    @click="function_for_chapter6A(
                        slotprops.value.record,
                        'deduction_under_80D',
                        slotprops.value.index
                      )"
                    style="width: 12rem"
                  >
                  Medical Insurance Premium/ Medical Expenditure for Parents Sr.Citizen
                  </span>
                  <span v-else
                    class="hover-on-text"
                    @click="function_for_chapter6A(
                        slotprops.value.record,
                        'deduction_under_80D',
                        slotprops.value.index
                      )"
                    style="width: 12rem"
                  >
                  {{
                      slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                    }}
                  </span>
                  <img v-if ="slotprops.value.record.InvestmentComponentType.name!='Preventive Health Check Up Upto 5000 Part of Above'"
                    style="cursor: pointer"
                    src="@/assets/info-black.svg"
                    @click="show6APopup(slotprops.value.record.InvestmentComponentType.name)"
                  />
                   <!-- <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.planned }}
                </span>
                  <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending'||slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='partially_approved' )"
                  
                >
                  {{ slotprops.value.record.actual }}
                </span>
                <txt
                v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status!='rejected' && slotprops.value.record.status!='audit_approved' && slotprops.value.record.status!='partially_approved' && slotprops.value.record.status!='Pending'"              
                @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                      
                    slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <!-- <txt
                 v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                      slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                {{ slotprops.value.record.actual }}
              </span>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p>

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                {{ slotprops.value.record.actual }}
              </span> -->
                <txt
                  v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                  
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.approved = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <!-- <p v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p> -->

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                 <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80D',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                
                 <button
                  style="width:10rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.status=='rejected'
                  "
                   
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-input80D${slotprops.value.index}`"
                   
                  >
                    <img src="@/assets/upload1.svg" />
                   
                  </label>
                
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80D${slotprops.value.index}`"
                    name="attachment"
                    @change="
                       uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_80D'
                      )
                    "
                  />
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected' "
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                   @blur="uploadValidation('deduction_under_chapter_four_80D')"
                  style="width: 14rem;"
                 
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>

                 <div  v-if="slotprops.value.column.key == 'action'" class="d-flex justify-space-around">
                  
                <v-toolbar-items class="hidden-sm-and-down">

                <v-menu offset-y>
                
                  <v-btn
                      class="act-btn"
                      slot="activator"
                      
                    >
                      Act
                    </v-btn>

                    <v-list>
                      <v-list-tile
                        v-for="(i, index) in menuItems" 
                        :key="index"
                      >
                      <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'deduction_under_chapter_four_80D')">{{ i.title}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                </v-menu>

                </v-toolbar-items>
               

              </div>
              </template>
            </itProof-submit-dataTable>
            <itProof-submit-dataTable
              
              :tableColumsHeader="deduction_under_80DD_table_colums_header"
              :tableColumnsData="deduction_under_80DD_table_columns_data"
            >
            <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == '80DDparticulars'"
                >
                  <span
                    class="hover-on-text"
                    @click="function_for_chapter6A(
                        slotprops.value.record,
                        'deduction_under_80DD',
                        slotprops.value.index
                      )"
                    style="width: 12rem"
                  >
                  {{
                      slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                    }}
                  </span>
                 <!-- <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.planned }}
                </span>
                  <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending'||slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='partially_approved' )"
                  
                >
                  {{ slotprops.value.record.actual }}
                </span>
                <txt
                v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status!='rejected' && slotprops.value.record.status!='audit_approved' && slotprops.value.record.status!='partially_approved' && slotprops.value.record.status!='Pending'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                  type="number"
                  @change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <!-- <txt
                 v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                      slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                {{ slotprops.value.record.actual }}
              </span>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p>

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                {{ slotprops.value.record.actual }}
              </span> -->
                <txt
                 v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.approved = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <!-- <p v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p> -->

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                 <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80DD',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                 <button
                  style="width:10rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.status=='rejected'
                  "
                   
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-input80DD${slotprops.value.index}`"
                   
                  >
                    <img src="@/assets/upload1.svg" />
                   
                  </label>
                  
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80DD${slotprops.value.index}`"
                    name="attachment"
                    @change="
                       uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_80DD'
                      )
                    "
                  />
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected' "
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                   @blur="uploadValidation('deduction_under_chapter_four_80DD')"
                  style="width: 14rem;"
                 
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>

                 <div  v-if="slotprops.value.column.key == 'action'" class="d-flex justify-space-around">
                  
                <v-toolbar-items class="hidden-sm-and-down">

                <v-menu offset-y>
                
                  <v-btn
                      class="act-btn"
                      slot="activator"
                      
                    >
                      Act
                    </v-btn>

                    <v-list>
                      <v-list-tile
                        v-for="(i, index) in menuItems" 
                        :key="index"
                      >
                      <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'deduction_under_chapter_four_80DD')">{{ i.title}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                </v-menu>

                </v-toolbar-items>
                </div>
              </template>
            </itProof-submit-dataTable>
            <itProof-submit-dataTable
              
              :tableColumsHeader="deduction_under_80DDB_table_colums_header"
              :tableColumnsData="deduction_under_80DDB_table_columns_data"
            >
            <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == '80DDBparticulars'"
                >
                  <span
                    class="hover-on-text"
                    @click="function_for_chapter6A(
                        slotprops.value.record,
                        'deduction_under_80DDB',
                        slotprops.value.index
                      )"
                    style="width: 12rem"
                  >
                  {{
                      slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                    }}
                  </span>
                   <!-- <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.planned }}
                </span>
                  <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending'||slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='partially_approved' )"
                  
                >
                  {{ slotprops.value.record.actual }}
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status!='rejected' && slotprops.value.record.status!='audit_approved' && slotprops.value.record.status!='partially_approved' && slotprops.value.record.status!='Pending'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <!-- <txt
                 v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                      slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                {{ slotprops.value.record.actual }}
              </span>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p>

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                {{ slotprops.value.record.actual }}
              </span> -->
                <txt
                 v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.approved = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <!-- <p v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p> -->

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                 <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80DDB',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                
                 <button
                  style="width:10rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                   slotprops.value.record.status=='rejected'
                  "
                   
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-input80DDB${slotprops.value.index}`"
                   
                  >
                    <img src="@/assets/upload1.svg" />
                   
                  </label>
                  
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80DDB${slotprops.value.index}`"
                    name="attachment"
                    @change="
                       uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_80DDB'
                      )
                    "
                  />
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected' "
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                   @blur="uploadValidation('deduction_under_chapter_four_80DDB')"
                  style="width: 14rem;"
                 
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>

                 <div  v-if="slotprops.value.column.key == 'action'" class="d-flex justify-space-around">
                  
                <v-toolbar-items class="hidden-sm-and-down">

                <v-menu offset-y>
                
                  <v-btn
                      class="act-btn"
                      slot="activator"
                      
                    >
                      Act
                    </v-btn>

                    <v-list>
                      <v-list-tile
                        v-for="(i, index) in menuItems" 
                        :key="index"
                      >
                      <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'deduction_under_chapter_four_80DDB')">{{ i.title}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                </v-menu>
                </v-toolbar-items>
                </div>
              </template>
            </itProof-submit-dataTable>
            <itProof-submit-dataTable
              :tableColumsHeader="deduction_under_80G_table_colums_header"
              :tableColumnsData="deduction_under_80G_table_columns_data"
            >
              <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == '80Gparticulars'"
                >
                  <span style="width: 12rem">{{
                    slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                  }}</span>
                   <!-- <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.planned }}
                </span>
                  <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending'||slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='partially_approved' )"                  
                >
                  {{ slotprops.value.record.actual }}
                </span>
                <txt
                v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status!='rejected' && slotprops.value.record.status!='audit_approved' && slotprops.value.record.status!='partially_approved' && slotprops.value.record.status!='Pending'"                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <!-- <txt
                 v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                      slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                  >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                {{ slotprops.value.record.actual }}
              </span>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p>

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                {{ slotprops.value.record.actual }}
              </span> -->
                <txt
                 v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.approved = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <!-- <p v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p> -->

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                 <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80G',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                
               <button
                  style="width:10rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.status=='rejected'
                  "
                   
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-input80G${slotprops.value.index}`"
                   
                  >
                    <img src="@/assets/upload1.svg" />
                   
                  </label>
                  
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80G${slotprops.value.index}`"
                    name="attachment"
                    @change="
                       uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_80G'
                      )
                    "
                  />
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected' "
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                   @blur="uploadValidation('deduction_under_chapter_four_80DDB')"
                  style="width: 14rem;"
                 
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>

                 <div  v-if="slotprops.value.column.key == 'action'" class="d-flex justify-space-around">
                  
                <v-toolbar-items class="hidden-sm-and-down">

                <v-menu offset-y>
                
                  <v-btn
                      class="act-btn"
                      slot="activator"
                      
                    >
                      Act
                    </v-btn>

                    <v-list>
                      <v-list-tile
                        v-for="(i, index) in menuItems" 
                        :key="index"
                      >
                      <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'deduction_under_chapter_four_80G')">{{ i.title}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                </v-menu>
                </v-toolbar-items>
                </div>
              </template>
            </itProof-submit-dataTable>

            <itProof-submit-dataTable
             
              :tableColumsHeader="deduction_under_80U_table_colums_header"
              :tableColumnsData="deduction_under_80U_table_columns_data"
            >
              <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == '80Uparticulars'"
                >
                  <span style="width: 12rem">{{
                    slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                  }}</span>
                  <!-- <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.planned }}
                </span>
                  <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending'||slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='partially_approved' )"                  
                >
                  {{ slotprops.value.record.actual }}
                </span>
                <txt
                v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status!='rejected' && slotprops.value.record.status!='audit_approved' && slotprops.value.record.status!='partially_approved' && slotprops.value.record.status!='Pending'"                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <!-- <txt
                 v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                      slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                  >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                {{ slotprops.value.record.actual }}
              </span>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p>

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                {{ slotprops.value.record.actual }}
              </span> -->
                 <txt
                 v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.approved = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <!-- <p v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p> -->

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                 <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80U',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                
                <button
                  style="width:10rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.status=='rejected'
                  "
                   
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-input80U${slotprops.value.index}`"
                   
                  >
                    <img src="@/assets/upload1.svg" />
                   
                  </label>
                  
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80U${slotprops.value.index}`"
                    name="attachment"
                    @change="
                       uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_80U'
                      )
                    "
                  />
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected' "
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                   @blur="uploadValidation('deduction_under_chapter_four_80U')"
                  style="width: 14rem;"
                 
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>

                 <div  v-if="slotprops.value.column.key == 'action'" class="d-flex justify-space-around">
                  
                <v-toolbar-items class="hidden-sm-and-down">

                <v-menu offset-y>
                
                  <v-btn
                      class="act-btn"
                      slot="activator"
                      
                    >
                      Act
                    </v-btn>

                    <v-list>
                      <v-list-tile
                        v-for="(i, index) in menuItems" 
                        :key="index"
                      >
                      <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'deduction_under_chapter_four_80U')">{{ i.title}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                </v-menu>
                </v-toolbar-items>
                </div>
              </template>
            </itProof-submit-dataTable>
            <itProof-submit-dataTable
              
              :tableColumsHeader="deduction_under_others_table_colums_header"
              :tableColumnsData="deduction_under_others_table_columns_data"
            >
              <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'particulars'"
                >
                <span v-if="slotprops.value.record.name == 'Interest from Savings Bank Account' || slotprops.value.record.InvestmentComponentType.name == 'Interest from Savings Bank Account' " style="width: 12rem">
                    80TTA - Interest from Savings Bank Account
                  </span>
                  <span v-else-if="slotprops.value.record.name == 'Interest from Savings Bank Account - Sr Citizens' || slotprops.value.record.InvestmentComponentType.name == 'Interest from Savings Bank Account - Sr Citizens' " style="width: 12rem">
                    80TTB - Interest from Savings Bank Account - Sr Citizens
                  </span>
                
                  <span v-else style="width: 12rem">{{
                    slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                  }}</span>
                  <img
                    style="cursor: pointer"
                    src="@/assets/info-black.svg"
                    @click="show6APopup(slotprops.value.record.InvestmentComponentType.name)"
                  />
                  <!-- <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.planned }}
                </span>
                   <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending'||slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='partially_approved' )"                  
                >
                  {{ slotprops.value.record.actual }}
                </span>
                <txt
                v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status!='rejected' && slotprops.value.record.status!='audit_approved' && slotprops.value.record.status!='partially_approved' && slotprops.value.record.status!='Pending'"                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <!-- <txt
                 v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                      slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                  >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                {{ slotprops.value.record.actual }}
              </span>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p>

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                {{ slotprops.value.record.actual }}
              </span> -->
                <txt
                 v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.approved = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <!-- <p v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p> -->

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                 <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_others',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                
                <button
                  style="width:10rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.status=='rejected'
                  "
                   
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-input80E${slotprops.value.index}`"
                   
                  >
                    <img src="@/assets/upload1.svg" />
                   
                  </label>
                 
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80E${slotprops.value.index}`"
                    name="attachment"
                    @change="
                       uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_others'
                      )
                    "
                  />
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected' "
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                   @blur="uploadValidation('deduction_under_chapter_four_others')"
                  style="width: 14rem;"
                 
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>

                 <div  v-if="slotprops.value.column.key == 'action'" class="d-flex justify-space-around">
                  
                <v-toolbar-items class="hidden-sm-and-down">

                <v-menu offset-y>
                
                  <v-btn
                      class="act-btn"
                      slot="activator"
                      
                    >
                      Act
                    </v-btn>

                    <v-list>
                      <v-list-tile
                        v-for="(i, index) in menuItems" 
                        :key="index"
                      >
                      <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'deduction_under_chapter_four_others')">{{ i.title}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                </v-menu>
                </v-toolbar-items>
                </div>
              </template>
            </itProof-submit-dataTable>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      For Updated Attachements  please download the existing document and zip it with new document and upload
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="
                        showPopupDeductionUnderCdeu =
                          !showPopupDeductionUnderCdeu;toast=false;getItSubmissionData()
                      "
                    />
                    <btn
                      text="Validate"
                      type="primary"
                      @click="saveDataForFinalArray('deduction_under_6A')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <pop-up-window-lg
          v-if="showPopupUnder80D"
          @back="showPopupUnder80D = !showPopupUnder80D;toast=false;options_for_6a_family_dependant =employeeFamilyDetails[0].details"
          :header="pop_up_header_80D"
        >
          <template v-slot:content>
             <toast-message
            :message="errmsg"
            type="error"
            :isToastEnable="toast"
            @close="(val) => (toast = val)"
          />
            <itProof-submit-dataTable
             
              :tableColumsHeader="permanent_disability_under_80D_header"
              :tableColumnsData="deduction_under_80D_pop_up"
            >
              <template v-slot="slotprops">
                <tl-select
                  v-if="slotprops.value.column.key == 'name'"
                  labelText="name"
                  :options="options_for_6a_family_dependant"
                  placeholder="Select"
                  v-model="slotprops.value.record.name"
                  @change="
                    (val) => {
                      relationChange(val, slotprops.value.index,'80_d_popup')
                    }
                  "
                />
                <txt
                  v-if="slotprops.value.column.key == 'relationship'"
                  type="text"
                  v-model="slotprops.value.record.relationShip"
                >
                </txt>
                <txt
                  v-if="slotprops.value.column.key == 'amount'"
                  type="number"
                  @change="(value) => (slotprops.value.record.amount = value)"
                  v-model="slotprops.value.record.amount "
                >
                </txt>
                <!-- <button
                  class="delete-btn"
                  v-if="
                    slotprops.value.column.key == 'delete' &&
                    slotprops.value.index > 0
                  "
                  @click="
                    () => {
                      deleteRow(
                        'deduction_under_6a_80D',
                        slotprops.value.index
                      );
                    }
                  "
                >
                  Delete
                </button> -->
              </template>
            </itProof-submit-dataTable>
            <!-- <div class="row margin-t-m margin-b-l">
              <div class="col-12">
                <div
                  class="row-container"
                  style="display: flex; justify-content: right"
                >
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button
                    class="text-green"
                    @click="
                      addMoreRow(
                        'deduction_under_6a_80D',
                        pop_up_header_80D
                      )
                    "
                  >
                    Add More Row
                  </button>
                </div>
              </div>
            </div> -->
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="showPopupUnder80D = !showPopupUnder80D;toast=false;options_for_6a_family_dependant =employeeFamilyDetails[0].details"
                    />
                    <btn
                      text="Save"
                      type="primary"
                      @click="
                        function_from_chapter6a_popup(
                          pop_up_header_80D,
                          'pop_up_80d'
                        )
                      "
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <pop-up-window-lg
          v-if="showPopupUnder80DD"
          @back="showPopupUnder80DD = !showPopupUnder80DD;toast=false;options_for_6a_family_dependant =employeeFamilyDetails[0].details"
          :header=pop_up_80DD_header
        >
          <template v-slot:content>
            <toast-message
                    :message="errmsg"
                    type="error"
                    :isToastEnable="toast"
                    @close="(val) => (toast = val)"
                 />
            <itProof-submit-dataTable
              
              :tableColumsHeader="permanent_disability_under_80D_header"
              :tableColumnsData="deduction_under_80DD_pop_up"
            >
            <template v-slot="slotprops">
                  
                <tl-select
                  v-if="slotprops.value.column.key == 'name'"
                  labelText="name"
                  :options="options_for_6a_family_dependant"
                  placeholder="Select"
                  v-model="slotprops.value.record.name"
                  @change="
                    (val) => {
                      relationChange(val, slotprops.value.index,'80_dd_popup')
                    }
                  "
                />
                <txt
                  v-if="slotprops.value.column.key == 'relationship'"
                  type="text"
                  v-model="slotprops.value.record.relationShip"
                >
                </txt>
                <txt
                  v-if="slotprops.value.column.key == 'amount'"
                  type="number"
                  @change="(value) => (slotprops.value.record.amount = value)"
                  v-model="slotprops.value.record.amount"
                >
                </txt>
                <!-- <button
                  class="delete-btn"
                  v-if="
                    slotprops.value.column.key == 'delete' &&
                    slotprops.value.index > 0
                  "
                  @click="
                    () => {
                      deleteRow(
                        'deduction_under_6a_80DD',
                        slotprops.value.index
                      );
                    }
                  "
                >
                  Delete
                </button> -->
              </template>
            </itProof-submit-dataTable>
            <!-- <div class="row margin-t-m margin-b-l">
              <div class="col-12">
                <div
                  class="row-container"
                  style="display: flex; justify-content: right"
                >
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button
                    class="text-green"
                    @click="
                      addMoreRow(
                        'deduction_under_6a_80DD',
                        pop_up_80DD_header
                      )
                    "
                  >
                    Add More Row
                  </button>
                </div>
              </div>
            </div> -->
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="showPopupUnder80DD = !showPopupUnder80DD;toast=false;options_for_6a_family_dependant =employeeFamilyDetails[0].details"
                    />
                    <btn
                      text="Save"
                      type="primary"
                      @click="
                        function_from_chapter6a_popup(
                          pop_up_80DD_header,
                          'pop_up_80dd'
                        )
                      "
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <pop-up-window-lg
          v-if="showPopupUnder80DDB"
          @back="showPopupUnder80DDB = !showPopupUnder80DDB;toast=false;options_for_6a_family_dependant =employeeFamilyDetails[0].details"
          :header=pop_up_80DDB_header
        >
          <template v-slot:content>
            <toast-message
                    :message="errmsg"
                    type="error"
                    :isToastEnable="toast"
                    @close="(val) => (toast = val)"
                 />
            <itProof-submit-dataTable
              
              :tableColumsHeader="permanent_disability_under_80DDB_header"
              :tableColumnsData="deduction_under_80DDB_pop_up_data"
            >
            <template v-slot="slotprops">
                <tl-select
                  v-if="slotprops.value.column.key == 'name'"
                  labelText="name"
                   :options="options_for_6a_family_dependant"
                  placeholder="Select"
                  v-model="slotprops.value.record.name"
                  @change="
                    (val) => {
                      relationChange(val, slotprops.value.index,'80_ddb_popup')
                    }
                  "
                />
                <txt
                  v-if="slotprops.value.column.key == 'relationship'"
                  type="text"
                  v-model="slotprops.value.record.relationShip"
                >
                </txt>
                <txt
                  v-if="slotprops.value.column.key == 'amount'"
                  type="number"
                  @change="(value) => (slotprops.value.record.amount = value)"
                  v-model="slotprops.value.record.amount"
                >
                </txt>
                <!-- <button
                  class="delete-btn"
                  v-if="
                    slotprops.value.column.key == 'delete' &&
                    slotprops.value.index > 0
                  "
                  @click="
                    () => {
                      deleteRow(
                        'deduction_under_6a_80DDB',
                        slotprops.value.index
                      );
                    }
                  "
                >
                  Delete
                </button> -->
              </template>
            </itProof-submit-dataTable>
            <!-- <div class="row margin-t-m margin-b-l">
              <div class="col-12">
                <div
                  class="row-container"
                  style="display: flex; justify-content: right"
                >
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button
                    class="text-green"
                    @click="
                      addMoreRow(
                        'deduction_under_6a_80DDB',
                        pop_up_80DDB_header
                      )
                    "
                  >
                    Add More Row
                  </button>
                </div>
              </div>
            </div> -->
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="showPopupUnder80DDB = !showPopupUnder80DDB;toast=false;options_for_6a_family_dependant =employeeFamilyDetails[0].details"
                    />
                    <btn
                       text="Save"
                      type="primary"
                      @click="
                        function_from_chapter6a_popup(
                          pop_up_80DDB_header,
                          'pop_up_80ddb'
                        )
                      "
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div
          class="pl-0 cursor-point"
        
          @click="
            showPopupIncomeLossFromHousingProperty =
              !showPopupIncomeLossFromHousingProperty;toast=false
          "
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/incomeLossFromHousingProperty.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">Income/Loss from Housing Property <span v-if="isIncomeLossEmp=='Approved'" style="color:green">(Validated)</span><span v-if="isIncomeLossEmp=='Pending'" style="color:orange">(Pending)</span></div>
              <div class="sub-heading-details-sm">
                A taxpayer can claim deduction under Section 24 of interest paid
                on home loan for each of the houses separately.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupIncomeLossFromHousingProperty"
          @back="
            showPopupIncomeLossFromHousingProperty =
              !showPopupIncomeLossFromHousingProperty;toast=false;getItSubmissionData()
          "
          header="Income/Loss from Housing Property"
        >
          <template v-slot:content>
             <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
            <itProof-submit-dataTable
              
              :tableColumsHeader="incomeLossTableColumsHeaderOne"
              :tableColumnsData="income_loss_from_house_table_columns_data_one"
            >
              <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'interestOnHousingLoan'"
                >
                  <span style="width: 10rem">{{
                    slotprops.value.record.joint_holder_name
                  }}</span>
                   <!-- <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.total_planned }}
                </span>
                    <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending'||slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='partially_approved' )"                  
                >
                  {{ slotprops.value.record.total_actual }}
                </span>
                <txt
                v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status!='rejected' && slotprops.value.record.status!='audit_approved' && slotprops.value.record.status!='partially_approved' && slotprops.value.record.status!='Pending'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.total_actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.total_actual"
                >
                </txt>
                 
                <!-- <txt
                 v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                      slotprops.value.record.total_actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.total_actual"
                  >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                {{ slotprops.value.record.total_actual }}
              </span>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.total_approved>slotprops.value.record.total_actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p>

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                {{ slotprops.value.record.total_actual }}
              </span> -->
                <txt
                 v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.total_approved = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.total_approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.total_approved }}
                </span>
                <!-- <p v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p> -->

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                  {{ slotprops.value.record.total_approved }}
                </span>
                 <!-- <span
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                >
                  {{ slotprops.value.record.total_approved }}
                </span> -->
                
                 <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'income_loss_self_occuiped',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                
               <button
                  style="width:10rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                   slotprops.value.record.status=='rejected'
                  "
                   
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-inputSelf${slotprops.value.index}`"
                   
                  >
                    <img src="@/assets/upload1.svg" />
                   
                  </label>
                  
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-inputSelf${slotprops.value.index}`"
                    name="attachment"
                    @change="
                       uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'income_loss_self'
                      )
                    "
                  />
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved' || slotprops.value.record.status=='' "
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected'"
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 14rem;"
                 
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>

                 <div  v-if="slotprops.value.column.key == 'action'" class="d-flex justify-space-around">
                
                <v-toolbar-items class="hidden-sm-and-down">

                <v-menu offset-y>
                
                  <v-btn
                      class="act-btn"
                      slot="activator"
                      
                    >
                      Act
                    </v-btn>

                    <v-list>
                      <v-list-tile
                        v-for="(i, index) in menuItems" 
                        :key="index"
                      >
                      <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'income_loss_self_occuiped')">{{ i.title}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                </v-menu>

                </v-toolbar-items>
               

                </div>
              </template>
            </itProof-submit-dataTable>
            <div
              :disabled="false"
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 20px;
                padding: 15px 30px;
              "
            >
              <div class="data_three">
                <span>Bank Name</span>
                <txt
                  name="bank_name"
                  type="text"
                  data-vv-as="bank_name"
                  v-model="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.bank_name
                  "
                  @Change="
                    (value) => {
                       income_loss_from_house_table_columns_data_one[0]
                      .bank_details.bank_name = value;
                    }
                  "
                
                ></txt>
               
                
              </div>
              <div class="data_three">
                <span>Bank Address</span>
                <txt
                  name="bank_address"
                  type="text"
                  data-vv-as="bank_address"
                  v-model="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.bank_address
                  "
                ></txt>
                
              </div>
              <div class="data_three">
                <span>Bank Pancard Number</span>
                <txt
                  name="bank_pancard_number"
                  type="text"
                  data-vv-as="bank_pancard_number"
                  v-model="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.bank_pancard_number
                  "
                  @change="
                      (val) => {
                       
                      checkBankPan(val.toUpperCase())
                      }
                    "
                   v-validate="{ required: true, regex: bankPanRegex }"
                    :classname="errors.has('bank_pancard_number')"
                    errormsg="PAN number is required & should be in valid format"
                ></txt>
              </div>
              <div class="data_three">
                <span>Loan Sanction Date</span>
                <date-picker
                  name="loan_sanction_date"
                  :value="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.loan_sanction_date
                  "
                  @datevalue="
                    (val) => {
                      income_loss_from_house_table_columns_data_one[0].bank_details.loan_sanction_date =
                        val;
                     let date=new Date(val)
                          income_loss_from_house_table_columns_data_one[0]
                      .bank_details.home_occupance_date=date.setDate(date.getDate()+1)
                    }
                  "
                   :dates-disabled="{
                        from:new Date(),
                        // to: new Date( fiscalYearStart),
                      }"
                  v-validate="{ required: true }"
                  data-vv-as="loan_sanction_date"
                  :classname="errors.has('loan_sanction_date')"
                  :errormsg="errors.first('loan_sanction_date')"
                ></date-picker>
                
              </div>
              <div class="data_three">
                <span>Home Occupancy Date </span>
                <date-picker
                  name="home_occupance_date"
                  :value="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.home_occupance_date
                  "
                  @datevalue="
                    (val) => {
                      income_loss_from_house_table_columns_data_one[0].bank_details.home_occupance_date =
                        val;
                        
                    }
                  "
                   :dates-disabled="{
                        from:new Date(fiscalYearEnd),
                        to: new Date( income_loss_from_house_table_columns_data_one[0].bank_details.loan_sanction_date),
                      }"
                  v-validate="{ required: true }"
                  data-vv-as="loan_sanction_date"
                  :classname="errors.has('home_occupance_date')"
                  :errormsg="errors.first('home_occupance_date')"
                ></date-picker>
                
              </div>
              <div class="data_three">
                <span>Home Address </span>
                <txt
                  name="home_address"
                  type="text"
                  data-vv-as="home_addres"
                  v-model="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.home_address
                  "
                ></txt>
               

              </div>
              <div class="data_three">
                <span>Pre-EMI intrest paid </span>
                <txt
                  name="pre_emi_interest_paid"
                  type="Number"
                  data-vv-as="pre_emi_interest_paid"
                  v-model="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.pre_emi_interest_paid
                  "
                ></txt>
                

              </div>
            </div>
            <!-- //Self-Declaration for joint property -->

            <div
              :disabled="false"
              style="
                display: flex;
                justify-content: space-between;
                padding: 15px 30px;
              "
            >
              <div>

                <div style="margin-bottom: 20px">
                <label>
                  <input 
                    type="checkbox" 
                    v-model="showDiv" 
                  />
                  Joint Declaration Applicable
                </label>
              </div>
                <div
                v-if="showDiv"
                  v-for="(
                    value, index
                  ) in income_loss_from_house_table_columns_data_three"
                  :key="index"
                  style="
                    display: flex;
                    justify-content: space-between;
                    gap: 20px;
                    padding: 15px 0;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <span style="width: 12rem"
                      >Self-Declaration for joint property</span
                    >
                    <!-- <img
                      style="cursor: pointer; height: 1.5rem"
                      title="information about icon for the arrangements of somethig"
                      src="@/assets/info-black.svg"
                    /> -->
                  </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>Name Of Joint Holder</span>
                    <txt
                      style="width: 20rem"
                      type="text"
                       v-model="
                        income_loss_from_house_table_columns_data_three[index]
                          .joint_holder_name
                      "
                      @change="
                        (value) => {
                          income_loss_from_house_table_columns_data_three[
                            index
                          ].joint_holder_name = value;
                         
                        }
                      "
                    ></txt>
                  </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>Relationship</span>
                    <txt
                      style="width: 20rem"
                      type="text"
                      v-model="
                        income_loss_from_house_table_columns_data_three[index]
                          .relationship
                      "
                      @change="
                        (value) => {
                          income_loss_from_house_table_columns_data_three[
                            index
                          ].relationship = value;
                        }
                      "
                    ></txt>
                  </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>% of tax benefit claimed by joint holder</span>
                    <txt
                      style="width: 20rem"
                      type="number"
                      v-model="income_loss_from_house_table_columns_data_three[index].tax_benefit"
                      @change="
                        (value) => {
                          // income_loss_from_house_table_columns_data_three[
                          //   index
                          // ].tax_benefit = value;
                           checkSelfJointHolder(Number(value),index)
                        }
                      "
                    ></txt>
                  </div>
                  <button
                    class="delete-btn"
                    v-if="
                      income_loss_from_house_table_columns_data_three.length > 1
                    "
                    @click="
                      () => {
                        deleteRow('income_loss', index);
                      }
                    "
                  >
                    Delete
                  </button>
                </div>
              </div>
              <div class="row margin-t-m margin-b-l">
                <div class="col-12">
                  <div
                    v-if="showDiv"
                    class="row-container"
                    style="display: flex; justify-content: right"
                  >
                    <img src="@/assets/group-5.svg" class="Group-5" />
                    <button
                      class="text-green"
                      @click="addOneMoreRow()"
                    >
                      Add More
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <itProof-submit-dataTable
              
              :tableColumsHeader="incomeLossTableColumsHeaderTwo"
              :tableColumnsData="income_loss_from_house_table_columns_data_two.letout"
            >
              <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'income/lossOnHouse'"
                >
                <span v-if="slotprops.value.record.name == 'Current Year Interest'" style="width: 12rem">
                   Current Financial Year Interest
                  </span>
                  <span v-else-if="slotprops.value.record.name == 'A Total rent received by employee'" style="width: 12rem">
                  A Annual Rent Received By Employee
                  </span>
                  <span v-else style="width: 12rem">{{
                    slotprops.value.record.name
                  }}</span>
                  <!-- <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.planned }}
                </span>
                   <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending'||slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='partially_approved' )"
                  
                >
                  {{ slotprops.value.record.actual }}
                </span>
                <txt
                v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status!='rejected' && slotprops.value.record.status!='audit_approved' && slotprops.value.record.status!='partially_approved' && slotprops.value.record.status!='Pending'"                @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt> 
                <!-- <txt
                 v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                      slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                  >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                {{ slotprops.value.record.actual }}
              </span>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p>

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                {{ slotprops.value.record.actual }}
              </span> -->
                <txt
                  v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'"
                  :disabled="!((slotprops.value.record.name == 'Current Year Interest')||(slotprops.value.record.name == 'A Total rent received by employee')||(slotprops.value.record.name == 'B Less: municipal Taxes Paid'))"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.approved = value;
                    calculate()
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <!-- <p v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p> -->

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                 <!-- <span
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                >
                  {{ slotprops.value.record.total_approved }}
                </span> -->
                 <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'income_loss_letout',
                      slotprops.value.index
                    )
                  "
                  v-if="
                  slotprops.value.record.name == 'Current Year Interest' &&
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                   :disabled="(!slotprops.value.record.actual > 0)?true:false || (slotprops.value.index > 0) ? true:false"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                
              <button
                  style="width:10rem; cursor: default"
                  v-if="
                    slotprops.value.record.name == 'Current Year Interest' &&
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.actual && slotprops.value.record.status=='rejected'
                  "
                   
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-inputLetOut${slotprops.value.index}`"
                   
                  >
                    <img src="@/assets/upload1.svg" />
                   
                  </label>
                  <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-inputLetOut${slotprops.value.index}`"
                    name="attachment"
                    @change="
                       uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'income_loss_letout_property'
                      )
                    "
                  />
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.record.name == 'Current Year Interest' &&
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status' &&slotprops.value.record.name == 'Current Year Interest'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved' || slotprops.value.record.status=='' "
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected'"
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks' && slotprops.value.record.name == 'Current Year Interest'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 14rem;"
                  :disabled="(!slotprops.value.record.actual > 0)?true:false || (slotprops.value.index > 0) ? true:false"
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && slotprops.value.record.name == 'Current Year Interest' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>

                 <div v-if="slotprops.value.column.key == 'action' && slotprops.value.record.name == 'Current Year Interest'" class="d-flex justify-space-around">
                
                <v-toolbar-items class="hidden-sm-and-down">

                <v-menu offset-y>
                
                  <v-btn
                      class="act-btn"
                      slot="activator"
                      
                    >
                      Act
                    </v-btn>

                    <v-list>
                      <v-list-tile
                        v-for="(i, index) in menuItems" 
                        :key="index"
                      >
                      <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'income_loss_letout')">{{ i.title}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                </v-menu>

                </v-toolbar-items>
               

                </div>
              </template>
            </itProof-submit-dataTable>
            <div
              :disabled="false"
              style="
                display: flex;
                justify-content: space-between;
                padding: 15px 30px;
              "
            >
              <div>

                <div style="margin-bottom: 20px">
                <label>
                  <input 
                    type="checkbox" 
                    v-model="showDivforletout" 
                  />
                  Joint Declaration Applicable
                </label>
              </div>
                <div
                  v-if="showDivforletout"
                  v-for="(
                    value, index
                  ) in income_loss_from_house_table_columns_data_letout_joint_Property"
                  :key="index"
                  style="
                    display: flex;
                    justify-content: space-between;
                    gap: 20px;
                    padding: 15px 0;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <span style="width: 12rem"
                      >Self-Declaration for joint property</span
                    >
                    <!-- <img
                      style="cursor: pointer; height: 1.5rem"
                      title="information about icon for the arrangements of somethig"
                      src="@/assets/info-black.svg"
                    /> -->
                  </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>Name Of Joint Holder</span>
                    <txt
                      style="width: 20rem"
                      type="text"
                      v-model="
                        income_loss_from_house_table_columns_data_letout_joint_Property[index]
                          .joint_holder_name
                      "
                      @change="
                        (value) => {
                          income_loss_from_house_table_columns_data_letout_joint_Property[
                            index
                          ].name = value;
                        }
                      "
                    ></txt>
                  </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>Relationship</span>
                    <txt
                      style="width: 20rem"
                      type="text"
                      v-model="
                        income_loss_from_house_table_columns_data_letout_joint_Property[index]
                          .relationship
                      "
                      @change="
                        (value) => {
                          income_loss_from_house_table_columns_data_letout_joint_Property[
                            index
                          ].relationship = value;
                        }
                      "
                    ></txt>
                  </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>% of tax benefit claimed by joint holder</span>
                    <txt
                      style="width: 20rem"
                      type="number"
                      v-model="
                        income_loss_from_house_table_columns_data_letout_joint_Property[index]
                          .tax_benefit
                      "
                      @change="
                        (value) => {
                          // income_loss_from_house_table_columns_data_letout_joint_Property[
                          //   index
                          // ].tax_benefit = value;
                        checkLetOutJointHolder(Number(value),index)

                        }
                      "
                    ></txt>
                  </div>
                  <button
                    class="delete-btn"
                    v-if="
                      income_loss_from_house_table_columns_data_letout_joint_Property.length > 1
                    "
                    @click="
                      () => {
                        deleteRow('income_loss_letout', index);
                      }
                    "
                  >
                    Delete
                  </button>
                </div>
              </div>
              <div class="row margin-t-m margin-b-l">
                <div class="col-12">
                  <div
                  v-if="showDivforletout"
                    class="row-container"
                    style="display: flex; justify-content: right"
                  >
                    <img src="@/assets/group-5.svg" class="Group-5" />
                    <button
                      class="text-green"
                      @click="addMoreRow('income_loss')"
                    >
                      Add More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      For Updated Attachements  please download the existing document and zip it with new document and upload
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn text="Cancel" type="secondary" @click="
            showPopupIncomeLossFromHousingProperty =
              !showPopupIncomeLossFromHousingProperty;toast=false;getItSubmissionData()
          " />
                    <btn
                      text="Validate"
                      type="primary"
                      @click="saveDataForFinalArray('income_loss_property')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div
          v-if="currentyearjoined"
          class="pr-0 cursor-point"
          @click="
            showPopupIncomeFromPreviousEmployer =
              !showPopupIncomeFromPreviousEmployer;toast=false
          "
        >
          <div   class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/incomeFromPreviousEmployer.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">Income from Previous Employer <span v-if="isPrevEmployeeEmp=='Approved'" style="color:green">(Validated)</span><span v-if="isPrevEmployeeEmp=='Pending'" style="color:orange">(Pending)</span></div>
              <div class="sub-heading-details-sm">
                It's not mandatory that you should report your previous employer
                salary income and TDS amount deducted.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupIncomeFromPreviousEmployer"
          @back="
            showPopupIncomeFromPreviousEmployer =
              !showPopupIncomeFromPreviousEmployer;toast=false;getItSubmissionData();
          "
          header="Income From Previous Employer"
        >
          <template v-slot:content>
             <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
        <itProof-submit-dataTable
             :tableColumsHeader="income_from_previos_employee_colums_header"
              :tableColumnsData="income_from_previous_employee_table_columns_data"
            >
             <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'particulars'"
                >
                  <span style="width: 12rem">{{
                    previousEmployerNames[slotprops.value.record.name] 
                  }}</span>
                  <!-- <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.planned }}
                </span>
                  <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status!='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.actual }}
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='rejected'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <!-- <txt
                 v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                      slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                  >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                {{ slotprops.value.record.actual }}
              </span>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p>

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                {{ slotprops.value.record.actual }}
              </span> -->
                <txt
                  v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.approved = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <!-- <p v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p> -->

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                 <!-- <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'section_ten_exemption',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button> -->
                
                <!-- <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                 
                </button> -->
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected' "
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                
                  style="width: 14rem;"
                 
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>

                 <div v-if="slotprops.value.column.key == 'action'" class="d-flex justify-space-around">
                
                <v-toolbar-items class="hidden-sm-and-down">

                <v-menu offset-y>
                
                  <v-btn
                      class="act-btn"
                      slot="activator"
                      
                    >
                      Act
                    </v-btn>

                    <v-list>
                      <v-list-tile
                        v-for="(i, index) in menuItems" 
                        :key="index"
                      >
                      <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'income_from_previous_employee')">{{ i.title}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                </v-menu>

                </v-toolbar-items>
               </div>
              </template>
            </itProof-submit-dataTable>
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 20px;
                
                margin: 20px 0px;
              "
            >
              <!-- <textarea
                class="form-control"
                name="remarks"
                v-model="
                  income_from_previous_employee_table_columns_data[0].remarks
                "
              /> -->
              <button
                style="width: 12rem; background-color: #e3c449; align-items:center"
                @click="
                  show_pop_up(
                    income_from_previous_employee_table_columns_data,
                    'income_from_previous_employee'
                  )
                "
                v-if="
                income_from_previous_employee_table_columns_data[0].file_location
                "
                class="export-button"
              >
                <img src="@/assets/clip.svg" />
                <label style="cursor: pointer">View Attachment</label>
              </button>
              <!-- <button
                style="width: 12rem; cursor: default"
                v-if="
                  !income_from_previous_employee_table_columns_data[0].file_location
                "
                class="export-button"
               
              >
              
                <label class="input-label" :for="`file-inputprev`">
                  <img src="@/assets/clip.svg" />
                  <p>No Attachment</p>
                </label>
              
               
              </button> -->
                 <button
                  style="width:10rem; cursor: default"
                  
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-inputprev`"
                   
                  >
                    <img title="Upload Document in case the submitted document is not valid" src="@/assets/upload1.svg" />
                   
                  </label>
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-inputprev`"
                    name="attachment"
                    @change="
                       uploadAttachments(
                      $event.target.files,
                      income_from_previous_employee_table_columns_data,
                      1,
                      'income_from_previous_employee'
                    )
                    "
                  />
                </button>
              <button
                style="width: 12rem; cursor: default"
                class="export-button"
                v-if="
                  !income_from_previous_employee_table_columns_data[0].file_location
                "
              >
                <label :for="`file-inputHRA`" class="input-label">
                  <img src="@/assets/clip.svg" />
                  <p>No Attachment</p>
                </label>
                <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
               
              </button>
                <!-- <p v-if="!income_from_previous_employee_table_columns_data[0][0].file_location && income_from_previous_employee_table_columns_data[0][0].actual" style="font-size:small;color:red;">Document is Mandatory </p> -->

            </div>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      For Updated Attachements  please download the existing document and zip it with new document and upload
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="
                        showPopupIncomeFromPreviousEmployer =
                          !showPopupIncomeFromPreviousEmployer;toast=false;getItSubmissionData()
                      "
                    />
                    <btn
                      text="Validate"
                      type="primary"
                      @click="
                        saveDataForFinalArray('income_from_previous_employee')
                      "
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div
         
          class="pl-0 cursor-point"
          @click="showPopupOtherIncome = !showPopupOtherIncome;toast=false"
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/other_income.svg"/>
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">Other Income <span v-if="isOtherIncomeEmp=='Approved'" style="color:green">(Validated)</span><span v-if="isOtherIncomeEmp=='Pending'" style="color:orange">(Pending)</span></div>
              <div class="sub-heading-details-sm">
                Other income is income that does not come from a company's main
                business, such as interest.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupOtherIncome"
          @back="showPopupOtherIncome = !showPopupOtherIncome;toast=false;getItSubmissionData();"
          header="Other Income"
        >
          <template v-slot:content >
             <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
            <itProof-submit-dataTable
              
              :tableColumsHeader="other_income_colums_header"
              :tableColumnsData="other_income_table_columns_data"
            >
              <template v-slot="slotprops">
               <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'particulars'"
                >
                  <span style="width: 12rem">{{
                    slotprops.value.record.name
                  }}</span>
                  <!-- <img
                    style="cursor: pointer"
                    title="information about icon for the arrangements of somethig"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  
                >
                  {{ slotprops.value.record.planned }}
                </span>
                   <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status!='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.actual }}
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='rejected'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <!-- <txt
                 v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                 @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                      slotprops.value.record.actual = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.actual"
                  >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                {{ slotprops.value.record.actual }}
              </span>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p>

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'submittedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                {{ slotprops.value.record.actual }}
              </span>  -->
                <txt
                  v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 10rem;"
                 
                  type="number"
                  @change="
                    (value) => {
                   
                    slotprops.value.record.approved = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' )"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <!-- <p v-if="slotprops.value.column.key == 'verifiedAmount' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.approved>slotprops.value.record.actual" style="font-size:small;color:red;">Verified Amount should not be greater than submitted amount</p> -->

                 <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount' && (slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                  
                >
                  {{ slotprops.value.record.approved }}
                </span>
                 <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'other_income',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                
                <button
                  style="width:10rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.actual && slotprops.value.record.status=='rejected'
                  "
                   
                  class="export-button1"
                >
                  <label
                    class="input-label"
                    :for="`file-input80DDB${slotprops.value.index}`"
                   
                  >
                    <img src="@/assets/upload1.svg" />
                   
                  </label> 
                  <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80DDB${slotprops.value.index}`"
                    name="attachment"
                    @change="
                       uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'other_income'
                      )
                    "
                  />
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                    :disabled="!slotprops.value.record.file_location"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>No Attachment</p>
                  </label>
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected' "
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status.toUpperCase() }}</span>
                </span>
                  <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                  @blur="uploadValidation('section_ten_exemption')"
                  style="width: 14rem;"
                 
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                      
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>

                 <div  v-if="slotprops.value.column.key == 'action'" class="d-flex justify-space-around">
                
                <v-toolbar-items class="hidden-sm-and-down">

                <v-menu offset-y>
                
                  <v-btn
                      class="act-btn"
                      slot="activator"
                      
                    >
                      Act
                    </v-btn>

                    <v-list>
                      <v-list-tile
                        v-for="(i, index) in menuItems" 
                        :key="index"
                      >
                      <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'other_income')">{{ i.title}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                </v-menu>

                </v-toolbar-items>
               </div>
              </template>
            </itProof-submit-dataTable>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      For Updated Attachements  please download the existing document and zip it with new document and upload
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="showPopupOtherIncome = !showPopupOtherIncome;toast=false;getItSubmissionData()"
                    />
                    <btn
                      text="Validate"
                      type="primary"
                      @click="saveDataForFinalArray('other_income')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
          <div
          v-show="enableTCS"
          class="pl-0 cursor-point"
          @click="showPopupOtherTaxTcs = !showPopupOtherTaxTcs;toast=false"
        > 
            <div class="row col-bg-gray">
              <div class="col-3 img-block">
                <img src="@/assets/other_income.svg" />
              </div>
              <div class="col-7 img-block">
                <div class="heading-text">Other Tax Collected at Source(TCS)</div>
                <div class="sub-heading-details-sm">
                  Enter details of any Tax Collected at Source (TCS) that you have paid during the financial year
                </div>      
              </div>
              <div class="col-2 arrow-left-align">  
                <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
              </div>
            </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupOtherTaxTcs"
          @back="showPopupOtherTaxTcs = !showPopupOtherTaxTcs;toast=false;getItSubmissionData();"
          header="Other Tax Collected at Source(TCS)"
        >
          <template v-slot:content>
            <toast-message
              :message="errmsg"
              type="error"
              :isToastEnable="toast"
              @close="(val) => (toast = val)"
            />
            <div>
              <div
                style="
                  display: flex;
                  width: 100%;
                "
              >
                <div class="heading-text">
                  Tax Collected at Source (TCS) Details
                </div>
                <div 
  class="align-center"
  style="display: flex; align-items: end; gap: 5px; margin-left:12px; margin-bottom:10px;padding-bottom:10px" 
>
  <img src="@/assets/group-5.svg" class="Group-5" />
  <button
    class="text-green"
    @click="addMoreRow('tcs_data')"
  >
    Add Row
  </button>
</div>              </div>
            </div>
            <itProof-submit-dataTable
              :tableColumsHeader="tcs_table_colums_header"
              :tableColumnsData="other_tcs_table_columns_data"
            >
              <template v-slot="slotprops">
                <tl-select
                  v-if="slotprops.value.column.key == 'section_display_name'"
                
                  name="tcs_section"
                  :options="tcs_section_options"
                  placeholder="Select Section"
                  v-model="slotprops.value.record.section_display_name"
                  @change="
                    (val) => {
                      slotprops.value.record.section_display_name = val;
                    }
                  "
                />
                <txt
                  v-if="slotprops.value.column.key == 'name_of_collector'"
                 
                  style="width: 12rem"
                  type="text"
                  @Change="
                    (value) => {
                      slotprops.value.record.name_of_collector = value;
                    }
                  "
                  v-model="slotprops.value.record.name_of_collector"
                >
                </txt>
                <txt
                  v-if="slotprops.value.column.key == 'tan_of_collector'"
             
                  style="width: 12rem"
                  type="text"
                  @Change="
                    (value) => {
                      slotprops.value.record.tan_of_collector = value;
                    }
                  "
                  v-model="slotprops.value.record.tan_of_collector"
                >
                </txt>
                <span
                  :disabled="true"
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'planned'"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'actual' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending'||slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='partially_approved')"
                >
                  {{ slotprops.value.record.actual }}
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'actual' && slotprops.value.record.status!='rejected' && slotprops.value.record.status!='audit_approved' && slotprops.value.record.status!='partially_approved' && slotprops.value.record.status!='Pending'"
               
                  style="width: 10rem"
                  type="number"
                  @Change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <txt
                  v-if="slotprops.value.column.key == 'approved' && slotprops.value.record.status=='partially_approved'&&slotprops.value.record.status!='rejected'&&slotprops.value.record.status!='Pending'&&slotprops.value.record.status!='audit_approved'"
                  style="width: 10rem;"
                  type="number"
                  @change="
                    (value) => {
                      slotprops.value.record.approved = value;
                    }
                  "
                  v-model="slotprops.value.record.approved"
                >
                </txt>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'approved' && (slotprops.value.record.status=='rejected' || slotprops.value.record.status=='Pending' || slotprops.value.record.status=='audit_approved' || slotprops.value.record.status=='approved')"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'tcs_attachment',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'attachment' &&
                    slotprops.value.record.file_path
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'attachment' &&
                    !slotprops.value.record.file_path
                  "
      
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-inputTCS${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment a</p>
                  </label>
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-inputTCS${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'tcs_attachment'
                      )
                    "
                  />
                </button>
                <span
                  style="display: flex; gap: 2px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'audit_approved' || slotprops.value.record.status == 'approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending' || slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'not_approved' || slotprops.value.record.status =='rejected'"
                    src="@/assets/rejected.png"
                  />
                  <span>{{ slotprops.value.record.status ? slotprops.value.record.status.toUpperCase() : 'PENDING' }}</span>
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'remarks'"
                  style="width: 14rem;"
                  type="text"
                  @change="
                    (value) => {
                      slotprops.value.record.remarks = value;
                    }
                  "
                  v-model="slotprops.value.record.remarks"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'remarks' && (slotprops.value.record.status=='partially_approved'||slotprops.value.record.status=='rejected') && !slotprops.value.record.remarks" style="font-size:small;color:red;">Remarks is Mandatory</p>
                <div v-if="slotprops.value.column.key == 'action'" class="d-flex justify-space-around">
                  <v-toolbar-items class="hidden-sm-and-down">
                    <v-menu offset-y>
                      <v-btn
                        class="act-btn"
                        slot="activator"
                      >
                        Act
                      </v-btn>
                      <v-list>
                        <v-list-tile
                          v-for="(i, index) in menuItems" 
                          :key="index"
                        >
                          <v-list-tile-title style="cursor:pointer" @click="getValues(i.title,slotprops.value.index,'tcs_data')">{{ i.title}}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                </div>
              </template>
            </itProof-submit-dataTable>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      IncomeTax proof Submission window will be closing soon
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="showPopupOtherTaxTcs = !showPopupOtherTaxTcs;toast=false;getItSubmissionData()"
                    />
                    <btn
                      text="Validate"
                      type="primary"
                      @click="saveDataForFinalArray('tcs_data')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
      </div>
      <bottom-action-container>
        <template>
        <div style="display: flex; flex-direction: column">
          <p style="font-size: large; font-weight: 700">
            Instruction
          </p>
          <p style="color:red">
            Uploading Attachments allow only PDF, PNG, ZIP, JPG upto 20MB
         </p>
          </div>
        </template>
        <template slot="end">
          <btn-grp>
            <btn type="secondary" text="Back" @click='isAuditorValidatedAllSection = true'></btn>
            <btn v-show="!incomeTaxProofSubmittedFlag" :disabled="allowOtherSections" text="Complete Validation" type="primary" @click="finalValidation()" />
            <!-- <btn v-show="!incomeTaxProofSubmittedFlag" style="font-size:medium" text="Validation Completed" type="secondary" @click="download12BBUrl(BB_12_url)" /> -->
          </btn-grp>
        </template>
      </bottom-action-container>

      <pop-up-message
        v-if="showSuccessMsg"
        :message="pop_up_message"
        btnText="OK"
        @back="goBack"
      ></pop-up-message>
       <pop-up-message
        v-if="attachementPop"
        message="File uploaded successfully"
        btnText="OK"
        @back="goBack"
      ></pop-up-message>
      <pop-up-message
        v-if="dateSuccess"
        message="IT proof has not submitted by employee"
        :popupType="'Warning'"
        :popupHeaderMessage="'IT Proof not Submitted'"
        btnText="OK"
        @back="goBack"
      ></pop-up-message>
      <pop-up-message
        v-if="isAuditorValidated"
        message="Please Validate and Perform Action on all Section"
        :popupType="'Warning'"
        :popupHeaderMessage="'Validation Pending'"
        btnText="OK"
        @back="goBack"
      ></pop-up-message>
      <pop-up-message
        v-if="isAuditorValidatedAllSection"
        message="Ensure all sections are validated before saving, otherwise your changes will not be saved."
        :popupType="'Warning'"
        :popupHeaderMessage="'Warning'"
        @back="isAuditorValidatedAllSection = false"
      >
        <template v-slot:bottomContent>
          <div class="popup-btn-group">
            <button class="btn-popup-secondary" type="button" @click="isAuditorValidatedAllSection = false">Cancel</button>
            <button class="btn-popup" type="button" @click="backHome()">OK</button>
          </div>
        </template>
      </pop-up-message>
    </div>
  </div>
</template>
<script>
import * as globalConfig from "@/apis/config.js";
const crypto = require("crypto");
import { createDecipheriv } from 'crypto';
import {S3} from "aws-sdk";
// import AWSS3UploadAshClient from "aws-s3-upload-ash";
import { mapGetters, mapActions, mapState } from "vuex";
import ItProofSubmitDataTable from "../../mysalary/incomeTax/houseRentdeclaration.vue";
import ExemptionUnderSectionDeduction from "../incometax/exemptionUnderSectionDeduction.vue";
import DeductionUnderCdeu from "../incometax/deductionsUnderCdeu.vue";
import DeductionUnderSectionSixteen from "../incometax/deductionUnderSectionSixteen.vue";
import ExemptionUnderSectionSeventeen from "../incometax/exemptionUnderSectionSeventeen.vue";
import IncomeFromPreviousEmployer from "../incometax/incomeFromPreviousEmployer";
import OtherIncome from "../incometax/otherIncome.vue";
import axios from "axios";
import IncomeLossFromHousingProperty from "../incometax/incomeLossFromHousingProperty.vue";
export default {
  components: {
    ExemptionUnderSectionDeduction,
    DeductionUnderCdeu,
    DeductionUnderSectionSixteen,
    ExemptionUnderSectionSeventeen,
    IncomeFromPreviousEmployer,
    OtherIncome,
    IncomeLossFromHousingProperty,
    ItProofSubmitDataTable,
  },

  data() {
    return {
      namesToAddIsDisabled: [
        "B Less: municipal Taxes Paid",
        "C (A-B) Net Annual Value",
        "D (C* 30%) Less: Standard Deduction @ 30%",
        "E Less: Interest on Housing Loan",
        "F (C-D-E) Income/Loss on House Property",
      ],
      previousEmployerNames: {
        salary_income: "Salary Income",
        pt: "Professional Tax",
        vpf: "Voluntary Provident Fund",
        pf: "Provident Fund",
        nps: "National Pension Scheme",
        tds: "Tax Deducted at Source",
      },
      BB_12_url:"",
      tempArray:[],
      showDiv:false,
      showDivforletout:false,
      DownloadAllDocuments:"",
      clientCodeBoolen:true,
      clientCode:["AD1BG","TSEMB","TWCDL","M8DMB","PPR55","PPR57","PPR58","PBTPL","NB005"],
      showDeleteConfirmation:false,
      incomeTaxProofSubmittedFlag:true,
      BBPayload:"",
      checkBoxFlag:true,
      finalSubmitFlag:true,
      employeeDetailsPayload:[],
      nameToRelationship: {},
      isPrevEmployerEnabled: false,
      e_code: "",
      form12BB_pop_up: false,
      allowOtherSections: false,
      errmsg: "",
      toast: false,
      pancardRegex: "",
      attachementPop:false,
      showPopupUnder80DDB: false,
      showPopupUnder80D: false,
      showPopupUnder80DD: false,
      pop_up_80DD_header:"",
      pop_up_80DDB_header:"",
      pop_up_header_80D:"",
      it_plan_id: "",
      dateCheck: "",
      dateSuccess: false,
      isAuditorValidated:false,
      isAuditorValidatedAllSection:false,
      pop_up_message: "",
      it_financial_year: "",
      net_taxable_income: "",
      total_tax: "",
      tax_to_be_paid: "",
      fetchUrl: "",
      employeeObj: null,
      fiscalYearEnd: "",
      fiscalYearEndPlus:"",
      fiscalYearStart: "",
      checkRange: false,
      PlanName: null,
      file_location_hra: "",
      file_location_income: "",
      file_location_previous: "",
      file_name_previous: "", 
      isSec10:false,
      isHra:false,
      isDeduction6A:false,
      isIncomeLoss: false,
      isPrevEmployee: false,
      isOtherIncome: false,   
      isSec10Emp:"",
      isHraEmp:"",
      isDeduction6AEmp:"",
      isIncomeLossEmp: "",
      isPrevEmployeeEmp: "",
      isOtherIncomeEmp:"" ,
      section_ten_attachments_pop_up: false,
      house_rent_attachments_pop_up: false,
      deduction_under_6A_attachments_pop_up: false,
      income_loss_from_house_attachments_pop_up: false,
      income_from_previous_employee_pop_up: false,
      other_income_attachments_pop_up: false,
      showPopupHouseRentDeclaration: false,
      showPopupSalaryPerks: false,
      showPopupTdsBreakupOldRegimePopup: false,
      showPopupItDeclarationStatmentOldRegimePopup: false,
      showPopupTdsBreakupNewRegimePopup: false,
      showPopupItDeclarationStatmentNewRegimePopup: false,
      showPopupExemptionUnderSectionDeduction: false,
      showPopupDeductionUnderCdeu: false,
      showPopupDeductionUnderSectionSixteen: false,
      showPopupExemptionUnderSectionSeventeen: false,
      showPopupIncomeFromPreviousEmployer: false,
      showPopupOtherIncome: false,
      showPopupIncomeLossFromHousingProperty: false,
      showConfirmationMsg: false,
    
      uploaded_attachment_name: "",
      exemptionSection: "Exemption Under Section 10",
      attachments_pop_up_header: "Attachments",
      upload_loader: false,
      house_rent_declaration_city: "",
      metro_city_options: ["Delhi", "Mumbai", "Kolkata", "Chennai", "Bengaluru", "Hyderabad", "Ahmedabad", "Pune", "Other"],
      employeeFamilyDetails: [],
      options_for_relationship: [
        "Self",
        "Spouse",
        "Son",
        "Daughter",
        "Mother",
        "Father",
      ],
      options_for_80u_percentage: [
        "Less than 40%",
        "More than 40% < 80%",
        "More than 80%",
      ],
      options_for_6a_family_dependant: [],
      attachment_pop_up_table_columns_data: [],
      attachment_pop_up_column_header: [
        {
          label: "Attachment",
          key: "attachment",
        },
        {
          label: "File Name",
          key: "fileName",
        },
        {
          label: "View File",
          key: "viewFile",
        },
        {
          label: "Remove File",
          key: "removeFile",
        },
      ],
       auditTableColumns: [
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Declared Amount",
          key: "declaredAmount"
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount"
        },
        {
          label: "Verfied Amount",
          key: "verfiedAmount",
          style: "text-align:right;"
        },
        {
          label: "Proof",
          key: "proof"
        },
        {
          label: "Status",
          key: "status"
        },
        {
           label: "Remarks",
          key: "remarks"
        },
        {
           label: "Action",
          key: "action"
        },

      ],
      auditTableColumns6A: [
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Declared Amount",
          key: "declaredAmount"
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount"
        },
        {
          label: "Verfied Amount",
          key: "verfiedAmount",
          style: "text-align:right;",
        },
        {
          label: "Proof",
          key: "proof"
        },
        {
          label: "Status",
          key: "status"
        },
        {
           label: "Remarks",
          key: "remarks"
        },
        {
           label: "Action",
          key: "action"
        },

      ],
        menuItems: [
        { title: 'Approve' },
        { title: 'Reject' },
        { title: 'Partially Approve' },
        
      ],
      currentyearjoined :false ,
      showPopupFamilyDetaila: false,
      showPopupOtherTaxTcs: false,
      other_tcs_attachment_pop_up: false,
      enableTCS: false,
      other_tcs_table_columns_data : [],

      tcs_section_options: [
        "206CA - Collection at source from alcoholic liquor for human",
        "206CB - Collection at source from timber obtained under forest lease",
        "206CC - Collection at source from timber obtained by any mode other than a forest lease",
        "206CD - Collection at source from any other forest produce (not being tendu leaves)",
        "206CE - Collection at source from any scrap",
        "206CF - Collection at source from contractors or licensee or lease relating to parking lots",
        "206CG - Collection at source from contractors or licensee or lease relating to toll plaza",
        "206CH - Collection at source from contractors or licensee or lease relating to mine or quarry",
        "206CI - Collection at source from tendu Leaves",
        "206CJ - Collection at source from on sale of certain Minerals",
        "206CK - Collection at source on cash case of Bullion and Jewellery",
        "206CL - Collection at source on sale of Motor vehicle",
        "206CM - Collection at source on sale in cash of any goods(other than bullion/jewelry)",
        "206CN - Collection at source on providing of any services(other than Chapter-XVII-B)",
        "206CO - Collection at source on remittance under LRS for purchase of overseas tour program package",
        "206CP - Collection at source on remittance under LRS for educational loan taken from financial institution mentioned in section 80E",
        "206CQ - Collection at source on remittance under LRS for purpose other than for purchase of overseas tour package or for educational loan taken from financial institution",
        "206CR - Collection at source on sale of goods",
        "206CT - Collection at source on remittance under LRS is for the purposes of education or medical treatment and not covered under Code P"
      ],
      tcs_table_colums_header: [
        {
          key: "section_display_name",
          label: "Section under which Tax Collected at source",
        },
        {
          key: "name_of_collector",
          label: "Name of the Collector",
        },
        {
          key: "tan_of_collector",
          label: "TAN of the Collector",
        },
        {
          key: "planned",
          label: "Declared Amount",
        },
        {
          key: "actual",
          label: "Submitted Amount",
        },
        {
          key: "approved",
          label: "Verified Amount",
        },
        {
          key: "attachment",
          label: "Attachment",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "remarks",
          label: "Remarks",
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      deduction_under_80DD_table_columns_data: [],
      deduction_under_80DDB_table_columns_data:[],
      deduction_under_80C_table_columns_data: [],
      deduction_under_80D_table_columns_data: [],
      deduction_under_others_table_columns_data: [],
      deduction_under_80G_table_columns_data: [],
      deduction_under_80U_table_columns_data: [],
      income_from_previous_employee_table_columns_data: [],
      other_income_table_columns_data: [],
      deduction_under_80D_pop_up:[],
      deduction_under_80DD_pop_up:[],
      other_income_colums_header: [
        {
          label: "Particulars",
          key: "particulars",
          style: "width:12rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:12rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:8rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
           style: "font-weight:bold;text-align:left;width:10rem;",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
        {
          label: "Action",
          key: "action",
        },
      ],
      income_from_previos_employee_colums_header: [
        {
          label: "Particulars",
          key: "particulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        // {
        //   label: "Proof",
        //   key: "proof",
        //   style: "width:8rem;",
        // },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
        {
          label: "Action",
          key: "action",
        },
      ],
      deduction_under_80C_table_colums_header: [
        {
          label: " 80C Particulars1111",
          key: "80Cparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
        {
          label: "Action",
          key: "action"
        },

      ],
      deduction_under_80DD_table_colums_header: [
        {
          label: "80DD Particulars",
          key: "80DDparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
        {
           label: "Action",
          key: "action"
        },
      ],
      deduction_under_80DDB_table_colums_header: [
        {
          label: "80DDB Particulars",
          key: "80DDBparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
        {
           label: "Action",
          key: "action"
        },
      ],
      deduction_under_80D_table_colums_header: [
        {
          label: "80D Particulars",
          key: "80Dparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
        {
           label: "Action",
          key: "action"
        },
      ],
      deduction_under_others_table_colums_header: [
        {
          label: "Particulars",
          key: "particulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
        {
           label: "Action",
          key: "action"
        },
      ],
      deduction_under_80G_table_colums_header: [
        {
          label: "80G Particulars",
          key: "80Gparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
        {
           label: "Action",
          key: "action"
        },
      ],
      deduction_under_80T_table_colums_header: [
        {
          label: "80T Particulars",
          key: "80Tparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
        {
           label: "Action",
          key: "action"
        },
      ],
      deduction_under_80U_table_colums_header: [
        {
          label: "80U Particulars",
          key: "80Uparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
        {
           label: "Action",
          key: "action"
        },
      ],
      house_rent_declaration_array: [],
      temp_HRA: [],
      family_details_table_columns_data: [
        {
          name: "Akash",
          relationship: "",
          dependencies: "",
          age: "",
        },
      ],
      family_details_table_colums_header: [
        {
          label: "Name",
          key: "particulars",
        },
        {
          label: "Relationship",
          key: "relationship",
        },
        {
          label: "Date of Birth",
          key: "dob",
        },
        {
          label: "Age",
          key: "age",
        },
        {
          label: "",
          key: "delete",
        },
      ],
      sec_ten_exemption_table_colums_header: [
        {
          label: "Particulars",
          key: "particulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      house_rent_table_colums_header: [
        {
          label: "Particulars",
          key: "particulars",
          style: "width:14rem;",
        },
        {
          label: "Amount",
          key: "amount",
          style: "width:12rem;",
        },
        {
          label: "Owner Name",
          key: "ownerName",
          style: "width:12rem;",
        },
        {
          label: "Owner PAN Number",
          key: "ownerPanNumber",
          style: "width:14rem;",
        },
        {
          label: "Metro City",
          key: "metroCity",
          style: "width:14rem;",
        },
      ],
      incomeLossTableColumsHeaderOne: [
        {
          label: "(i)Interest on housing loan (Self occupied)",
          key: "interestOnHousingLoan",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
        {
           label: "Action",
          key: "action"
        },
      ],
      incomeLossTableColumsHeaderTwo: [
        {
          label: "(i)Income/Loss from house property(Letout)",
          key: "income/lossOnHouse",
          style: "width:12rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:14rem",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
        {
           label: "Action",
          key: "action"
        },
      ],
      income_loss_from_house_table_columns_data_one: [],
      income_loss_from_house_table_columns_data_three: [
        {
          joint_holder_name: "",
          relationship: "",
          tax_benefit: "",
        },
      ],
      income_loss_from_house_table_columns_data_letout_joint_Property: [
        {
          joint_holder_name: "",
          relationship: "",
          tax_benefit: "",
        },
      ],
      permanent_disability_under_80D_header: [
        {
          label: "Name",
          key: "name",
          style: "width:8rem;",
        },
        {
          label: "Relationship",
          key: "relationship",
        },
        {
          label: "Amount",
          key: "amount",
        },
        {
          label: "",
          key: "delete",
        },
      ],
      permanent_disability_under_80DDB_header: [
        {
          label: "Name",
          key: "name",
          style: "width:8rem;",
        },
        {
          label: "Relationship",
          key: "relationship",
        },
        {
          label: "Amount",
          key: "amount",
        },
        {
          label: "",
          key: "delete",
        },
      ],
      handicapped_disability_under_80DD_data: [
        {
          name: "",
        },
      ],
      income_loss_from_house_table_columns_data_two: {
        letout: [],
        joint_property_details:[]   
      },
      deduction_under_80DDB_pop_up_data:[],
      income_loss_from_house_table_columns_data_total: {},
      house_rent_table_columns_data: [
        {
          particulars: "01-Apr-2020 to 30-Apr-2023",
          amount: 40000,
          ownerName: "",
          ownerPanNumber: "",
          metroCity: "",
        },
        {
          particulars: "01-Apr-2020 to 30-Apr-2023",
          amount: 40000,
          ownerName: "",
          ownerPanNumber: "",
          metroCity: "",
        },
        {
          particulars: "01-Apr-2020 to 30-Apr-2023",
          amount: 40000,
          ownerName: "",
          ownerPanNumber: "",
          metroCity: "",
        },
        {
          particulars: "01-Apr-2020 to 30-Apr-2023",
          amount: 40000,
          ownerName: "",
          ownerPanNumber: "",
          metroCity: "",
        },
        {
          particulars: "01-Apr-2020 to 30-Apr-2023",
          amount: 40000,
          ownerName: "",
          ownerPanNumber: "",
          metroCity: "",
        },
      ],
      sec_ten_exemption_table_columns_data: [],
      promiseIP:[],
      form12BBDate:"",
      employeeName:'',
      bankPanRegex:"",
      personal: {
        first_name: null,
        last_name: null,
        code: null,
      },
      salary: {
        ctc: null,
        salary_structure_id: null,
        exempt_for_it_deduction_first_month: false,
        master_salary_structure: [],
      },
      it_plan_id: "",
      employeeId: "",
      instance: {
        le_id: "",
        employee_id: "",
        financial_year: "",
        it_plan_id: "",
      },
      data2: {
        exemption10: [],
        exemption17: [],
        deductionsUnderSection16: [],
        deductionsUnderChapterVIA: [],
        section24: [],
        previousEmploymentDetails: {},
        otherIncome: [],
        le_id: "",
        employee_id: "",
        financial_year: "",
        plan_id: "",
        regime_type: "",
      },

      salaryPerk: [],
      tds_breakup_and_taxable_income: [],
      itSheet: [],
      first_name: "",
      last_name: "",
      ctc: "",
      code: "",
      totalIncomeTax: "",
      annualTax: "",
      showSuccessMsg: false,
      totalAmount_otherIncome: "",
      totalAmount_previousEmpDetails: "",
      show80DFamilyPopup: false,
      show80DSeniorParentsPopup: false,
      show80DParentsPopup: false,
      show80DFamilySeniorParentsPopup: false,
      showInterestonEducationPopup: false,
      showInterestonHomeonePopup: false,
      showInterestonHometwoPopup: false,
      showInterestonEVPopup: false,
      showNPSEmployeeContributionPopup: false,
      showNPSEmployerContributionPopup: false,
      showInterestFromSavingAccount: false,
      showInterestFromSavingAccountforseniorcitizen: false
    };
  },
  computed: {
    ...mapState({
      payrollYear: (state) => state.payroll.runpayroll.payrollYear,
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getleData: "onboard/legal_entities/record",
      getITSettingsData: "onboard/statutoryinfo/incometax/getITData",
    }),
    ...mapState({
      globalData: (state) => state.globalapi.globalData.data,
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifHr() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
    ifEmployee() {
      return localStorage.getItem("userRole") == "EMPLOYEE" ? true : false;
      },
  ifAuditor() {
      return localStorage.getItem("userRole") == "AUDITOR" ? true : false;
    },  
    empId() {
      
      return this.$route.query.id
    },
    emailId() {
      return localStorage.getItem("loginId");
    },
    // showDiv() {
    //   return this.income_loss_from_house_table_columns_data_three && this.income_loss_from_house_table_columns_data_three[0] && this.income_loss_from_house_table_columns_data_three[0].joint_holder_name ? true : false;
    // },
  },
  mounted() {
    this.salaryTableData = [];
    // this.isDateInRange()
    this.fetchRecord();
    this.pancardRegex = globalConfig.Regex.IT_EMPLOYEE_PAN;
    this.bankPanRegex = globalConfig.Regex.BANK_PAN;
    // this.itProofDocumentDownload()
    this.getItSubmissionData();
    this.ipAddressFunction();
     setInterval(this.timeFunction,10000)
    (this.section_ten_attachments_pop_up = false),
      (this.house_rent_attachments_pop_up = false),
      (this.deduction_under_6A_attachments_pop_up = false),
      (this.income_loss_from_house_attachments_pop_up = false),
      (this.income_from_previous_employee_pop_up = false),
      (this.other_income_attachments_pop_up = false);
  },
  activated() {
    //this.fetchAllSalaryStructureData();
    this.salaryTableData = [];
    //this.setRecordData();
    this.fetchRecord();
    setInterval(this.timeFunction,60000)
    this.attachments_pop_up = false;
    this.getItSubmissionData();
  },
  updated() {
    setInterval(this.timeFunction,60000)
    this.house_rent_declaration_array = this.house_rent_declaration_array;
    // this.getItSubmissionData();
    //console.log(this.house_rent_declaration_array, "updated");
  },
  methods: {
    ...mapActions({
      act_getProfileData:
        "dashboard/payroll/monthlypayroll/employeeProfile/fetchAll",
      getAllItProofSubmissionData: "dashboard/itProof/fetchAll",
      form12BBURL:"dashboard/itProof/form12BBURL",
      allDocumentsURL: "dashboard/itProof/allDocumentsDownload",
      uploadFileToS3Bucket:"dashboard/itProof/uploadFileToS3Bucket", 
      form12BBupdateURL:"dashboard/itProof/update12BBURL",
      postAllITProofData: "dashboard/itProof/postAllITProofData",
      act_get_plan: "dashboard/payroll/incometax/getPlan",
      act_fetchEmpById: "onboard/employees/fetchEmpDataById",
      fetchEmployeeCode: "onboard/employees/fetchEmployeeCode",
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_fetchsalarycomponents:
        "onboard/settings/salary_component/fetchAllsalaryComponentsData",
      act_set_it_data: "dashboard/payroll/incometax/setItData",
      act_save_it_plan: "dashboard/payroll/incometax/createItData",
      act_fetch_plan_name: "dashboard/payroll/incometax/getPlanName",
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      getPreSignedUrl: "payroll/lopsandrlops/createPreSigned",

    }),
    addOneMoreRow(){
        if (this.income_loss_from_house_table_columns_data_three.length < 4) {
                    this.income_loss_from_house_table_columns_data_three.push({
                      joint_holder_name: "",
                      relationship: "",
                      tax_benefit: "",
                    });
                  }
    },
    async itProofDocumentDownload(){
      try{
        let payload={
          empCode:this.e_code,
          leid:this.le_id,
          year:this.it_financial_year,
        }
        let data = await this.encryptData(payload); 
        // console.log(data,"data")
     let res= await this.allDocumentsURL(data);
     console.log("allDocumentsURLRessssssssssssss",res)
     let apiResponse = JSON.parse(await this.decryptOne(res));
      console.log("apiResponse",apiResponse)
      this.DownloadAllDocuments=apiResponse.data.pdfPreSignedUrl 
      }catch(err){
        this.errmsg =err
        this.toast =true
      }
    },
    async ipAddressFunction(){
      this.promiseIP = await fetch("https://api.ipify.org?format=json")
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            return data.ip;
          })
    },
    show6APopup(keys){
      if(keys=="Medical Insurance Premium Self & Family"){        
        this.show80DFamilyPopup = true;
      }
      else if(keys=="Medical Insurance Premium Parents Sr. Citizen"){        
        this.show80DSeniorParentsPopup = true;
      }
      else if(keys=="Medical Insurance Premium Parents"){        
        this.show80DParentsPopup = true;
      }
      else if(keys=="Medical Insurance Premium Self & Family Sr. Citizen"){        
        this.show80DFamilySeniorParentsPopup = true;
      }
      else if(keys=="Interest on Education Loan"){        
        this.showInterestonEducationPopup = true;
      }
      else if(keys=="Interest on Home Loan (Availed during 2016-17)"){        
        this.showInterestonHomeonePopup = true;
      }
      else if(keys=="Interest on Home Loan (Availed during 2019-20 for the first house)"){        
        this.showInterestonHometwoPopup = true;
      }
      else if(keys=="Interest on Purchase of Electric vehicles (Availed after 1st April 2019)"){        
        this.showInterestonEVPopup = true;
      }
      else if(keys=="NPS Employee Contribution"){        
        this.showNPSEmployeeContributionPopup = true;
      }
      else if(keys=="NPS Employer Contribution"){        
        this.showNPSEmployerContributionPopup = true;
      }
      else if(keys=="Interest from Savings Bank Account"){        
        this.showInterestFromSavingAccount = true;
      }
      else if(keys=="Interest from Savings Bank Account - Sr Citizens"){        
        this.showInterestFromSavingAccountforseniorcitizen = true;
      }
            
    },
     showConfirmMessageFunction(){
     this.showDeleteConfirmation=true;
     },
     timeFunction(){
      var formBBDate = new Date()
      var hours = formBBDate.getHours()
      var minutes = formBBDate.getMinutes()
      var ampm = hours >= 12 ? 'pm' : 'am';
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      this.form12BBDate = formBBDate.getDate()+"/"+(formBBDate.getMonth()+1)+"/"+formBBDate.getFullYear()+" "+strTime
     },
    relationChange(val, index,record) {
        switch(record){
          case '80_d_popup':
         
            let isPresent80D = this.deduction_under_80D_pop_up.some(obj => obj.name === val.name)
            if (isPresent80D) {
              
              this.toast = true
               this.errmsg="Dependents Cannot be same"  
              this.deduction_under_80D_pop_up.splice(index,1)
            } else {
              //console.log("absent")
              this.deduction_under_80D_pop_up[index].relationShip = val.relationship;
               this.deduction_under_80D_pop_up[index].name = val.name;
              }
             
            break;
          case '80_ddb_popup':
           let isPresent80DDB = this.deduction_under_80DDB_pop_up_data.some(obj => obj.name === val.name)
            if (isPresent80DDB) {
              
              this.toast = true
               this.errmsg="Dependencies Cannot be same"  
              this.deduction_under_80DDB_pop_up_data.splice(index,1)
            } else {
              //console.log("absent")
              this.deduction_under_80DDB_pop_up_data[index].relationShip = val.relationship;
               this.deduction_under_80DDB_pop_up_data[index].name = val.name;
              }
          break;
          case '80_dd_popup':
           let isPresent80DD = this.deduction_under_80DD_pop_up.some(obj => obj.name === val.name)
            if (isPresent80DD) {
              
              this.toast = true
               this.errmsg="Dependencies Cannot be same"  
              this.deduction_under_80DD_pop_up.splice(index,1)
            } else {
              //console.log("absent")
              this.deduction_under_80DD_pop_up[index].relationShip = val.relationship;
               this.deduction_under_80DD_pop_up[index].name = val.name;
              }
          break;
        }
      },
    function_for_chapter6A(record, value, index) {
      switch (value) {
        
        case 'deduction_under_80D':
          this.deduction_under_80D_pop_up=[]
         this.showPopupUnder80D = true 
          this.pop_up_header_80D = (record.InvestmentComponentType.name || slotprops.value.record.name)
          // console.log(this.pop_up_header_80D,"header")
          if (this.pop_up_header_80D == "Medical Insurance Premium Parents") {
            //  console.log("header")
           let options= this.options_for_6a_family_dependant.filter((item) => item.relationship == "Mother" || item.relationship == "Father")
              this.options_for_6a_family_dependant=options
            // console.log(this.options_for_6a_family_dependant)
          }
          else if (this.pop_up_header_80D == "Medical Insurance Premium Self & Family Sr. Citizen") {
            let options= this.options_for_6a_family_dependant.filter((item) => item.age>60)
            this.options_for_6a_family_dependant=options
          }
          else if (this.pop_up_header_80D == "Preventive Health Check Up Upto 5000 Part of Above") {
             let options= this.options_for_6a_family_dependant.filter((item) => item.relationship == "Mother" || item.relationship == "Father"|| item.relationship == "Self")
              this.options_for_6a_family_dependant=options
          } else if (this.pop_up_header_80D == "Medical Insurance Premium Parents Sr. Citizen") {
            let options= this.options_for_6a_family_dependant.filter((item) => item.age>60 && item.relationship == "Mother" || item.relationship == "Father" )
            this.options_for_6a_family_dependant=options
          }
          
          if (record.family_details) {
          this.deduction_under_80D_pop_up = record.family_details  
          } else {
            this.deduction_under_80D_pop_up.push({
              name: "",
              relationShip: "",
              amount: "",
            });
          }
        
            
          break;
        case "deduction_under_80DD":
          this.deduction_under_80DD_pop_up=[]
           this.showPopupUnder80DD = true
          this.pop_up_80DD_header = (record.InvestmentComponentType.name || slotprops.value.record.name)
              // console.log("header")
           let options= this.options_for_6a_family_dependant.filter((item) => item.relationship != "Self")
              this.options_for_6a_family_dependant=options
          if (record.family_details) {
          this.deduction_under_80DD_pop_up = record.family_details  
          } else {
            this.deduction_under_80DD_pop_up.push({
              name: "",
              relationShip: "",
              amount: "",
            });
          }
        
          break;
        case "deduction_under_80DDB":
            this.deduction_under_80DDB_pop_up_data=[]
           this.showPopupUnder80DDB = true
          this.pop_up_80DDB_header = (record.InvestmentComponentType.name || slotprops.value.record.name)
          if (this.pop_up_80DDB_header == "Medical Treatment Expenses - Specified Diseases Sr Citizen") {
            // console.log("header")
            let options = this.options_for_6a_family_dependant.filter((item) => item.age > 60)
            this.options_for_6a_family_dependant = options
          }
          else if (this.pop_up_80DDB_header == "Medical Treatment Expenses - Specified Diseases") {
           let options= this.options_for_6a_family_dependant.filter((item) => item.relationship == "Mother" || item.relationship == "Father"|| item.relationship == "Self")
              this.options_for_6a_family_dependant=options
          }
             if (record.family_details) {
          this.deduction_under_80DDB_pop_up_data = record.family_details  
          } else {
            this.deduction_under_80DDB_pop_up_data.push({
              name: "",
              relationShip: "",
              amount: "",
            });
          }
        
          break;

      }
    },
    function_from_chapter6a_popup(header, record) {
    //  console.log("header",header,record) 
      var totalAmount = 0;
       switch(record){
        case "pop_up_80d":
        this.deduction_under_80D_pop_up.map((record) => {
            totalAmount += Number(record.amount);
            this.deduction_under_80D_table_columns_data && this.deduction_under_80D_table_columns_data.map((record,index)=>{
          if(record.InvestmentComponentType && record.InvestmentComponentType.name == header){
          this.deduction_under_80D_table_columns_data[index].actual= totalAmount;
          this.deduction_under_80D_table_columns_data[0].family_details = this.deduction_under_80D_pop_up
         }else if(record.name&&record.name == header){
          this.deduction_under_80D_table_columns_data[index].actual= totalAmount;
          this.deduction_under_80D_table_columns_data[0].family_details = this.deduction_under_80D_pop_up
         }
      })
          });
          this.showPopupUnder80D = false; 
          break;
          case "pop_up_80dd" :
          this.deduction_under_80DD_pop_up.map((record) => {
            totalAmount += Number(record.amount);
            this.deduction_under_80DD_table_columns_data && this.deduction_under_80DD_table_columns_data.map((record,index)=>{
          if(record.InvestmentComponentType && record.InvestmentComponentType.name == header){
          this.deduction_under_80DD_table_columns_data[index].actual= totalAmount;
          this.deduction_under_80DD_table_columns_data[0].family_details = this.deduction_under_80DD_pop_up
         }else if(record.name&&record.name == header){
          this.deduction_under_80DD_table_columns_data[index].actual= totalAmount;
          this.deduction_under_80DD_table_columns_data[0].family_details = this.deduction_under_80DD_pop_up
         }
      })
          });
          this.showPopupUnder80DD = false
          break;
          case "pop_up_80ddb" :
          this.deduction_under_80DDB_pop_up_data.map((record) => {
            totalAmount += Number(record.amount);
            this.deduction_under_80DDB_table_columns_data && this.deduction_under_80DDB_table_columns_data.map((record,index)=>{
          if(record.InvestmentComponentType&&record.InvestmentComponentType.name == header){
          this.deduction_under_80DDB_table_columns_data[index].actual= totalAmount;
          this.deduction_under_80DDB_table_columns_data[0].family_details = this.deduction_under_80DDB_pop_up_data
         }else if(record.name&&record.name == header){
          this.deduction_under_80DDB_table_columns_data[index].actual= totalAmount;
          this.deduction_under_80DDB_table_columns_data[0].family_details = this.deduction_under_80DDB_pop_up
         }
      })
          });
          this.showPopupUnder80DDB = false
          break;
       }
      
     
    },
    addMoreRows() {
      if (this.income_loss_from_house_table_columns_data_three.length < 4) {
        this.income_loss_from_house_table_columns_data_three.push({
          joint_holder_name: "",
          relationship: "",
          tax_benefit: "",
        });
      }
    },
    checkSelfJointHolder(val,ind) {
      //console.log(val, ind, this.income_loss_from_house_table_columns_data_three, val, ind, "hello")
      const sumobject = this.income_loss_from_house_table_columns_data_three.reduce((sum, obj) => sum + obj.tax_benefit,0)
      //console.log(sumobject,"hiii")
      if (sumobject > 100) {
        //console.log("true");
        this.income_loss_from_house_table_columns_data_three[ind].tax_benefit = 0
         window.alert("Tax benefit claimed by joint holder cannot exceed more than 100%")
      } else {
        //console.log("false");
        this.toast = false
           this.income_loss_from_house_table_columns_data_three[ind].tax_benefit=val
        }
       
    },
    checkLetOutJointHolder(val,ind) {
      //console.log(val, ind, this.income_loss_from_house_table_columns_data_letout_joint_Property, val, ind, "hello")
      const sumobject = this.income_loss_from_house_table_columns_data_letout_joint_Property.reduce((sum, obj) => sum + obj.tax_benefit,0)
      //console.log(sumobject,"hiii")
      if (sumobject > 100) {
        //console.log("true");
        this.income_loss_from_house_table_columns_data_letout_joint_Property[ind].tax_benefit = 0
       window.alert("Tax benefit claimed by joint holder cannot exceed more than 100%")
      } else {
        //console.log("false");
        this.toast = false
           this.income_loss_from_house_table_columns_data_letout_joint_Property[ind].tax_benefit=val
        }
       
    },
    deleteRow(value, index, relation) {
      //console.log(value, index, "dlete");
      // console.log(this.house_rent_declaration_array.details);
      switch (value) {
        case "family_details":
          this.employeeFamilyDetails[0].details[index].isDelete = true;
          if (
            relation == "Self" ||
            relation == "Mother" ||
            relation == "Father"
          ) {
            if (!this.options_for_relationship.includes(relation)) {
              this.options_for_relationship.unshift(relation);
            }
          }
          this.employeeFamilyDetails[0].details.splice(index,1)
          break;
        case "house_rent_declaration":
        this.house_rent_declaration_array.details.splice(index,1)
          // this.house_rent_declaration_array.details[index].isDelete = true;
          break;
        case "deduction_under_6a_80u":
          this.deduction_under_80U_pop_up_data.splice(index, 1);
          break;
        case "deduction_under_6a_80DD":
          this.deduction_under_80DD_pop_up.splice(index,1);
          break;
          case "deduction_under_6a_80DDB":
          this.deduction_under_80DDB_pop_up_data.splice(index,1);
          break;
        case "income_loss":
          this.income_loss_from_house_table_columns_data_three.splice(index, 1);
          break;
        case "income_loss_letout":
          this.income_loss_from_house_table_columns_data_letout_joint_Property.splice(index, 1);
          break;
        case "deduction_under_6a_80D":   
        this.deduction_under_80D_pop_up.splice(index,1);
        break;
          case "tcs_data":
          this.other_tcs_table_columns_data.splice(index, 1);
          break;
      }
      //console.log(this.house_rent_declaration_array.details, "hra");
    },
    addMoreRow(value, header) {
      switch (value) {
        case "family_details":
          this.employeeFamilyDetails[0].isSave = false;
          this.allowOtherSections =
            this.employeeFamilyDetails[0].isSave == false ? true : false;
          this.employeeFamilyDetails[0].details.push({
            name: "",
            relationship: "",
            dependencies: "",
            age: "",
            isDelete: false,
            dob: "",
          });
          //console.log(this.employeeFamilyDetails[0], "data");
          break;
        case "house_rent_declaration":
          
          const date = new Date(
            this.house_rent_declaration_array.details[
              this.house_rent_declaration_array.details.length - 1
            ]["to"]
          ); 
          let year1 = date.getFullYear()
          let month1 = date.getMonth()
          let day1 = date.getDate()
          let year2 = new Date(this.fiscalYearEnd).getFullYear()  
          let month2 = new Date(this.fiscalYearEnd).getMonth()
          let day2=new Date(this.fiscalYearEnd).getDate()
          // console.log(year1,month1,day1,"next",year2,month2,day2,"boolean",year1 != year2 && month1 != month2 && day1 != day2);
          if (year1 !== year2 || month1 !== month2 || day1 !== day2) {
             this.house_rent_declaration_array.details.push({
            metro: false,
            from: date.setDate(date.getDate() + 1),

            to: new Date(this.fiscalYearEnd),
            isDelete: false,
            value: "",
            ownerDetails: {
              metro: "non_metro",
              panNumber: "",
              state: "",
            },
          });
          } else {
            this.toast = true;
            this.errmsg = "You can enter details for Current Financial Year only"  
            setTimeout(() => {
              this.toast=false
            }, 3000);
          }
         
          //console.log(this.house_rent_declaration_array, "last");
          break;
        case "income_loss":
          if (this.income_loss_from_house_table_columns_data_three.length < 4) {
            this.income_loss_from_house_table_columns_data_three.push({
              joint_holder_name: "",
              relationship: "",
              tax_benefit: "",
            });
          }
        case "income_loss_letout":
          if(this.income_loss_from_house_table_columns_data_letout_joint_Property.length < 4){
            this.income_loss_from_house_table_columns_data_letout_joint_Property.push({
              joint_holder_name:"",
              relationship:"",
              tax_benefit:"",
            })
          }
        case "deduction_under_6a_80DD":
          this.deduction_under_80DD_pop_up.push({
              name: "",
              relationShip: "",
              amount: "",
            })
        case "deduction_under_6a_80DDB":
          this.deduction_under_80DDB_pop_up_data.push({
            name: "",
            relationShip: "",
            amount: "",
          });
             case "tcs_data":
          this.other_tcs_table_columns_data.push({
            section_display_name: "",
            name_of_collector: "",
            tan_of_collector: "",
            planned: 0,
            actual: 0,
            approved: 0,
            file_path: "",
            file_name: "",
            status: false,
            remarks: ""
          });
          break;
        case "deduction_under_6a_80D":   
        this.deduction_under_80D_pop_up.push({
              name: "",
              relationShip: "",
              amount: "",
            })
      }
    },
    removeTime() {
      this.house_rent_declaration_array.details.map((item, index) => {
        if (index > 0) {
          item.from = "";
          // item.to=""  
          }   
      })
    },
    sendMetroValue(val, index) {
      //console.log(val, index, "metro");
      if (val != "Other") {
        this.house_rent_declaration_array.details[index].metro = true;
        this.house_rent_declaration_array.details[index].ownerDetails.metro =
          "metro";
        this.house_rent_declaration_array.details[index].ownerDetails.state =
          val;
      } else {
        this.house_rent_declaration_array.details[index].metro = false;
        this.house_rent_declaration_array.details[index].ownerDetails.metro =
          "non_metro";
      }
    
    },

    calculateAge(dob, index) {
      
      var dob = new Date(dob);
      if (dob == null || dob == "") {
        this.errmsg = "Please enter Valid DOB";
        this.toast = true;
      } else {
       
        var month_diff = Date.now() - dob.getTime();

        
        var age_dt = new Date(month_diff);

        
        var year = age_dt.getUTCFullYear();

        
        var age = Math.abs(year - 1970);
        
        this.employeeFamilyDetails[0].details[index].age = age;
        
      }
    },
    checkRelationship(relation) {
      
      if (relation == "Self" || relation == "Mother" || relation == "Father" || relation == "Spouse") {
        
        var index = this.options_for_relationship.indexOf(relation);
        if (index !== -1) {
          
          this.options_for_relationship.splice(index, 1);
        }
      
      }
   
    },
    childValidation() {
      // console.log("child");
      if (
         this.employeeFamilyDetails[0].no_of_children<this.employeeFamilyDetails[0].no_of_school_children ||this.employeeFamilyDetails[0].no_of_children<this.employeeFamilyDetails[0].no_of_hostel_children 
      ) {
        
        this.employeeFamilyDetails[0].no_of_children = 0;
        this.employeeFamilyDetails[0].no_of_school_children = 0;
        this.employeeFamilyDetails[0].no_of_hostel_children = 0;
        this.toast = true;
        this.errmsg = "Please Enter Valid Children Details";
        
      } else if (this.employeeFamilyDetails[0].no_of_hostel_children> this.employeeFamilyDetails[0].no_of_school_children) {
        this.employeeFamilyDetails[0].no_of_children = 0;
        this.employeeFamilyDetails[0].no_of_school_children = 0;
        this.employeeFamilyDetails[0].no_of_hostel_children = 0;
         this.toast = true;
        this.errmsg = "No. of Hostel going children cannot be greater than school going";
      }
      else {
      this.toast=false  
      }
    },
    isDateInRange(dateToCheck, fromDate, toDate) {
      const startDate = new Date('2023-01-01'); // Replace with your start date
      const endDate = new Date('2024-02-01');
      const checkDate=new Date()
      this.dateCheck = checkDate >= startDate && checkDate <= endDate
      if (this.dateCheck) {
        this.dateSuccess=true  
      }
      // console.log("time check",this.dateCheck,this.dateSuccess)
    },

    // Function to check if a date falls within any date range in the array
    // isDateInRange(arrayOfObjects, targetDate) {
    
    //   for (let i = 0; i < arrayOfObjects.length - 1; i++) {
    //     const fromDate = new Date(arrayOfObjects[i].from);
    //     const toDate = new Date(arrayOfObjects[i].to);

    //     if (targetDate >= fromDate && targetDate <= toDate) {
    //       return true; // Target date is within the range
    //     }
    //   }

    //   return false; // Target date is not within any range
    // },
    // checkResult(date) {
    //   if (this.isDateInRange(this.house_rent_declaration_array.details, date)) {
    //     console.log(`${date.toISOString()} is within a date range.`);
    //   } else {
    //     console.log(`${date.toISOString()} is not within a date range.`);
    //   }
    // },
    prevEmployeeValidation() {
     
     return !this.income_from_previous_employee_table_columns_data.some(el => el.actual > 0 )
    },
    prevEmployeeChange(val,index) {
      //console.log("values", val, index, "all", this.income_from_previous_employee_table_columns_data);
      this.income_from_previous_employee_table_columns_data[0][index].actual = val
      this.toast=false
      for (let i = 1; i < this.income_from_previous_employee_table_columns_data[0].length; i++){
        if (this.income_from_previous_employee_table_columns_data[0][i].actual >= this.income_from_previous_employee_table_columns_data[0][0].actual) {
          this.income_from_previous_employee_table_columns_data[0][i].actual = 0
          if (index != 0) {
             this.toast = true; 
            this.errmsg = `${this.previousEmployerNames[this.income_from_previous_employee_table_columns_data[0][index].name]} cannot be greater than Salary Income`  
          }
        
          
        } else if (i == 1 && this.income_from_previous_employee_table_columns_data[0][i].actual > 2500) {
          this.income_from_previous_employee_table_columns_data[0][index].actual = 0
          this.toast = true;
       //console.log("elseif");  
          this.errmsg = `${this.previousEmployerNames[this.income_from_previous_employee_table_columns_data[0][index].name]} cannot exceed Rs.2500`
          break;   
        } 
      }

    },
    uploadValidation(value) {
      switch (value) {
        case "section_ten_exemption":
          return this.sec_ten_exemption_table_columns_data && this.sec_ten_exemption_table_columns_data.some(function (el) {
            return (el.status == 'audit_approved' &&(el.file_location == null))||(el.status == 'partially_approved' && (!el.remarks||(el.file_location == null))) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
          });
          break;
          case "other_income":
           
          return this.other_income_table_columns_data && this.other_income_table_columns_data.some(function (el) {
          return (el.status == 'audit_approved' &&(el.file_location == null || !el.file_location))||(el.status == 'partially_approved' && (!el.remarks||(el.file_location == null || !el.file_location))) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");

          });
          break;
         case "income/loss_from_house":
        
            return this.income_loss_from_house_table_columns_data_two.letout && this.income_loss_from_house_table_columns_data_two.letout.some(function(el,index){
              if(index == 0){
                console.log(el.status)
              return (el.status == 'audit_approved' &&(el.file_location == null || !el.file_location))||(el.status == 'partially_approved' && (!el.remarks|| (el.file_location == null || !el.file_location))) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
              }
          });
          break;
            case "income/loss_self":
     
          // console.log(this.income_loss_from_house_table_columns_data_one);
                
            return this.income_loss_from_house_table_columns_data_one && this.income_loss_from_house_table_columns_data_one.some(function(el){
             
            return (el.status == 'audit_approved' &&(el.file_location == null || !el.file_location))||(el.status == 'partially_approved' && (!el.remarks|| (el.file_location == null || !el.file_location))) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
          });
          break;
        case "deduction_under_chapter_four_80C":
          return this.deduction_under_80C_table_columns_data && this.deduction_under_80C_table_columns_data.some(function (
            el
          ) {
             return (el.status == 'audit_approved' &&(el.file_location == null || !el.file_location))||(el.status == 'partially_approved' && (!el.remarks|| (el.file_location == null || !el.file_location))) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
          });
          break;
        case "deduction_under_chapter_four_80D":
          return this.deduction_under_80D_table_columns_data && this.deduction_under_80D_table_columns_data.some(function (
            el
          ) {
            return (el.status == 'partially_approved' && !el.remarks) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");

          });
          break;
         case "deduction_under_chapter_four_80DD":
         return this.deduction_under_80DD_table_columns_data && this.deduction_under_80DD_table_columns_data.some(function (
            el
          ) {
            return (el.status == 'partially_approved' && !el.remarks) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
          });
          break;
          case "deduction_under_chapter_four_80DDB":
         return this.deduction_under_80DDB_table_columns_data && this.deduction_under_80DDB_table_columns_data.some(function (
            el
          ) {
            return (el.status == 'partially_approved' && !el.remarks) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
          });
          break;
        case "deduction_under_chapter_four_others":
          return this.deduction_under_others_table_columns_data && this.deduction_under_others_table_columns_data.some(function (
            el
          ) {
            return (el.status == 'partially_approved' && !el.remarks) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
          });
          break;
        case "deduction_under_chapter_four_80G":
          return this.deduction_under_80G_table_columns_data && this.deduction_under_80G_table_columns_data.some(function (
            el
          ) {
            return (el.status == 'partially_approved' && !el.remarks) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
          });
          break;
        case "deduction_under_chapter_four_80U":
          return this.deduction_under_80U_table_columns_data && this.deduction_under_80U_table_columns_data.some(function (
            el
          ) {
            return (el.status == 'partially_approved' && !el.remarks) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
          });
          break;
        case "deduction_under_6A":
          return (
           this.deduction_under_80U_table_columns_data && this.deduction_under_80U_table_columns_data.some(function (el) {
              return (el.status == 'audit_approved' &&(el.file_location == null || !el.file_location))||(el.status == 'partially_approved' && (!el.remarks|| (el.file_location == null || !el.file_location))) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
            }) ||
           this.deduction_under_80C_table_columns_data && this.deduction_under_80C_table_columns_data.some(function (el) {
              return(el.status == 'audit_approved' &&(el.file_location == null || !el.file_location))||(el.status == 'partially_approved' && (!el.remarks|| (el.file_location == null || !el.file_location))) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
            }) ||
            this.deduction_under_80D_table_columns_data && this.deduction_under_80D_table_columns_data.some(function (el) {
              return (el.status == 'audit_approved' &&(el.file_location == null || !el.file_location))||(el.status == 'partially_approved' && (!el.remarks|| (el.file_location == null || !el.file_location))) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
            })  ||
           this.deduction_under_80G_table_columns_data &&  this.deduction_under_80G_table_columns_data.some(function (el) {
              return (el.status == 'audit_approved' &&(el.file_location == null || !el.file_location))||(el.status == 'partially_approved' && (!el.remarks|| (el.file_location == null || !el.file_location))) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
            })||
           this.deduction_under_80DD_table_columns_data && this.deduction_under_80DD_table_columns_data.some(function (el) {
             return (el.status == 'audit_approved' &&(el.file_location == null || !el.file_location))||(el.status == 'partially_approved' && (!el.remarks|| (el.file_location == null || !el.file_location))) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
            }) ||
           this.deduction_under_80DDB_table_columns_data && this.deduction_under_80DDB_table_columns_data.some(function (el) {
              return (el.status == 'audit_approved' &&(el.file_location == null || !el.file_location))||(el.status == 'partially_approved' && (!el.remarks|| (el.file_location == null || !el.file_location))) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
            }) ||
           this.deduction_under_others_table_columns_data && this.deduction_under_others_table_columns_data.some(function (el) {
              return (el.status == 'audit_approved' &&(el.file_location == null || !el.file_location))||(el.status == 'partially_approved' && (!el.remarks|| (el.file_location == null || !el.file_location))) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved");
            })
            
          );
          break;
        case "family_details":
            return this.employeeFamilyDetails[0].details && this.employeeFamilyDetails[0].details.some(function (el) {
            return !el.dob || !el.name || !el.relationship;
          });
          break;
        case "hra_section":
          return this.house_rent_declaration_array.details && this.house_rent_declaration_array.details.some(function (el) {
            return  (el.status !='audit_approved' && !el.remarks||(el.file_location && el.status=="Pending" || el.status=="not_approved"))
          });
          break;
        case "previous_employee":
          let value = this.income_from_previous_employee_table_columns_data && this.income_from_previous_employee_table_columns_data.some((el, ind) => { if (ind == 0) {return el.actual > 0 } })
          let value2 = this.income_from_previous_employee_table_columns_data && this.income_from_previous_employee_table_columns_data.some((el, ind) => { if (ind == 0) {return el.actual <= 0} })
          // return (el.status == 'partially_approved' && !el.remarks) || (el.status == 'rejected' && !el.remarks);
          return this.income_from_previous_employee_table_columns_data && this.income_from_previous_employee_table_columns_data.some(function (el, ind) {
           
            return (el.status == 'partially_approved' && !el.remarks) || (el.status == 'rejected' && !el.remarks)||(el.file_location && el.status=="Pending" || el.status=="not_approved") ;

            
           
          });  
          break;
            case "tcs_data":
             return this.other_tcs_table_columns_data && this.other_tcs_table_columns_data.some(function (el) {
            return  (el.status !='audit_approved' && !el.remarks||(el.file_location && el.status=="Pending" || el.status=="not_approved"))
          });
          break;

      }
    },

    async uploadAttachments(value, record, index, belongs) {
      //console.log("belongs", index, record, belongs);
      this.upload_loader = true;
      //console.log(value)
      var config = {
        bucketName:  process.env.VUE_APP_IT_DOCUMENT ? "payliefuat" :"payliefprod" ,
        dirName: `income_tax_proof_submissions/${this.le_id}/${this.it_financial_year}/${this.e_code}/auditor_uploaded/${belongs}/` /* optional - when use: e.g BUCKET_ROOT/dirName/fileName.extesion */,
        region: "ap-south-1",
        accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY,
        secretAccessKey: process.env.VUE_APP_AWS_SECRET_KEY,
        s3Url: "https://paylief.s3.amazonaws.com/",
      };
      var baseUrl = `https://paylief.s3.${config.region}.amazonaws.com`;
     if (value.length != 0 && value[0].size <21348301 ) {
        this.uploaded_attachment_name = value[0].name;
        let formData = new FormData();
        formData.append("file", value[0]);
        formData.append("fileName",value[0].name.replace(/[\s()]+/g, '_'));
        formData.append("bucketName",config.bucketName);
        formData.append("path",config.dirName);
        try{
          let res = await this.uploadFileToS3Bucket(formData)
          this.attachementPop=true
          this.fetchUrl = res.payload
          if (this.fetchUrl) {
            // console.log(this.fetchUrl, belongs)
            switch (belongs) {
              case "section_ten_exemption":
                // console.log(this.sec_ten_exemption_table_columns_data[index])
                this.sec_ten_exemption_table_columns_data[index].file_location =
                  this.fetchUrl;
                this.sec_ten_exemption_table_columns_data[index].file_name =
                  value[0].name;
                  // console.log(this.sec_ten_exemption_table_columns_data[index].file_location)
                break;
              case "income_loss_letout_property":
                this.income_loss_from_house_table_columns_data_two.letout[
                  index
                ].file_location = this.fetchUrl;
                this.income_loss_from_house_table_columns_data_two.letout[
                  index
                ].file_name = value[0].name;
               
                break;
              case "income_loss_self":
               
                this.file_location_income = this.fetchUrl;
                this.income_loss_from_house_table_columns_data_one[
                  index
                ].file_location = this.file_location_income;
                this.income_loss_from_house_table_columns_data_one[
                  index
                ].file_name = value[0].name;
                console.log(
                  "final",
                  this.income_loss_from_house_table_columns_data_one
                );
                break;
              case "house_rent_declaration":
                this.file_location_hra = this.fetchUrl;
                this.house_rent_declaration_array.file_name = value[0].name;
                this.house_rent_declaration_array.file_location =
                  this.file_location_hra;

                break;
              case "deduction_under_chapter_VI_A_80C":
                this.deduction_under_80C_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_80C_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "deduction_under_chapter_VI_A_80D":
                this.deduction_under_80D_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_80D_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "deduction_under_chapter_VI_A_80DD":
              this.deduction_under_80DD_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_80DD_table_columns_data[index].file_name =
                  value[0].name;
                break;
                case "deduction_under_chapter_VI_A_80DDB":
              this.deduction_under_80DDB_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_80DDB_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "deduction_under_chapter_VI_A_others":
                  // console.log(this.fetchUrl,value);
                this.deduction_under_others_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_others_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "deduction_under_chapter_VI_A_80G":
                this.deduction_under_80G_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_80G_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "deduction_under_chapter_VI_A_80U":
                this.deduction_under_80U_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_80U_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "other_income":
                this.other_income_table_columns_data[index].file_location =
                  this.fetchUrl;
                this.other_income_table_columns_data[index].file_name =
                  value[0].name;
                break;
                case "tcs_attachment":
                this.other_tcs_table_columns_data[index].file_path = this.fetchUrl;
                this.other_tcs_table_columns_data[index].file_name = value[0].name;
                break;
              case "income_from_previous_employee":
               
                this.file_location_previous = this.fetchUrl
              this.file_name_previous=  value[0].name
                this.income_from_previous_employee_table_columns_data[0].file_location = this.fetchUrl;
                this.income_from_previous_employee_table_columns_data[0].file_name = value[0].name;
            }
          }
          this.upload_loader = false;
          this.toast=false
        }catch(err){
          this.upload_loader = false;
          this.toast=true
          this.errmsg=err
        }
      } else {
        //console.log("else");
        this.upload_loader = false;
        this.toast = true
        this.errmsg="File Size Cannot Exceed More than 20MB"
      }

      //console.log(value, "value", record, "record");
    },
    closeTabs() {
       this.showPopupFamilyDetaila = false;
      this.showPopupExemptionUnderSectionDeduction = false;
      this.showPopupHouseRentDeclaration = false;
      this.showPopupDeductionUnderCdeu = false;
      this.showPopupIncomeFromPreviousEmployer = false;
      this.showPopupOtherIncome = false;
      this.showPopupExemptionUnderSectionDeduction = false;
      this.showPopupIncomeLossFromHousingProperty = false;
      this.form12BB_pop_up = false;
      this.incomeTaxProofSubmittedFlag = true
    },
    checkOwnerPan(pan_number, index) {
    //  console.log(pan_number,index,this.pancardRegex.test(pan_number))
      if (!this.pancardRegex.test(pan_number)) {
        // console.log("hiii")
        this.house_rent_declaration_array.details[index].ownerDetails.panNumber = ""
        
      }
      else {
          // console.log("helloi")
        this.house_rent_declaration_array.details[index].ownerDetails.panNumber=pan_number
      }  
    },
    checkBankPan(pan_number) {
      //  console.log(pan_number,this.bankPanRegex.test(pan_number))
      if (!this.bankPanRegex.test(pan_number)) {
        // console.log("hiii")
      this.income_loss_from_house_table_columns_data_one[0].bank_details.bank_pancard_number = ""
        
      }
      else {
          // console.log("helloi")
        this.income_loss_from_house_table_columns_data_one[0].bank_details.bank_pancard_number=pan_number
      }  
    },
    checkConditionTrue(...values) {
      console.log(values, "val")

      return values.filter(value => value === true).length;

    },

    checkConditionApproved(...values) {
      console.log(values,"val")
    
      return values.filter(value => value == 'Approved').length;



},

    async finalValidation() {
      console.log(this.isSec10, this.isSec10Emp,this.isDeduction6A, this.isDeduction6AEmp,this.isHra ,this.isHraEmp,this.isIncomeLoss,this.isIncomeLossEmp,this.isPrevEmployee, this.isPrevEmployeeEmp,this.isOtherIncome,this.isOtherIncomeEmp)
      console.log((this.isSec10 && this.isSec10Emp.toString().includes("Approved")) || (this.isHra && this.isHraEmp.toString().includes("Pending")))
      let result = this.checkConditionTrue(this.isSec10,this.isDeduction6A,this.isHra,this.isIncomeLoss,this.isPrevEmployee,this.isOtherIncome,this.isSec10Emp,this.isDeduction6AEmp,this.isHraEmp,this.isIncomeLossEmp,this.isPrevEmployeeEmp,this.isOtherIncomeEmp)
      let resultStr=this.checkConditionApproved(this.isSec10Emp,this.isDeduction6AEmp,this.isHraEmp,this.isIncomeLossEmp,this.isPrevEmployeeEmp,this.isOtherIncomeEmp,this.isSec10,this.isDeduction6A,this.isHra,this.isIncomeLoss,this.isPrevEmployee,this.isOtherIncome)
      console.log(result,"valid",resultStr,"app")
      
      if (result===resultStr) {
        this.backendArrayData.isAuditValidated=true
        this.it_proof_submission("final_submit")
        console.log("hii")
          
      } else {
        this.isAuditorValidated = true
          console.log("hello")
      }
    },
    backHome(){      
      this.isAuditorValidatedAllSection = false
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxproofapproval`,
      });
    },
    saveDataForFinalArray(value) {
      switch (value) {
        case "section_ten_exemption": 
          if (this.uploadValidation(value)) {
              
              window.alert("Please perfom actions for all the submitted value")
          } else {
            this.backendArrayData.section10.section10Others =
            this.sec_ten_exemption_table_columns_data;
            this.backendArrayData.isDraft = true;
            this.backendArrayData.isSec10Save = true;
            this.backendArrayData.isSec10SaveEmp = "Approved";
            this.it_proof_submission(value);
          }
         
          //console.log(this.uploadValidation(), "hello");
          break;
        case "hraSection":
          if (this.uploadValidation('hra_section')) {
            window.alert("Please perfom actions for all the submitted value")
              
          }else {
            this.backendArrayData.section10["HRA"].approved =
            this.house_rent_declaration_array;
            this.backendArrayData.section10["HRA"].status = "APPROVED"     
            this.backendArrayData.isDraft = true;
            this.backendArrayData.isHraSave = true
           this.backendArrayData.isHraSaveEmp="Approved"
            this.it_proof_submission(value);
         }
          
          // this.backendArrayData.section10["HRA"].actual=this.house_rent_declaration_array
          break;

        case "employee_family_details":
          //console.log(this.uploadValidation('family_details') || this.toast); 
          if(this.uploadValidation('family_details') || this.toast){
            window.alert("Please Enter Missing Fields")
          } else {
             this.allowOtherSections = false;
          this.employeeFamilyDetails.map((record) => {
            record.isSave = true;
          });
          this.backendArrayData.employeeFamily = this.employeeFamilyDetails;
          this.backendArrayData.isDraft = true;
          this.it_proof_submission(value);
           }
         
          //console.log("family", this.backendArrayData);
          break;
        case "income_loss_property":
          //  console.log(this.uploadValidation('income/loss_self') ,"to kmow", this.uploadValidation('income/loss_from_house'))
          // console.log(this.uploadValidation('income/loss_self') || this.uploadValidation('income/loss_from_house'))
          if (this.uploadValidation('income/loss_self') || this.uploadValidation('income/loss_from_house')) {
             window.alert("Please perfom actions for all the submitted value")

          } else {
            this.income_loss_from_house_table_columns_data_one[0].total_approved = Number("-"+Math.abs(this.income_loss_from_house_table_columns_data_one[0].total_approved))
            this.income_loss_from_house_table_columns_data_one[0].joint_property_details =
            this.income_loss_from_house_table_columns_data_three;
          this.income_loss_from_house_table_columns_data_two.joint_property_details =
            this.income_loss_from_house_table_columns_data_letout_joint_Property
          this.backendArrayData.section24.letOutProperty[0].letOut =
            this.income_loss_from_house_table_columns_data_two.letout;
          this.backendArrayData.section24.letOutProperty[0].joint_property_details =
            this.income_loss_from_house_table_columns_data_two.joint_property_details;
          let arr = this.income_loss_from_house_table_columns_data_one;
          let finalObj = {};
          for (let i = 0; i < arr.length; i++) {
            Object.assign(finalObj, arr[i]);
          }
          this.backendArrayData.section24.selfOccupied = finalObj;
          this.backendArrayData.section24.status = "APPROVED"
          this.backendArrayData.isDraft = true;
            this.backendArrayData.isIncomeLossSave = true  
            this.backendArrayData.isIncomeLossSaveEmp="Approved"   
          this.it_proof_submission(value);
          }
         
          break;
        case "deduction_under_6A":
          if (this.uploadValidation(value)) {
             window.alert("Please perfom actions for all the submitted value")
          } else {
            this.backendArrayData.section6a["80C"] =
            this.deduction_under_80C_table_columns_data;
          this.backendArrayData.section6a["80D"] =
            this.deduction_under_80D_table_columns_data;
          this.backendArrayData.section6a["Others"] =
            this.deduction_under_others_table_columns_data;
          this.backendArrayData.section6a["80G"] =
            this.deduction_under_80G_table_columns_data;
          this.backendArrayData.section6a["80U"] =
            this.deduction_under_80U_table_columns_data;
          this.backendArrayData.section6a["80DD"] =
            this.deduction_under_80DD_table_columns_data;
          this.backendArrayData.section6a["80DDB"] =
            this.deduction_under_80DDB_table_columns_data;
            this.backendArrayData.isDraft = true;
            this.backendArrayData.isDeduction6ASave = true
          this.backendArrayData.isDeduction6ASaveEmp="Approved"  
          this.it_proof_submission(value);
          }
          
          break;
        case "income_from_previous_employee":
          if (this.uploadValidation('previous_employee')) {
             window.alert("Please perfom actions for all the submitted value")
          } else {
            // console.log(this.income_from_previous_employee_table_columns_data,"data")
            var backendPreviousEmployeeArray =
            this.income_from_previous_employee_table_columns_data.map(
              (item) => {
                let key = item.name;
                var values = {
                  planned: item.planned,
                  actual: item.actual,
                  approved: item.approved,
                  file_location: item.file_location,
                  file_name: item.file_name,
                  status: item.status,
                  remarks:item.remarks   
                };
                return {
                  [key]: values,
                };
              }
              );
          // console.log("hiii prev",this.backendPreviousEmployeeArray)  
          this.backendArrayData.previousEmployment =
            backendPreviousEmployeeArray;
          
            this.backendArrayData.isDraft = true;
            this.backendArrayData.isPrevEmpSave = true  
          this.backendArrayData.isPreEmpSaveEmp="Approved"  
          this.it_proof_submission(value);
          }
         
          
          break;
        case "other_income":
          if (this.uploadValidation('other_income')) {
            window.alert("Please perfom actions for all the submitted value")
          } else {
            this.backendArrayData.otherIncome =
            this.other_income_table_columns_data;
            this.backendArrayData.isDraft = true;
            this.backendArrayData.isOtherSave = true 
          this.backendArrayData.isOtherSaveEmp="Approved"
          this.it_proof_submission(value);
          }
          
          break;
          case "tcs_data":
          console.log(this.uploadValidation('tcs_data'), "hello");
          if (this.uploadValidation('tcs_data')) {
            window.alert("Please perfom actions for all the submitted value")
          } else {
            this.backendArrayData.employeeTCS =
            this.other_tcs_table_columns_data;
            this.backendArrayData.isDraft = true;
            this.backendArrayData.isTcsSave = true 
          this.backendArrayData.isTcsSaveEmp="Approved"
          this.it_proof_submission(value);
          }
      }
    },
    show_pop_up(records, value, index) {
      //console.log("recor",records)
      switch (value) {
        case "section_ten_exemption":
          this.attachments_pop_up_header = "Section 10 Exemption";
          this.section_ten_attachments_pop_up = true;
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data = [];
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType.name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "house_rent_declaration":
          //console.log("im here at ");
          this.attachment_pop_up_table_columns_data = [];
          this.attachments_pop_up_header = "House Rent Allowance";
          this.showPopupHouseRentDeclaration = false;
          this.house_rent_attachments_pop_up = true;
          this.fetchUrl = this.house_rent_declaration_array.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: "House Rent Attachment",
            fileName: this.house_rent_declaration_array.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });

          break;
        case "deduction_under_80C":
          this.attachments_pop_up_header = "deduction_under_80C";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80D":
          this.attachments_pop_up_header = "deduction_under_80D";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80DD":
          this.attachments_pop_up_header = "deduction_under_80DD";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80DDB":
          this.attachments_pop_up_header = "deduction_under_80DDB";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80E":
          this.attachments_pop_up_header = "deduction_under_80E";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80G":
          this.attachments_pop_up_header = "deduction_under_80G";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80T":
          this.attachments_pop_up_header = "deduction_under_80T";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80U":
          this.attachments_pop_up_header = "deduction_under_80U";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_others":
          this.attachments_pop_up_header = "deduction_under_others";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          
})
          break;
        case "other_income":
          this.attachments_pop_up_header = "Other Income";
          this.showPopupOtherIncome = false;
          this.other_income_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name,
            index:index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;

        case "income_from_previous_employee":
          //console.log("hiii previous")
          this.attachments_pop_up_header = "Income From Previous Employer";
          this.showPopupIncomeFromPreviousEmployer = false;
          this.income_loss_from_house_attachments_pop_up = false;
          this.showPopupIncomeLossFromHousingProperty = false;
          this.income_from_previous_employee_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records[0].file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || "Income from Previous Employer",
            fileName: records[0].file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "income_loss_self_occuiped":
          this.attachments_pop_up_header = "Income_loss_self_occuiped";
          this.showPopupIncomeFromPreviousEmployer = false;
          this.income_loss_from_house_attachments_pop_up = true;
          this.showPopupIncomeLossFromHousingProperty = false;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || "Total Income",
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "income_loss_letout":
          this.attachments_pop_up_header = "Income_loss_letout";
          this.showPopupIncomeFromPreviousEmployer = false;
          this.income_loss_from_house_attachments_pop_up = true;
          this.showPopupIncomeLossFromHousingProperty = false;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || "Total Income",
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        
        case "tcs_attachment":
          this.attachments_pop_up_header = "Tax Collected at Source (TCS)";
          this.showPopupOtherTaxTcs = false;
          this.other_tcs_attachment_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_path;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.section_display_name || "TCS Attachment",
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        
      }
    },
    download12BBUrl(data)
    {
    axios({
              url:data,
              method:'GET',
              responseType: 'blob'
      })
      .then((res) => {
           const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download",'form12.BB'); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
      })
    },
    downloadAllDocumentsUrl(data)
    {
        this.upload_loader=true
        console.log("data",data)
           const url = data;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download",`${this.e_code}.zip`); //or any other extension
                document.body.appendChild(link);
                link.click(); 
        this.upload_loader = false
              
    },
    
    async preSignedUrlFunction() {
        try {
          let res = await this.getPreSignedUrl({
            url: this.fetchUrl
          });
          if (res.data.payload && res.data.payload.iv && res.data.payload.encryptedPacket) {
            const decryptedLink = await this.decrypt(res.data.payload);
            console.log("decryptedLink",decryptedLink)
            return decryptedLink;
          } else {
            console.log('Invalid payload structure');
            return null;
          } 
        } catch (e) {
          console.log('Error in preSignedUrlFunction:', e);
          return null; 
        }
      },
      async downloadUrl() {
      try {
        const downloadLink = await this.preSignedUrlFunction();
         console.log("downloadLinkdownloadLink",downloadLink)
        if (downloadLink) {
          let url = JSON.parse(downloadLink);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download",  this.attachment_pop_up_table_columns_data[0].fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          console.log('Failed to retrieve the download link.');
        }
      } catch (e) {
        console.error('Error during download:', e);
      }
    },
   

    
    deleteUrl(record,index,header) {
      switch(header){
      case 'Section 10 Exemption':
          this.section_ten_attachments_pop_up = false
      this.showPopupExemptionUnderSectionDeduction = true;  
        this.sec_ten_exemption_table_columns_data[record.index].file_location = "";
        this.sec_ten_exemption_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"; 
        break;
      case 'deduction_under_80C':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_80C_table_columns_data[record.index].file_location="";
        this.deduction_under_80C_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"; 
        break;
       case 'deduction_under_80D':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_80D_table_columns_data[record.index].file_location="";
        this.deduction_under_80D_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"; 
        break;
       case 'deduction_under_80DD':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_80DD_table_columns_data[record.index].file_location="";
        this.deduction_under_80DD_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"; 
         break;
       case 'deduction_under_80DDB':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_80DDB_table_columns_data[record.index].file_location="";
        this.deduction_under_80DDB_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break; 
        case 'deduction_under_others':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_others_table_columns_data[record.index].file_location="";
        this.deduction_under_others_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break; 
        case 'deduction_under_80G':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_80G_table_columns_data[record.index].file_location="";
        this.deduction_under_80G_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break; 
        case 'deduction_under_80U':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_80U_table_columns_data[record.index].file_location="";
        this.deduction_under_80U_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break;
        case 'House Rent Allowance':
          this.showPopupHouseRentDeclaration = true
        this.file_location_hra=""  
        this.house_rent_declaration_array.file_location = "";
        this.file_location_hra="";
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break;
        case 'Income_loss_self_occuiped':
          this.showPopupIncomeLossFromHousingProperty=true
          //console.log(this.income_loss_from_house_table_columns_data_one)
          this.income_loss_from_house_table_columns_data_one.map((item) => {
          item.total_actual=0  
          })
        this.income_loss_from_house_table_columns_data_one[0].file_location = "";
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break;
        case 'Income_loss_letout':
          //console.log(this.income_loss_from_house_table_columns_data_two);
          this.showPopupIncomeLossFromHousingProperty=true
          
          this.income_loss_from_house_table_columns_data_two.letout.map((item) => {
          item.actual=0  
          })
          this.income_loss_from_house_table_columns_data_two.letout[record.index].file_location = "";
        
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break;
        case 'Other Income':
        this.other_income_table_columns_data[record.index].file_location = "";
        this.other_income_table_columns_data[record.index].actual =0;
        this.showSuccessMsg = true;
          this.pop_up_message = "Attachment Deleted Successfully"
       this.showPopupOtherIncome = true;  
          break;
        case 'Income From Previous Employer':
         //console.log(this.income_from_previous_employee_table_columns_data)
        this.income_from_previous_employee_table_columns_data[0][0].file_location = "";
          this.file_location_previous = ""
        this.file_name_previous=""    
        this.income_from_previous_employee_table_columns_data[0].map(record=>{
          record.actual =0;
        })
        this.showSuccessMsg = true;
          this.pop_up_message = "Attachment Deleted Successfully"
         this.showPopupIncomeFromPreviousEmployer = true;  
        break;  
         case 'Other Tax Collected at Source(TCS)':
        this.other_tcs_table_columns_data[record.index].file_path = "";
        this.other_tcs_table_columns_data[record.index].actual = 0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        this.showPopupOtherTaxTcs = true;
        break;

       }
 
    },
    async decryptOne(payload) {
      try {
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, payload.iv);
        const decrypted = Buffer.concat([decipher.update(payload.encryptedPacket, 'base64'), decipher.final()]);
        return decrypted.toString();
      } catch (error) {
          console.log("eroorrrrrrrrrrrrrrrrrrrrrrrrrrrrr",error)
      }
    },
    async decrypt(payload) {
      const key = process.env.VUE_APP_PAYSLIP_SECRET;
      const decipher = createDecipheriv('aes-256-cbc', key, Buffer.from(payload.iv, 'hex'));
      const decrypted = Buffer.concat([
        decipher.update(payload.encryptedPacket, 'base64'),
        decipher.final()
      ]);

      return decrypted.toString();
    },
    async encryptData(payload) {
      try {
        const iv = crypto.randomBytes(8).toString('hex')
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
        let encryptedText = Buffer.concat([
          cipher.update(JSON.stringify(payload)),
          cipher.final()
        ]);
        return {
          iv: iv.toString(),
          encryptedPacket: encryptedText.toString('base64')
        }
      } catch (err) {
        throw err;
      }
    },
     async upload12BBmanual(data){
      try{   
             let formData = new FormData();
            formData.append("form12B", data[0]);
              let record={
                "legalEntityId":this.employeeDetailsPayload[0].legal_entity_id,
                "empCode":this.employeeDetailsPayload[0].code,
                 "payload":formData
              }
              let res = await this.form12BBupdateURL(record);
              if(res){
                this.showSuccessMsg = true;
                this.finalSubmitFlag=false
                this.pop_up_message = "Form 12BB submitted Successfully";
              }
      }catch(err){
        this.toast = true;
        this.errmsg = err;
      }
    },
     
    async openForm12BB() {
      this.checkBoxFlag=true
      this.form12BB_pop_up = true;
      var hraDetailsFor12BB=[]
      let HRAbackendArray=this.backendArrayData.section10.HRA.approved.details.length?this.backendArrayData.section10.HRA.approved:this.backendArrayData.section10.HRA.actual.details.length?
      this.backendArrayData.section10.HRA.actual:this.backendArrayData.section10.HRA.planned.details.length?this.backendArrayData.section10.HRA.planned:"";
      console.log("HRAbackendArray",HRAbackendArray);
      
      HRAbackendArray&&HRAbackendArray.details. map(record=>{
          hraDetailsFor12BB.push(
            {
              "rentPaidToTheLandlord":record.value?record.value:"",
              "nameOfLandlord":record.ownerDetails.name?record.ownerDetails.name:"",
              "addressOfTheLandlord":record.ownerDetails.address?record.ownerDetails.address:"",
              "PANofTheLandlord":record.ownerDetails.panNumber?record.ownerDetails.panNumber:"",
              "proofStatus": "Proof Submitted"
            }
          )
      })
      this.BBPayload ={
        "empId":this.empId,
        "ipAddress":"",
        "isDigitallySiged":false,
        "empCode":this.employeeDetailsPayload[0].code,
        "empName":this.employeeName ,
        "gender":this.employeeDetailsPayload[0].gender,
        "empEmail":this.employeeDetailsPayload[0].email_id,
        "empMobile":this.employeeDetailsPayload[0].mobile_number,
        "empPAN":this.employeeDetailsPayload[0].pan_number,
        "legalEntityId":this.employeeDetailsPayload[0].legal_entity_id,
        "legalEntityImgUrl":this.employeeDetailsPayload[0].legalEntityDetails.logoURL,
        "legalEntityAddress":this.employeeDetailsPayload[0].legalEntityDetails.registeredAddress,
        "clientCode":this.employeeDetailsPayload[0].legalEntityDetails.clientCode,
        "clientName": this.employeeDetailsPayload[0].legalEntityDetails.legalName,
        "financialYear":this.employeeDetailsPayload[0].payrollDetails.year,
        "houseRentAllowance":hraDetailsFor12BB,
        "deductionOfInterestOnBorrowing": [{
        "interestPayableOrPaidToTheLender":this.backendArrayData.section24.sefOccupied.total_actual,
        "nameOfTheLender":this.backendArrayData.section24.sefOccupied.bank_details.bank_name,
        "addressOfTheLender":this.backendArrayData.section24.sefOccupied.bank_details.bank_address,
        "PANofLender":this.backendArrayData.section24.sefOccupied.bank_details.bank_pancard_number,                                                                                                                                                                                                                                                    
        "financialInstitutions":this.backendArrayData.section24.sefOccupied.bank_details.bank_name,
        "employer":"",
        "otherLenderDetails": "",
        "proofStatus":this.backendArrayData.section24.sefOccupied.file_location?"submitted":"Not-submitted"
       }],
       "leaveTravelConcessionsOrAssitance" : "",
       "chapterVIASections": [{
       "chapterVIASection80C":this.backendArrayData.section6a['80C'],
       "chapterVIAOtherSections": [{
         "80D":this.backendArrayData.section6a['80D'],
         "80G":this.backendArrayData.section6a['80G'],
         "Others":this.backendArrayData.section6a['Others'],
         "80U":this.backendArrayData.section6a['80U'],
         "80DD":this.backendArrayData.section6a['80DD']
       }]
     }]
   }
    
  //  console.log("before encryption",this.BBPayload)
   
   let data = await this.encryptData(this.BBPayload); 
     let res = await this.form12BBURL(data);
     let apiResponse = JSON.parse(await this.decryptOne(res));
      this.BB_12_url=apiResponse.data.pdfPreSignedUrl
    },  
    async digitalySign()
    {
      try{
      this.BBPayload.isDigitallySiged=true
      this.BBPayload.ipAddress = this.promiseIP
      let data = await this.encryptData(this.BBPayload); 
     let res = await this.form12BBURL(data);
      if(res){
        this.showSuccessMsg = true;
        this.finalSubmitFlag=false
        this.pop_up_message = "Form 12BB submitted Successfully";
        var apiResponse = JSON.parse(await this.decryptOne(res));
      }
      //  console.log(apiResponse)
      }catch(err){
        this.toast = true;
        this.errmsg = err;
      }
    },

    async it_proof_submission(header) {
      try {
        this.upload_loader=true
        if(header == "final_submit"){
          this.showDeleteConfirmation = false
          this.backendArrayData.isDraft = false;
          // this.backendArrayData.isAuditValidated = true;
        }
        this.backendArrayData.employeeId = this.empId;
        this.backendArrayData.itPlanId = this.it_plan_id;
        this.backendArrayData.financialYear = 2025;
        this.backendArrayData.login_email_id = this.emailId;
        let res = await this.postAllITProofData(this.backendArrayData);
        if (res) {
          this.toast=false
          switch (header) {
            case "section_ten_exemption":
            this.upload_loader=false
          this.showSuccessMsg = true;
          this.pop_up_message = "Section 10 proofs successfully Validated";
          this.getItSubmissionData();
          this.closeTabs()
              break;
              case "hraSection":
            this.upload_loader=false
          this.showSuccessMsg = true;
          this.pop_up_message = "House Rent Declaration proofs successfully validated";
          this.getItSubmissionData();
          this.closeTabs()
              break;
            case "employee_family_details":
                this.upload_loader=false
          this.showSuccessMsg = true;
          this.pop_up_message = "Family Details successfully validated";
          this.getItSubmissionData();
          this.closeTabs()
              break;
               case "income_loss_property":
                this.upload_loader=false
          this.showSuccessMsg = true;
          this.pop_up_message = "Income/Loss From Housing Proofs successfully validated";
          this.getItSubmissionData();
          this.closeTabs()
              break;
          case "deduction_under_6A":
                this.upload_loader=false
          this.showSuccessMsg = true;
          this.pop_up_message = "Deduction Under Chapter VI A Proofs successfully validated";
          this.getItSubmissionData();
          this.closeTabs()
              break;
          case "income_from_previous_employee":
                this.upload_loader=false
          this.showSuccessMsg = true;
          this.pop_up_message = "Income From Previous Employer Proofs successfully validated";
          this.getItSubmissionData();
          this.closeTabs()
              break;
          case "other_income":
                this.upload_loader=false
          this.showSuccessMsg = true;
          this.pop_up_message = "Other Income Proofs successfully validated";
          this.getItSubmissionData();
          this.closeTabs()
            case "tcs_data":
                this.upload_loader=false
              this.showSuccessMsg = true;
          this.pop_up_message = "TCS Proofs successfully saved as draft";
          this.getItSubmissionData();
          this.closeTabs()
              break;
          case "final_submit" :
          this.upload_loader=false
          this.showSuccessMsg = true;
          this.pop_up_message = "IT Proofs is successfully Validated";
          this.getItSubmissionData();
          this.closeTabs()
          }
          
          
        
        }
        //console.log(res);
      } catch (err) {
        this.upload_loader=false
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getHraDAta(data) {
      if (data["HRA"].approved.details&&data["HRA"].approved.details.length > 0) {
        // data["HRA"].approved.details[1].from = "2023-06-01"
        // data["HRA"].approved.details[1].to = "2024-03-31"
        return await data["HRA"].approved;
      } else if (data["HRA"].actual.details.length > 0) {
        return await data["HRA"].actual;
      } else {
        return {
    "status": true,
    "details": [
        {
            "to": "",
            "from": "",
            "metro": "",
            "value": "",
            "status": "",
            "remarks": "",
            "isDelete": false,
            "ownerDetails": {
                "name": "",
                "metro": "",
                "state": "",
                "toDate": "",
                "address": "",
                "pinCode": null,
                "fileName": "",
                "fromDate": "",
                "panNumber": "",
                "pancardUrl": ""
            },
            "cownerDetails": {
                "name": "",
                "state": "",
                "address": "",
                "pincode": null,
                "fileName": "",
                "panNumber": "",
                "pancardUrl": ""
            }
        },
        
    ],
    "file_location": ""
}
      }
    },
    getCurrentFiscalYear() {
      const today = new Date();
      const fiscalStartMonth = 4; // Assuming fiscal year starts in April

      if (today.getMonth() + 1 < fiscalStartMonth) {
        // If the current month is before the fiscal year start month
        this.fiscalYearStart = new Date(
          today.getFullYear() - 1,
          fiscalStartMonth - 1,
          1
        );
        this.fiscalYearEnd = new Date(
          today.getFullYear(),
          fiscalStartMonth - 2,
          31
        );
      } else {
        // If the current month is on or after the fiscal year start month
        this.fiscalYearStart = new Date(
          today.getFullYear(),
          fiscalStartMonth - 1,
          1
        );
        this.fiscalYearEnd = new Date(
          today.getFullYear() + 1,
          fiscalStartMonth - 2,
          31
        );
        this.fiscalYearEndPlus = new Date(this.fiscalYearEnd)
       this.fiscalYearEndPlus.setDate(this.fiscalYearEnd.getDate()+1)
      }

      this.fiscalYearStart.toISOString().split("T")[0];
      this.fiscalYearEnd.toISOString().split("T")[0];

      //console.log("start", this.fiscalYearStart, "end", this.fiscalYearEndPlus);
    },
getValues(title, index, header) {
      switch (header) {
        case "section_ten_exemption":
          if (title == "Approve") {
            this.sec_ten_exemption_table_columns_data[index].approved = this.sec_ten_exemption_table_columns_data[index].actual
            this.sec_ten_exemption_table_columns_data[index].status = 'audit_approved'
            // console.log(this.sec_ten_exemption_table_columns_data, "data")
          } else if (title == "Partially Approve") {
            this.sec_ten_exemption_table_columns_data[index].status = "partially_approved"
            
          } else if (title == "Reject") {
            this.sec_ten_exemption_table_columns_data[index].status = "rejected"
             this.sec_ten_exemption_table_columns_data[index].approved=0
          }
          console.log("data,", this.sec_ten_exemption_table_columns_data[index])
          break;
            case "house_rent_declaration":
          if (title == "Approve") {            
            this.house_rent_declaration_array.details[index].value =   this.tempArray[index]
            this.house_rent_declaration_array.details[index].status = 'audit_approved'
          } else if (title == "Partially Approve") {
            this.house_rent_declaration_array.details[index].value =   this.tempArray[index]
            this.house_rent_declaration_array.details[index].status = "partially_approved"
            
          } else if (title == "Reject") {
            this.house_rent_declaration_array.details[index].status = "rejected"
            this.house_rent_declaration_array.details[index].value=0
          }
          break;
        case 'deduction_under_chapter_four_80C':
          if (title == "Approve") {
            this.deduction_under_80C_table_columns_data[index].approved = this.deduction_under_80C_table_columns_data[index].actual
            this.deduction_under_80C_table_columns_data[index].status = 'audit_approved'
            // console.log(this.deduction_under_80C_table_columns_data, "data")
          } else if (title == "Partially Approve") {
            this.deduction_under_80C_table_columns_data[index].status = "partially_approved"
          } else if (title == "Reject") {
             this.deduction_under_80C_table_columns_data[index].approved=0
            this.deduction_under_80C_table_columns_data[index].status = "rejected"
          }
          console.log("data,", this.deduction_under_80C_table_columns_data[index])
          break;
        case 'deduction_under_chapter_four_80D':
          if (title == "Approve") {
            this.deduction_under_80D_table_columns_data[index].approved = this.deduction_under_80D_table_columns_data[index].actual
            this.deduction_under_80D_table_columns_data[index].status = 'audit_approved'
            // console.log(this.deduction_under_80D_table_columns_data, "data")
          } else if (title == "Partially Approve") {
            this.deduction_under_80D_table_columns_data[index].status = "partially_approved"
          } else if (title == "Reject") {
             this.deduction_under_80D_table_columns_data[index].approved=0
            this.deduction_under_80D_table_columns_data[index].status = "rejected"
          }
          // console.log("data,", this.deduction_under_80D_table_columns_data[index])
          break;


        case 'deduction_under_chapter_four_80DD':
          if (title == "Approve") {
            this.deduction_under_80DD_table_columns_data[index].approved = this.deduction_under_80DD_table_columns_data[index].actual
            this.deduction_under_80DD_table_columns_data[index].status = 'audit_approved'
            // console.log(this.deduction_under_80DD_table_columns_data, "data")
          } else if (title == "Partially Approve") {
            this.deduction_under_80DD_table_columns_data[index].status = "partially_approved"
          } else if (title == "Reject") {
             this.deduction_under_80DD_table_columns_data[index].approved=0
            this.deduction_under_80DD_table_columns_data[index].status = "rejected"
          }
          // console.log("data,", this.deduction_under_80DD_table_columns_data[index])
          break;
          case 'deduction_under_chapter_four_80DDB':
          if (title == "Approve") {
            this.deduction_under_80DDB_table_columns_data[index].approved = this.deduction_under_80DDB_table_columns_data[index].actual
            this.deduction_under_80DDB_table_columns_data[index].status = 'audit_approved'
            // console.log(this.deduction_under_80DDB_table_columns_data, "data")
          } else if (title == "Partially Approve") {
            this.deduction_under_80DDB_table_columns_data[index].status = "partially_approved"
          } else if (title == "Reject") {
            this.deduction_under_80DDB_table_columns_data[index].approved=0
            this.deduction_under_80DDB_table_columns_data[index].status = "rejected"
          }
          // console.log("data,", this.deduction_under_80DDB_table_columns_data[index])
          break;
           case 'deduction_under_chapter_four_80G':
          if (title == "Approve") {
            this.deduction_under_80G_table_columns_data[index].approved = this.deduction_under_80G_table_columns_data[index].actual
            this.deduction_under_80G_table_columns_data[index].status = 'audit_approved'
            // console.log(this.deduction_under_80G_table_columns_data, "data")
          } else if (title == "Partially Approve") {
            this.deduction_under_80G_table_columns_data[index].status = "partially_approved"
          } else if (title == "Reject") {
             this.deduction_under_80G_table_columns_data[index].approved=0
            this.deduction_under_80G_table_columns_data[index].status = "rejected"
          }
          // console.log("data,", this.deduction_under_80G_table_columns_data[index])
          break;
           case 'deduction_under_chapter_four_80U':
          if (title == "Approve") {
            this.deduction_under_80U_table_columns_data[index].approved = this.deduction_under_80U_table_columns_data[index].actual
            this.deduction_under_80U_table_columns_data[index].status = 'audit_approved'
            // console.log(this.deduction_under_80U_table_columns_data, "data")
          } else if (title == "Partially Approve") {
            this.deduction_under_80U_table_columns_data[index].status = "partially_approved"
          } else if (title == "Reject") {
             this.deduction_under_80U_table_columns_data[index].approved=0
            this.deduction_under_80U_table_columns_data[index].status = "rejected"
          }
          // console.log("data,", this.deduction_under_80U_table_columns_data[index])
          break;
           case 'deduction_under_chapter_four_others':
          if (title == "Approve") {
            this.deduction_under_others_table_columns_data[index].approved = this.deduction_under_others_table_columns_data[index].actual
            this.deduction_under_others_table_columns_data[index].status = 'audit_approved'
            // console.log(this.deduction_under_others_table_columns_data, "data")
          } else if (title == "Partially Approve") {
            this.deduction_under_others_table_columns_data[index].status = "partially_approved"
          } else if (title == "Reject") {
            this.deduction_under_others_table_columns_data[index].approved=0
            this.deduction_under_others_table_columns_data[index].status = "rejected"
          }
          break;
          case "income_loss_self_occuiped":
          if (title == "Approve") {
            this.income_loss_from_house_table_columns_data_one[index].total_approved = this.income_loss_from_house_table_columns_data_one[index].total_actual
            this.income_loss_from_house_table_columns_data_one[index].status = 'audit_approved'
          } else if (title == "Partially Approve") {
            this.income_loss_from_house_table_columns_data_one[index].status = "partially_approved"
          } else if (title == "Reject") {
             this.income_loss_from_house_table_columns_data_one[index].total_approved=0
            this.income_loss_from_house_table_columns_data_one[index].status = "rejected"
          }
          break;
           case "income_loss_letout":
          if (title == "Approve") {
            console.log("this.income_loss_from_house_table_columns_data_two.letout[index]",this.income_loss_from_house_table_columns_data_two.letout)
            this.income_loss_from_house_table_columns_data_two.letout.map(val=>{
              val.approved = val.actual
              val.status = 'audit_approved'
            })
          } else if (title == "Partially Approve") {
            this.income_loss_from_house_table_columns_data_two.letout.map((val,index)=>{
                val.status = 'partially_approved'
            })
          } else if (title == "Reject") {
            this.income_loss_from_house_table_columns_data_two.letout.map(val=>{
              val.status = "rejected"
              val.approved = 0
            })
          }
          break;
        case "income_from_previous_employee":
           
          if (title == "Approve") {
             this.income_from_previous_employee_table_columns_data[index].status = 'audit_approved'
            this.income_from_previous_employee_table_columns_data[index].approved =  this.income_from_previous_employee_table_columns_data[index].actual
        
          } else if (title == "Partially Approve") {
            this.income_from_previous_employee_table_columns_data[index].status = "partially_approved"
            
            this.income_from_previous_employee_table_columns_data[index].approved =  this.income_from_previous_employee_table_columns_data[index].actual
          
           
          } else if (title == "Reject") {
             this.income_from_previous_employee_table_columns_data[index].status = "rejected"
             this.income_from_previous_employee_table_columns_data[index].approved = 0
             
           
             
          }
          // this.getItSubmissionData()
          // this.income_from_previous_employee_table_columns_data[0]=[...this.income_from_previous_employee_table_columns_data[0]]
          // console.log("data,", this.income_from_previous_employee_table_columns_data[0][index])
          break;
          case "other_income":
           
          if (title == "Approve") {
             this.other_income_table_columns_data[index].status = 'audit_approved'
            this.other_income_table_columns_data[index].approved =  this.other_income_table_columns_data[index].actual
        
          } else if (title == "Partially Approve") {
            this.other_income_table_columns_data[index].status = "partially_approved"
            
            this.other_income_table_columns_data[index].approved =  this.other_income_table_columns_data[index].actual
          
           
          } else if (title == "Reject") {
             this.other_income_table_columns_data[index].status = "rejected"
             this.other_income_table_columns_data[index].approved = 0
             
           
             
          }
          // this.getItSubmissionData()
          // this.income_from_previous_employee_table_columns_data[0]=[...this.income_from_previous_employee_table_columns_data[0]]
          // console.log("data,", this.income_from_previous_employee_table_columns_data[0][index])
          break;
          
        case "tcs_data":
          if (title == "Approve") {
            this.other_tcs_table_columns_data[index].approved = this.other_tcs_table_columns_data[index].actual
            this.other_tcs_table_columns_data[index].status = 'audit_approved'
          } else if (title == "Partially Approve") {
            this.other_tcs_table_columns_data[index].status = "partially_approved"
          } else if (title == "Reject") {
            this.other_tcs_table_columns_data[index].approved = 0
            this.other_tcs_table_columns_data[index].status = "rejected"
          }
          console.log("TCS data:", this.other_tcs_table_columns_data[index])
          break;
          
      } 
    },
    

    
    async getItSubmissionData() {
      // console.log("hiii")
      try {
        let res = await this.act_get_plan(this.empId);
        //console.log(res.data.payload);
        const planList = res.data.payload.filter(
          (ele) => ele.is_plan_active == true
        );
        this.it_plan_id = planList[0].id;
        let obj = {
          employee_id: this.empId,
        };
        let response = await this.act_getProfileData(obj);
        this.employeeDetailsPayload =response.data.payload
        var getProfileDataPayload = response.data.payload;
        let cientCodeName=getProfileDataPayload[0].legalEntityDetails.clientCode
         this.clientCodeBoolen = this.clientCode.some((record)=>{
               return record == cientCodeName
         })
        this.e_code = response.data.payload[0].code;
        this.it_financial_year = response.data.payload[0].payrollDetails.year;
        this.employeeName = response.data.payload[0].first_name+" "+(response.data.payload[0].last_name?response.data.payload[0].last_name:"")
        const itsheetPayload = {
          employeeId: this.empId,
          le_id: this.le_id,
          financialYear: 2025,
          itPlanId: this.it_plan_id,
        };
        let result = await this.getAllItProofSubmissionData(itsheetPayload);
        this.backendArrayData = result
        this.tempArray=[];     
        this.showDiv = this.income_loss_from_house_table_columns_data_three && this.income_loss_from_house_table_columns_data_three[0] && this.income_loss_from_house_table_columns_data_three[0].joint_holder_name ? true : false;
        this.showDivforletout = this.income_loss_from_house_table_columns_data_letout_joint_Property && this.income_loss_from_house_table_columns_data_letout_joint_Property[0]  && this.income_loss_from_house_table_columns_data_letout_joint_Property[0].joint_holder_name ? true : false;
       if(this.backendArrayData.section10.HRA.approved.details && this.backendArrayData.section10.HRA.approved.details.length > 0){  
        this.backendArrayData.section10.HRA.approved && this.backendArrayData.section10.HRA.approved.details && this.backendArrayData.section10.HRA.approved.details.map(e => {
        this.tempArray.push(e.value) 
          } );  
          
        }else if(this.backendArrayData.section10.HRA.actual.details && this.backendArrayData.section10.HRA.actual.details.length > 0){
          this.backendArrayData.section10.HRA.actual&& this.backendArrayData.section10.HRA.actual.details && this.backendArrayData.section10.HRA.actual.details.map(e => {
        this.tempArray.push(e.value) 
          })
        }
        this.incomeTaxProofSubmittedFlag = result.itProofSubmitted ? false : true;
        if (this.incomeTaxProofSubmittedFlag) {
         this.dateSuccess=true
        }   
        this.isSec10 = result.isSec10Save ? true : false;
        this.isHra = result.isHraSave ? true : false;  
         
        this.isIncomeLoss = result.isIncomeLossSave ? true : false;
        this.isDeduction6A = result.isDeduction6ASave ? true : false;
        this.isPrevEmployee = result.isPrevEmpSave ? true : false;
        this.isOtherIncome = result.isOtherSave ? true : false;
        //for validating
        this.other_tcs_table_columns_data =    result.employeeTCS 
        this.currentyearjoined = result.DOJFlag
        this.enableTCS = result.enableTCS?true:false
         if(result.employeeTCS&&result.employeeTCS.length == 0){
        this.addMoreRow('tcs_data')
        }
         this.isSec10Emp = result.isSec10SaveEmp 
        this.isHraEmp = result.isHraSaveEmp   
       
        this.isIncomeLossEmp = result.isIncomeLossSaveEmp 
        this.isDeduction6AEmp = result.isDeduction6ASaveEmp 
        this.isPrevEmployeeEmp = result.isPreEmpSaveEmp 
        this.isOtherIncomeEmp = result.isOtherSaveEmp 
        // console.log("eyyyyygdddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddd")
        // var first_Object_key_access = Object.keys(result.employeeMaster)[0];
        // console.log("eyyyyygddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddhhhhhhhhhhhhhhhhhhhhhhhhhhhhh")
        // (this.net_taxable_income =
        //   result.employeeMaster[first_Object_key_access].taxableIncome),
        //   (this.total_tax =
        //     result.employeeMaster[first_Object_key_access].totalTax),
        //   (this.tax_to_be_paid =
        //     result.employeeMaster[first_Object_key_access].totalTaxProjected),
        //   (this.backendArrayData = result);
        this.employeeFamilyDetails = result.employeeFamily;
        this.options_for_6a_family_dependant =
          this.employeeFamilyDetails[0].details;
        //console.log(this.employeeFamilyDetails);
        this.employeeFamilyDetails[0].details &&
          this.employeeFamilyDetails[0].details.forEach((person) => {
            //console.log("entry", person);
            this.nameToRelationship[person.name] = person.relationship;
          });
        this.employeeFamilyDetails[0].details.length &&
          this.employeeFamilyDetails[0].details.map((item) => {
            //console.log("hiii");
            if (
              item.relationship == "Self" ||
              item.relationship == "Father" ||
              item.relationship == "Mother"
            ) {
              //console.log("here at index", item.relationship);
              let index = this.options_for_relationship.indexOf(
                item.relationship
              );
              if (index != -1) {
                this.options_for_relationship.splice(index, 1);
              }
              //console.log(index, "index");
            }
          });
        //console.log(this.options_for_relationship, "familt data");
        if (this.employeeFamilyDetails[0].details.length == 0) {
          this.addMoreRow("family_details");
        }
        this.sec_ten_exemption_table_columns_data =
          result.section10.section10Others;
         
          this.sec_ten_exemption_table_columns_data.map(record=>{
              if(record.status == "not_approved"){
                  record.status = "Pending"
              }
            if (!record.hasOwnProperty("remarks")) {
                record.remarks=""
            }
            if(record.status=='audit_approved')
            record.approved=record.actual
          })
        this.sec_ten_exemption_table_columns_data.sort((a, b) => {
          if (a.file_location && !b.file_location) {
              return -1
          } else if (b.file_location && !a.file_location) {
            return 1
          } else {
              return 0
            }     
        }) 
        
        this.deduction_under_80C_table_columns_data = result.section6a["80C"];
        this.deduction_under_80C_table_columns_data.map(record=>{
              if(record.status == "not_approved" || !record.hasOwnProperty("status") || record.status=="" ){
                  record.status = "Pending"
              }
            if (!record.hasOwnProperty("remarks")) {
                record.remarks=""
            }
            if(record.status=='audit_approved')
            record.approved=record.actual
        })
         
          this.deduction_under_80C_table_columns_data.sort((a, b) => {
          if (a.file_location && !b.file_location) {
              return -1
          } else if (b.file_location && !a.file_location) {
            return 1
          } else {
              return 0
            }     
        })         // console.log(this.deduction_under_80C_table_columns_data,"80c")
        this.deduction_under_80D_table_columns_data = result.section6a["80D"];
        this.deduction_under_80D_table_columns_data.map(record=>{
            if(record.status == "not_approved" || !record.hasOwnProperty("status") || record.status=="" ){
                  record.status = "Pending"
              }
            if (!record.hasOwnProperty("remarks")) {
                record.remarks=""
            }
            if(record.status=='audit_approved')
            record.approved=record.actual
        })
         
        this.deduction_under_80D_table_columns_data.sort((a, b) => {
          if (a.file_location && !b.file_location) {
              return -1
          } else if (b.file_location && !a.file_location) {
            return 1
          } else {
              return 0
            }     
        })
        this.deduction_under_others_table_columns_data = result.section6a["Others"];
        this.deduction_under_others_table_columns_data.map(record=>{
              if(record.status == "not_approved" || !record.hasOwnProperty("status") || record.status=="" ){
                  record.status = "Pending"
              }
            if (!record.hasOwnProperty("remarks")) {
                record.remarks=""
            }
            if(record.status=='audit_approved')
            record.approved=record.actual
        })
          this.deduction_under_others_table_columns_data.sort((a, b) => {
          if (a.file_location && !b.file_location) {
              return -1
          } else if (b.file_location && !a.file_location) {
            return 1
          } else {
              return 0
            }     
        })     
        this.deduction_under_80G_table_columns_data = result.section6a["80G"];
        this.deduction_under_80G_table_columns_data&&this.deduction_under_80G_table_columns_data.map(record=>{
              if(record.status == "not_approved" || !record.hasOwnProperty("status") || record.status=="" ){
                  record.status = "Pending"
              }
            if (!record.hasOwnProperty("remarks")) {
                record.remarks=""
            }
            if(record.status=='audit_approved')
            record.approved=record.actual
        })
          this.deduction_under_80G_table_columns_data&&this.deduction_under_80G_table_columns_data.sort((a, b) => {
          if (a.file_location && !b.file_location) {
              return -1
          } else if (b.file_location && !a.file_location) {
            return 1
          } else {
              return 0
            }     
        })     
        this.deduction_under_80U_table_columns_data = result.section6a["80U"];
        this.deduction_under_80U_table_columns_data.map(record=>{
             if(record.status == "not_approved" || !record.hasOwnProperty("status") || record.status=="" ){
                  record.status = "Pending"
              }
            if (!record.hasOwnProperty("remarks")) {
                record.remarks=""
            }
            if(record.status=='audit_approved')
            record.approved=record.actual
        })
         
 this.deduction_under_80U_table_columns_data.sort((a, b) => {
          if (a.file_location && !b.file_location) {
              return -1
          } else if (b.file_location && !a.file_location) {
            return 1
          } else {
              return 0
            }     
 })
          let copydeduction_under_80DD_table_columns_data = result.section6a["80DD"];
             this.deduction_under_80DD_table_columns_data = copydeduction_under_80DD_table_columns_data && copydeduction_under_80DD_table_columns_data.filter(record => {
               return record.InvestmentComponentType.name !== 'Medical Treatment Expenses';
             }); 
        this.deduction_under_80DD_table_columns_data&&this.deduction_under_80DD_table_columns_data.map(record=>{
           if(record.status == "not_approved" || !record.hasOwnProperty("status") || record.status=="" ){
                  record.status = "Pending"
              }
            if (!record.hasOwnProperty("remarks")) {
                record.remarks=""
            }
            if(record.status=='audit_approved')
            record.approved=record.actual
        })
          this.deduction_under_80DD_table_columns_data.sort((a, b) => {
          if (a.file_location && !b.file_location) {
              return -1
          } else if (b.file_location && !a.file_location) {
            return 1
          } else {
              return 0
            }     
        })     
        this.deduction_under_80DDB_table_columns_data = result.section6a["80DDB"];
        this.deduction_under_80DDB_table_columns_data.map(record=>{
            if(record.status == "not_approved" || !record.hasOwnProperty("status") || record.status=="" ){
                  record.status = "Pending"
              }
            if (!record.hasOwnProperty("remarks")) {
                record.remarks=""
            }
            if(record.status=='audit_approved')
            record.approved=record.actual
        })
          this.deduction_under_80DDB_table_columns_data.sort((a, b) => {
          if (a.file_location && !b.file_location) {
              return -1
          } else if (b.file_location && !a.file_location) {
            return 1
          } else {
              return 0
            }     
        })     
        this.deduction_under_80U_table_columns_data.map((record, index) => {
          record.familyDetails = {
            name: "",
            relationship: "",
            percentage: "",
            amount: "",
            isDelete: false,
          };
        });
         this.deduction_under_80U_table_columns_data.sort((a, b) => {
          if (a.file_location && !b.file_location) {
              return -1
          } else if (b.file_location && !a.file_location) {
            return 1
          } else {
              return 0
            }     
        })     
        //console.log(this.deduction_under_80U_table_columns_data);
        this.other_income_table_columns_data = result.otherIncome;
        this.other_income_table_columns_data.map(record=>{
              if(record.status == "not_approved"|| !record.hasOwnProperty("status") || !record.status){
                  record.status = "Pending"
              }
              if (!record.hasOwnProperty("remarks")) {
                record.remarks=""
              }
              if(record.status=='audit_approved')
                record.approved=record.actual
            })
         this.other_income_table_columns_data.sort((a, b) => {
          if (a.file_location && !b.file_location) {
              return -1
          } else if (b.file_location && !a.file_location) {
            return 1
          } else {
              return 0
            }     
        })     
        // result.previousEmployment.pop();
        this.isPrevEmployerEnabled = true;
         this.income_from_previous_employee_table_columns_data =
          await result.previousEmployment &&
          result.previousEmployment.map((item) => {
            let key = Object.keys(item)[0];
            let nestedObject = item[key];
            return {
              name: key,
              planned: nestedObject.planned,
              actual: nestedObject.actual,
              approved: nestedObject.approved,
              file_location: nestedObject.file_location,
              file_name: nestedObject.file_name,
              remarks: nestedObject.remarks ? nestedObject.remarks : "",
              status:  nestedObject.status ? nestedObject.status : "Pending"    
            };
          });
          // console.log(" previous_Employee_data", previous_Employee_data)
        // let prevEmpData = [];
        // prevEmpData.push(previous_Employee_data);
       
      
         this.income_from_previous_employee_table_columns_data.map((record) => {
          //  if(record.status == "not_approved"|| !record.hasOwnProperty("status") || !record.status||record.status==""){
          //    record.status = "Pending"
          //         console.log("hbii thejas")
          //     }
              if (!record.hasOwnProperty("remarks")) {
                record.remarks=""
              }
              if(record.status=='audit_approved')
                record.approved=record.actual
            })
        //  this.income_from_previous_employee_table_columns_data = [...previous_Employee_data];
        console.log("prev", this.income_from_previous_employee_table_columns_data)
      // console.log("prevuos", [...previous_Employee_data])  
        result.section24.letOutProperty[0].letOut &&
          result.section24.letOutProperty[0].letOut.forEach((item) => {
            // Check if the object's name is in the specified list and "isDisabled" is not already present
            if (
              this.namesToAddIsDisabled.includes(item.name) &&
              !item.hasOwnProperty("isDisabled")
            ) {
              // Add the "isDisabled" key with an empty string value
              item.isDisabled = true;
             
            }
            //  if(item.status == "not_approved" || !item.hasOwnProperty("status") || !item.status){
            //       record.status = "Pending"
            //   }
            if (!item.hasOwnProperty("remarks")) {
                item.remarks=""
              }
             if(item.status=='audit_approved')
                item.approved=item.actual
          });

        this.income_loss_from_house_table_columns_data_two.letout =
          result.section24.letOutProperty[0].letOut.map((item) => {
            if ("file_location" in item) {
            } else {
              item.file_location = "";
            }
             if(item.status == "not_approved" || !item.hasOwnProperty("status") || !item.status){
                  item.status = "Pending"
              }
             if ("remarks" in item) {
            } else {
              item.remarks = "";
            } 
            return item;
          });
        this.income_loss_from_house_table_columns_data_two.joint_property_details =
        result.section24.letOutProperty[0].joint_property_details && result.section24.letOutProperty[0].joint_property_details
        if(result.section24.sefOccupied){
          this.income_loss_from_house_table_columns_data_one = [
             result.section24.sefOccupied 
          ];
        }
        console.log("bank details",this.income_loss_from_house_table_columns_data_one)
        if (
          !this.income_loss_from_house_table_columns_data_one[0].bank_details
        ) {
          this.income_loss_from_house_table_columns_data_one[0].bank_details = {
            bank_name: "",
            bank_address: "",
            bank_pancard_number: "",
            loan_sanction_date: "",
            home_occupance_date: "",
            home_address: "",
            pre_emi_interest_paid: "",
          };
        }
        if (!this.income_loss_from_house_table_columns_data_one[0].status || this.income_loss_from_house_table_columns_data_one[0].status == "" || !this.income_loss_from_house_table_columns_data_one[0].status == "not_approved") {
          this.income_loss_from_house_table_columns_data_one[0].status="Pending"
        }
        if (
          this.income_loss_from_house_table_columns_data_one[0]
            .joint_property_details
        ) {
          this.income_loss_from_house_table_columns_data_three =
            this.income_loss_from_house_table_columns_data_one[0].joint_property_details;
        }
        if (
          !this.income_loss_from_house_table_columns_data_one[0].file_location
        ) {
          this.income_loss_from_house_table_columns_data_one[0].file_location =
            "";
        }
        if(!this.income_loss_from_house_table_columns_data_one[0].remarks){
          this.income_loss_from_house_table_columns_data_one[0].remarks=""
        }
         if(!this.income_loss_from_house_table_columns_data_one[0].status){
          this.income_loss_from_house_table_columns_data_one[0].status=""
        }
        if(
          this.income_loss_from_house_table_columns_data_two.joint_property_details
        ){
          this.income_loss_from_house_table_columns_data_letout_joint_Property =
          this.income_loss_from_house_table_columns_data_two.joint_property_details;
        }
        this.income_loss_from_house_table_columns_data_one[0].joint_holder_name = "Total"
        let hraData = await this.getHraDAta(JSON.parse(JSON.stringify(result.section10)));
        this.house_rent_declaration_array = hraData;
        // console.log( this.house_rent_declaration_array, "hra data");
      
        this.house_rent_declaration_array &&
          this.house_rent_declaration_array.details.length &&
          this.house_rent_declaration_array.details.map((item) => {
            if (item.isDelete) {
            } else {
              item.isDelete = false;
            }
            if (item.hasOwnProperty("status")) {
              console.log("no")
            } else {
              item.status = "Pending";
            }
             if (item.hasOwnProperty("remarks")) {
            } else {
              item.remarks = "";
            }
            return item;
          });
        if (!this.house_rent_declaration_array.file_location) {
          this.house_rent_declaration_array.file_location = "";
        }
        // if (this.house_rent_declaration_array.details.length == 0) {
        //   addMoreRow("house_rent_declaration");
        // }
        // this.house_rent_table_columns_data=hraData

        this.getCurrentFiscalYear();
        this.itProofDocumentDownload();
       
      } catch (err) {
        console.log("error", err);
      }
    },

     goBackFunction(headerValue) {
       this.toast = false
       this.errmsg = false 
       this.dateSuccess=false  
   
      //console.log(headerValue);
      switch (headerValue) {
        case "Deduction Under 6A":
          this.showPopupDeductionUnderCdeu = true;
          break;
        case "Other Income":
          this.showPopupOtherIncome = true;
          break;
        case "Income From Previous Employer":
          console.log("hii")
          this.showPopupIncomeFromPreviousEmployer = true;
          break;
        case "House Rent Allowance":
          this.showPopupHouseRentDeclaration=true
          break;
        case "Income/Loss from Housing Property":

          this.showPopupIncomeLossFromHousingProperty = true
          break;  
        case "deduction_under_80D":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80C":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80DD":
          this.showPopupDeductionUnderCdeu = true;
          break;
           case "deduction_under_80DD":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80DDB":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80E":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80G":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80T":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80U":
          this.showPopupDeductionUnderCdeu = true;
          break;
        case "Tax Collected at Source (TCS)":
          this.showPopupOtherTaxTcs = true;
          break;
           case "deduction_under_others":
          this.showPopupDeductionUnderCdeu = true;
          break;
        case "Income_loss_self_occuiped":
          this.showPopupIncomeLossFromHousingProperty = true;
          break;
        case "Income_loss_letout":
          this.showPopupIncomeLossFromHousingProperty = true;
          break;
      }
     
      (this.section_ten_attachments_pop_up = false),
        (this.house_rent_attachments_pop_up = false),
        (this.deduction_under_6A_attachments_pop_up = false),
        (this.income_loss_from_house_attachments_pop_up = false),
        (this.income_from_previous_employee_pop_up = false),
        (this.other_income_attachments_pop_up = false);
    },
    async fetchRecord() {
      this.it_plan_id = this.$route.query.it_plan_id;
      this.employeeId = this.$route.query.employee_id;
      let payload = {
        empId: this.employeeId,
        empLeId: this.le_id,
      };
      let employeeDetail = await this.act_fetchEmpById(payload);
      let planDetails = await this.act_fetch_plan_name(this.it_plan_id);
      this.PlanName = planDetails.data.payload.plan_name;
      this.first_name = employeeDetail.data.payload.data.first_name;
      this.last_name = employeeDetail.data.payload.data.last_name;
      this.ctc = employeeDetail.data.payload.data.EmployeeSalarySetting[0].ctc;
      this.code = employeeDetail.data.payload.data.code;
      //console.log("Employee Details", employeeDetail.data.payload.data);
      this.instance.employee_id = this.employeeId;
      let bodyParams = {};
      let data = await this.getOrgLeList({
        data: {
          ...bodyParams,
        },
      });
      this.role = data.data.user.userRole;
      if (this.role == "EMPLOYEE") {
        this.instance.financial_year = 2020;
      } else {
        this.instance.financial_year = this.payrollYear;
      }
      this.instance.it_plan_id = this.it_plan_id;
      this.instance.le_id = this.le_id;
      let res = await this.act_set_it_data(this.instance);

      if (res.status) {
        // //console.log(res);
        this.data2.exemption10 = res.data.payload.Exemption10;
        this.data2.exemption17 = res.data.payload.Exemption17;
        this.data2.deductionsUnderSection16 =
          res.data.payload.deductionsUnderSection16;
        this.data2.deductionsUnderChapterVIA =
          res.data.payload.deductionsUnderChapterVIA;
        //console.log("deductionsUnderChapterVIA---------->",this.data2.deductionsUnderChapterVIA)
        this.data2.section24 = res.data.payload.section24;
        this.data2.previousEmploymentDetails =
          res.data.payload.previousEmploymentDetails;
        this.totalAmount_previousEmpDetails =
          this.data2.previousEmploymentDetails.nps.amount +
          this.data2.previousEmploymentDetails.pf.amount +
          this.data2.previousEmploymentDetails.pt.amount +
          this.data2.previousEmploymentDetails.salary_income.amount +
          this.data2.previousEmploymentDetails.tds.amount +
          this.data2.previousEmploymentDetails.vpf.amount;
        this.data2.otherIncome = res.data.payload.otherIncome;
        this.totalAmount_otherIncome = this.data2.otherIncome.reduce(
          (total, i) => {
            total = total + i.planned;
            return total;
          },
          0
        );
        this.salaryPerk = res.data.payload.Salary;
        this.tds_breakup_and_taxable_income =
          res.data.payload.tds_breakup_and_taxable_income;
        this.itSheet = res.data.payload.itSheet;

        this.totalIncomeTax = this.itSheet[0].taxableIncome;
        this.annualTax = this.itSheet[0].totalTax;
        //console.log("TDS data show", this.tds_breakup_and_taxable_income);
        //console.log("IT sheet data ",this.itSheet);
      }
    },

    backpreviouspage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax/incometaxdeclarationdashboard`,
        query: { id: this.employeeId },
      });
    },
    section10update(Exemption10) {
      this.showPopupExemptionUnderSectionDeduction = false;
      // //console.log("updated data ",Exemption10);
      this.data2.exemption10 = Exemption10;
    },
    section17update(Exemption17) {
      this.showPopupExemptionUnderSectionSeventeen = false;
      ////console.log("updated data Exemption17",Exemption17);
      this.data2.exemption17 = Exemption17;
    },
    previousDataUpdate(previousEmpData) {
      this.showPopupIncomeFromPreviousEmployer = false;
      ////console.log("updated data previousEmpData",previousEmpData);
      this.data2.previousEmploymentDetails = previousEmpData;
    },

    chapterVIAupdate(chapterData) {
      this.showPopupDeductionUnderCdeu = false;
      //console.log("updated data chapter VI A",chapterData);
      this.data2.deductionsUnderChapterVIA = chapterData;
    },

    otherIncomeUpdate(otherIncomeList) {
      this.showPopupOtherIncome = false;
      //console.log("updated data Other Income",otherIncomeList);
      this.data2.otherIncome = otherIncomeList;
    },
    Section24Update(Section24Update) {
      this.showPopupIncomeLossFromHousingProperty = false;
      //console.log("updated data Other Income",Section24Update);
      this.data2.section24 = Section24Update;
      this.data2.section24.self_occupied.total_planned = this.data2.section24
        .self_occupied.total_planned
        ? this.data2.section24.self_occupied.total_planned * -1
        : 0;
    },
    saveplan() {
      this.showConfirmationMsg = true;
    },

    async saveTaxRegime() {
      this.data2.plan_id = this.instance.it_plan_id;
      this.data2.employee_id = this.instance.employee_id;
      this.data2.financial_year = this.instance.financial_year;
      this.data2.le_id = this.instance.le_id;
      this.showConfirmationMsg = false;
      let res = await this.act_save_it_plan(this.data2);
      if (res.status) {
        //console.log(res);
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax/incometaxdeclarationdashboard`,
          query: { id: this.data2.employee_id },
        });
      } else {
        console.log("make mistake try again...........");
      }
    },

    /* function to hide the confimation pop-up */
    cancelEvent() {
      this.showConfirmationMsg = false;
    },

    //cancel() {
    //this.$router.push({
    //path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax`
    //});
    // this.$router.push({
    //   path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/updateFixedNonCtcComponents`
    // });
    //},

    nothing() {
      //alert("Helloooo");
    },

    popupMessage() {
      this.exemptionSection = "Add House on Rent";
      //location.reload();
    },

    changeHeaderTitle() {
      this.exemptionSection = "Exemption Under Section 10";
      this.showPopupExemptionUnderSectionDeduction = false;
    },

    goBack() {
      // this.$router.push({
      //   path: `/dashboard/${this.$route.params.entity_index}/overview/dashboard`
      // });\
      this.dateSuccess = false;
      this.showSuccessMsg = false;
      this.attachementPop=false
      this.section_ten_attachments_pop_up = false;
      this.house_rent_attachments_pop_up = false
       this.deduction_under_6A_attachments_pop_up =false
       this.income_from_previous_employee_pop_up = false
       this.income_loss_from_house_attachments_pop_up = false
      this.other_income_attachments_pop_up = false
       this.isAuditorValidated=false
    },

    calculate() {
      let item = this.income_loss_from_house_table_columns_data_two.letout;
       if (this.income_loss_from_house_table_columns_data_two.letout[1].approved > 0) {
                //console.log("there");
                this.income_loss_from_house_table_columns_data_two.letout[2].isDisabled=false
              } else {
                this.income_loss_from_house_table_columns_data_two.letout[2].isDisabled=true
       }
      if (this.income_loss_from_house_table_columns_data_two.letout[1].approved&& this.income_loss_from_house_table_columns_data_two.letout[1].approved <= this.income_loss_from_house_table_columns_data_two.letout[2].approved) {
        this.income_loss_from_house_table_columns_data_two.letout[2].approved = 0
            window.alert('Muncipal Tax paid cannot be more than or equal to Rent Recieved')
      }     
      //console.log("fuction called",item)
      item[3].approved = item[1].approved - item[2].approved;
      item[4].approved = item[3].approved * 0.3;
      item[5].approved = item[0].approved;
      item[6].approved = item[3].approved - item[4].approved - item[5].approved;
    },
   
    async saveEssIT() {
      this.data2.plan_id = this.instance.it_plan_id;
      this.data2.employee_id = this.instance.employee_id;
      //this.data2.financial_year=this.instance.financial_year;
      this.data2.le_id = this.instance.le_id;
      this.instance.financial_year = 2020;
      this.data2.regime_type = "oldregime";
      let res = await this.act_save_it_plan(this.data2);
      if (res.status) {
        this.showSuccessMsg = true;
        //   this.$router.push({
        //   path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax/incometaxdeclarationdashboard`,
        //   query: { id: this.data2.employee_id }
        // });
      } else {
        //console.log("make mistake try again...........");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

::v-deep(.act-btn)  {
  background-color: #cccccc !important;
  color: rgb(9, 9, 9)!important;
  border: none !important;
  padding: 5px 10px !important;
  border-radius: 5px !important;
  cursor: pointer !important;
}

::v-deep(.act-btn:hover)  {
  background-color: #34c0be !important;
  color: #f2f4f6 !important;

}
.delete-btn {
  padding: 2px 20px;
  align-self: flex-end;
  font-weight: 500;
  background-color: #db2929;
  height: 40px;
  color: #fff;
  border-radius: 5px;
}
.section-container {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  flex-wrap: wrap;
}
.data_three {
  display: flex;
  width: 23%;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}

.mask {
  width: 258.5px;
  height: 144px;
  border-radius: 8px;
  border: solid 1px #e9e9e9;
  background-color: #ffffff;
  padding: 20px 24px;
  margin: 20px 20px 20px 0px;
}

.center {
  margin: 500px;
}

.resize {
  margin-left: 100px;
}

.bold-text {
  width: 345px;
  height: 24px;
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  margin-top: 40px;
}

.add-new {
  width: 68px;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}

.click-on-Add-New-t {
  width: 403px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  // margin-left: -30px;
  margin-top: 10px;
}

.oval {
  // background-color: #ffa000;
  width: 75px;
  height: 75px;
  border-radius: 50px;
}

.add-btn-small {
  margin-top: 30px;
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .text {
    color: #858585;
    font-size: 14px;
  }
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;

  &:nth-child(n) {
    margin-right: 20px;
  }

  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }

  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }

  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}

.noData {
  text-align: center;
  padding: 10% 0 10% 0;

  span {
    color: #858585;
    font-size: 18px;
  }
}

.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}

.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}

.noData span {
  font-size: 18px;
  color: #858585;
}

.lineheight {
  height: 1px;
}

.img-user {
  margin-right: 10px;
  position: absolute;
}

.month {
  position: relative;
  margin-left: 40%;
}

.employee-fullname {
  text-transform: capitalize;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.employee-code {
  font-size: 12px;
  font-weight: normal;
  color: #979797;
}

.salary-perks {
  margin-top: 30px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.salary-ctc {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.close-card {
  position: absolute;
  cursor: pointer;
  color: #5d409f;
  right: 10px;
  top: 4px;
}

.document-new-block {
  margin-left: auto;
  margin-right: auto;
  margin-top: 18%;
  width: 400px;
  text-align: center;
}

.add-new-icon-document {
  display: inline-flex;
  cursor: pointer;
  margin-top: 15px;
}

.add-new {
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

#example {
  margin-top: 20px;
}

#example .col-4 {
  border: 1px solid #c9c9c9;
}

#example .col-4:not(:last-child) {
  border-right-width: 0;
}

#example .row:not(:last-child) .col-4 {
  border-bottom-width: 0;
}

#example .col-5 {
  border: 1px solid #c9c9c9;
}

#example .col-5:not(:last-child) {
  border-left-width: 0;
  border-right-width: 0;
}

// #example .row:not(:last-child) .col-5 {
//   border-bottom-width: 0;
// }

.first {
  height: 210px;
  padding: 32px;
  border-radius: 10px 0px 0px 10px;
  border: solid 1px #dddddd;
}

.middle {
  max-width: 37%;
  height: 210px;
  padding: 32px;
  // border-radius: 10px 0px 0px 10px;
  // border: solid 1px #dddddd;
}

.last {
  max-width: 37%;
  flex: 0 0 37%;
  height: 210px;
  padding: 32px;
  border-radius: 0px 10px 10px 0px;
  border: solid 1px #dddddd;
}

.view-salary-breakup {
  margin: 22px 0px 0px 0px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #34c0be;
  cursor: pointer;
}

.regime-title {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.badget-custom {
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

.icon-i {
  // margin: 0px 12px;
  transform: translate(0px, 7px);
}

.total-taxable-income {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.taxable-amount {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
  // margin-right: 20px;
  text-align: right;
}

.custom-width-block-19 {
  width: 14%;
}

.custom-width-block-13 {
  width: 13%;
}

.icon-move-right {
  float: right;
  margin-right: 7px;
}

.custom-col {
  margin-right: 0px;
}

.deduction-title {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.line {
  width: 1px;
  display: inline-block;
  height: 19px;
  margin: 0px 13px 0px 10px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.block-deductions {
  width: 404px;
  // height: 145px;
  padding: 24px 16px 24px 16px;
  border-radius: 8px;
  border: solid 1px #efefef;
  background-color: #ffffff;
  cursor: pointer;
}

.block-deductions-title {
  margin-bottom: 8px;
}

.block-deductions-sub-title {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.deduction-img {
  text-align: right;
  transform: translate(0px, 0px);
}

.amount-deduction {
  text-align: right;
  display: block;
}

.progress-bar-blue {
  margin-top: 10px;
  width: 340px;
  border-radius: 10px;
  height: 10px;
  background-color: #dadada;
}

.progress-target {
  background-color: #34c0be;
  border-radius: 10px;
  height: 10px;
  width: 94px;
}

.progress-target-full {
  background-color: #34c0be;
  border-radius: 10px;
  height: 10px;
  width: 340px;
}

/* Modal Content */

.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 30%;
  // height: 191px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  opacity: 0;
  padding: 30px 30px 30px 30px;
  -webkit-animation-name: showPopup;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
  // -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;

  .success-icon {
    // margin-bottom: 40px;
  }

  .success-text {
    font-size: $font-size-l1;
    font-weight: 600;
    // margin-bottom: auto;
    margin-left: 12px;
    color: #6e6e6e;
  }

  .message-text {
    font-size: $font-size-l1;
    margin-bottom: 20px;
    line-height: 25px;
    animation-delay: 0.7s;
    animation-name: fadeInRight;
    -webkit-animation-name: fadeInRight;
  }

  .btn-confirm-delete {
    display: flex;
    align-items: center;

    *:nth-child(n) {
      margin-right: 20px;
    }
  }

  .warning {
    margin-bottom: 16px;
    text-align: center;
    height: 24px;
    width: 24px;
  }

  .btn-popup {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: $color-primary;
    color: $color-white;
  }

  .btn-popup-secondary {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: #ffffff;
    border: #34c0be solid 2px;
    color: #34c0be;
  }

  .close-btn {
    position: relative;
    transform: scale(2);
    left: 230px;
    bottom: 20px;
    cursor: pointer;
  }
}

.success-img {
  position: relative;
  height: 24px;
  width: 24px;

  &.animated {
    animation-name: pulse;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: pulse;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}

.warn-img {
  position: relative;
  height: 24px;
  width: 24px;
}

.warning {
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;

  &.animated {
    animation-name: shake;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: shake;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}

.warning-text {
  font-size: $font-size-l1;
  font-weight: 600;
  margin-left: 12px;
  color: #6e6e6e;
}

.circle {
  position: relative;
  animation-name: showc;
  animation-duration: 2s;
  opacity: 0;
  left: 10px;
  height: 80px;
  width: 80px;
  -webkit-animation-name: showc;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.4s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}

.tick {
  position: absolute;
  bottom: 21px;
  left: 17px;
  width: 45px;
  height: 45px;
  opacity: 0;
  -webkit-animation-name: showt;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.7s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}

@keyframes showPopup {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }

  80% {
    transform: scale(1.1);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes showc {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }

  80% {
    transform: scale(1.1);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes showt {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }

  80% {
    transform: scale(1.1);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.img-msg-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  animation-delay: 0.4s;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
}

@keyframes fadeInRight {
  0% {
    padding-left: 25px;
    opacity: 0;
  }

  100% {
    padding-left: 0px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeInRight {
  0% {
    padding-left: 25px;
    opacity: 0;
  }

  100% {
    padding-left: 0px;
    opacity: 1;
  }
}

.popup-btns {
  margin-left: auto;

  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }
}

.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes pulse {
  0% {
    transform: scale3d(1, 1, 1);
  }

  5% {
    transform: scale3d(1.2, 1.2, 1.2);
  }

  10% {
    transform: scale3d(1, 1, 1);
  }

  100% {
    transform: scale3d(1, 1, 1);
  }
}

@-webkit-keyframes pulse {
  0% {
    transform: scale3d(1, 1, 1);
  }

  5% {
    transform: scale3d(1.2, 1.2, 1.2);
  }

  10% {
    transform: scale3d(1, 1, 1);
  }

  100% {
    transform: scale3d(1, 1, 1);
  }
}

@keyframes shake {
  1%,
  9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%,
  8% {
    transform: translate3d(2px, 0, 0);
  }

  3%,
  5%,
  7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%,
  6% {
    transform: translate3d(4px, 0, 0);
  }

  10% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes shake {
  1%,
  9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%,
  8% {
    transform: translate3d(2px, 0, 0);
  }

  3%,
  5%,
  7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%,
  6% {
    transform: translate3d(4px, 0, 0);
  }

  10% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

.top-bar {
  height: 64px;
  // width: 100%;
  width: 453px;
  transform: translate(-30px, -30px);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
}

.hraButton {
  display: flex;
  justify-content: center;
}

.heading_new {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
}

.badget-custom-popup-title {
  transform: translate(140px, -24px);
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

// ESS UI part CSS
.income-tax-summary-box {
  background-color: #ebebeb;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 1px 2px #f0f0f0;
}

.income-tax-text {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: #5a5a5a;
  margin-left: 8px;
  font-family: "Montserrat";
}

.col-10-new {
  -ms-flex: 0 0 83.33334%;
  -webkit-box-flex: 0;
  flex: 0 0 83.33334%;
  max-width: 83.33334%;
}

.back-btn-color-text {
  color: #40c6bf;
  font-weight: 600;
  text-align: center;
  margin: 12px 0px 0px;
  cursor: pointer;
}

.custom-col-3 {
  background: white;
  padding: 16px;
  margin: 5px;
  flex: 0 0 22%; // 24% change to 22%
  max-width: 22%; // 24% change to 22%
  border-radius: 8px;
}

.sm-text-it-summary {
  color: #8d8d8d;
  font-size: 1rem;
  font-weight: 500;
  font-family: "Montserrat";
}

.sm-sub-text-it-summary {
  font-weight: 600;
  margin-top: 8px;
  color: #5a5a5a;
  font-family: "Montserrat";
}

.sm-sub-text-right {
  font-family: "Montserrat";
  font-size: 0.8rem;
}

// .add-btn-sm {
//   margin-top: 5px;
// }

.change-btn-color-text {
  border: #34c0bd solid 1px;
  background: #34c0bd;
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
  min-width: 180px;
  min-height: 30px;
  text-align: center;
  padding: 10px;
  margin-top: 6px;
  cursor: pointer;
}

.change-status-btn-color-text {
  border: #c07c34 solid 1px;
  background: #fe7632ab;
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
  min-width: 180px;
  min-height: 20px;
  text-align: center;
  padding: 6px;
  margin-top: 6px;
  cursor: pointer;
}

.col-bg-gray {
  background: #ebebeb;
  padding: 15px;
  border-radius: 8px;
}

.img-block {
  margin-top: 6px;
  height:90px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  overflow: hidden;
  white-space: normal;
  margin: 0;
  padding: 0;
}

.heading-text {
  font-size: 1.125rem;
  font-weight: bold;
  color: #40c6bf;
  margin-bottom: 9px;
  font-family: "Montserrat";
}

.sub-heading-details-sm {
  color: #8d8d8d;
  line-height: 1.5rem;
  font-weight: 500;
  font-size: 1.1rem;
  font-family: "Montserrat";
}

.total-amount-text {
  font-weight: bold;
  font-size: 1rem;
  margin-top: 14px;
  color: #5a5a5a;
  font-family: "Montserrat";
}

.arrow-icon-it {
  position: relative;
  top: calc(50% - 10px);
}

.arrow-left-align {
  text-align: end;
  cursor: pointer;
}

.cursor-point {
  cursor: pointer;
  width: 48.5%;
  gap: 20px;
}

.export-button {
  background-color: rgba(14, 165, 235, 0.5);
  color: black;
  width: 12rem;
  height: 2rem;
  display: flex;
  position: relative;
  gap: 10px;

  img {
    height: 1rem;
    width: 1rem;
  }
}
.export-button1 {
  
  color: black;
  width: 2rem;
  height: 2rem;
  display: flex;
  position: relative;
  gap: 10px;

  img {
    height: 2rem;
    width: 3rem;
  }
}
// .export-button > input {
//   visibility: hidden;
//   width: 0;
// }
.input-label {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  width: -webkit-fill-available !important;
  justify-content: center;
  font-size: 12px;
  color: #000000;
  margin: 0px;
}

.input-label1 {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  width: -webkit-fill-available !important;

  font-size: 12px;
  color: #000000;
  margin: 0px;
}

input[type="file"] {
  position: absolute;

  z-index: -1;
  top: 15px;
  left: 20px;
  font-size: 1px;
  color: #b8b8b8;
}

.model {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;

  span {
    color: #f3f3f3;
    font-size: xx-large;
  }
}

.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3b2867;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

span {
  font-weight: 500;
}

.hover-on-text {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  color: #34c0bd;
}
.BBmain {
  display: flex;
  flex-direction: column;
  height:100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size:large;
  border-bottom: solid 1px grey;

}

.BBbottom {
  height:100%;
  width: 100%;
  border-top: solid 1px grey;
}
.BBcenter{
  border-top: solid 1px grey;
  width:100%;
  background-color: #f5f3f3;
  text-align:center;
}
.borderRed{
  border:solid 1px red;
}
.borderLess{
  width:14rem
}
.upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
      to right,
      rgb(147, 146, 146) 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient(rgb(147, 145, 145) 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(
      to right,
      rgb(146, 143, 143) 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient(rgb(146, 146, 146) 10px, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  height: 70%;
  width: 100%;
  p {
    font-size: large;
  }
}
.uploadMethoRadio {
  display: flex;
  margin-top:5%;
  margin-bottom: 2%;
}
.essStatus {
    margin: 30px 0px;
    .label-text {
      font-size: 12px;
      font-weight: 500 !important;
      color: #8d8d8d !important;
      height: 15px !important;
    }
  }
.upload-button {
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    border: 3px solid #5d409f;
    border-radius: 4px;
    padding: 10px 45px;
    font-size: 15px;
    font-weight: 600;
    color: #5d409f;
    margin-top:-10px ;
  }
  #upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1
  }
  img {
    height: 19px;
    width: 19px;
    margin-right: 8px;
  }
}
</style>
